/* LISTING — scan -> lecture rapide -> analyse complète */
/* Top pronostics IA - basé sur best_bets.js (mêmes datas / endpoints),
   mais wording SEO + filtre "matchs passés" pour l'affichage utilisateur. */

document.addEventListener("DOMContentLoaded", () => {
  const path = window.location?.pathname || "";
  const lang = path.startsWith("/en/") ? "en" : path.startsWith("/es/") ? "es" : "fr";
  const selectionRules = window.FSPicksSelection;
  const selectionCopy = selectionRules.text(lang);
  const fixtureStatus = window.fsFixtureStatus;
  const topPerfDebugEnabled = new URLSearchParams(window.location.search).get("tp_perf") === "1";
  const topPerfMarks = new Set();

  function markTopPerf(name, detail = null) {
    if (!name || topPerfMarks.has(name)) return;
    topPerfMarks.add(name);
    try {
      performance.mark(name, detail == null ? undefined : { detail });
    } catch (_) {
      performance.mark(name);
    }
    if (topPerfDebugEnabled) {
      console.debug(`[top-pronostics perf] ${name}`, Math.round(performance.now()), detail || "");
      let output = document.getElementById("tp-perf-debug");
      if (!output && document.body) {
        output = document.createElement("output");
        output.id = "tp-perf-debug";
        output.hidden = true;
        document.body.appendChild(output);
      }
      if (output) {
        const snapshot = JSON.stringify(Array.from(topPerfMarks).map((markName) => {
          const entry = performance.getEntriesByName(markName, "mark")[0];
          return { name: markName, ms: Math.round(entry?.startTime || 0), detail: entry?.detail || null };
        }));
        output.textContent = snapshot;
        output.dataset.marks = snapshot;
      }
    }
  }

  markTopPerf("top_boot_start");
  window.FSTopPronosticsPerf = {
    getMarks: () => Array.from(topPerfMarks).map((name) => {
      const entry = performance.getEntriesByName(name, "mark")[0];
      return { name, startTime: entry?.startTime ?? null, detail: entry?.detail ?? null };
    })
  };
  const followActionEnabled = document.body?.dataset?.topPredictionsFollow === "1";
  const chkHideFinishedDay = document.getElementById("chk-hide-finished-day");

  const TEXT = {
    fr: {
      filters_show: "Afficher les filtres",
      filters_hide: "Masquer les filtres",
      filters_state_closed: "Masqués pour garder une lecture simple.",
      filters_state_open: "Ouverts pour personnaliser la liste.",
      mode_hint_all: "Mode tous les matchs actif : tous les seuils sont forcés à 33%.",
      mode_hint_performance: "Mode performance actif : seuils conseillés dynamiques, toutes les ligues restent couvertes.",
      mode_hint_high: (leagueCount) => `Mode haute performance actif : ligues puis seuils, ${leagueCount} ligues retenues.`,
      mode_hint_high_fallback: "Mode haute performance actif : seuils renforcés appliqués, historique insuffisant pour filtrer les ligues.",
      mode_hint_ultra: (leagueCount) => `Mode ultra haute performance actif : seuils puis ligues, ${leagueCount} ligues conservées.`,
      mode_hint_ultra_fallback: "Mode ultra haute performance actif : seuils renforcés appliqués, historique insuffisant pour filtrer les ligues.",

      mode_menu_group_base: "Modes de base",
      mode_menu_group_profiles: "Profils Top Pronostics",
      mode_menu_manage: "Créer / gérer",
      mode_menu_profiles_empty: "Aucun profil multi-marchés compatible. Les profils 1X2 simples restent disponibles sur leurs pages dédiées.",
      mode_menu_current_label: "Mode actif",
      mode_profile_desc_fallback: "Filtres personnalisés sauvegardés.",
      mode_profile_hint: (name) => `Profil ${name} actif : filtres personnalisés appliqués.`,
      bridge_title: "Top pronostics IA du jour",
      bridge_text: "La lecture reste volontairement simple ici. Crée tes modes et tes filtres sur la page profil, puis retrouve-les dans le menu déroulant.",
      bridge_button: "Ouvrir profil pronostics",
      mode_relax_title: "Mode élargi",
      mode_relax_message: "Aucun pronostic disponible dans le mode sélectionné. Affichage élargi au meilleur mode disponible aujourd'hui.",
      trend_empty: "Pas encore de données à afficher sur les 7 derniers jours chargés.",
      trend_volume: "Volume",
      trend_day_sample: (total, voids) => `${total} réglés${voids ? ` · ${voids} remb.` : ""}`,
      trend_day_pending: (pending) => `${pending} à venir`,

      mode_hint_frozen_suffix: "Calibrage figé sur les matchs clôturés jusqu'à la veille.",
      mode_hint_live_suffix: "Optimisation live activée : les résultats du jour peuvent encore faire bouger les picks.",
      optimize_today_hint_frozen: "Par défaut, Performance / Haute performance / Ultra se calibrent sur les matchs clôturés jusqu'à la veille.",
      optimize_today_hint_live: "Mode live actif : les résultats du jour peuvent modifier les seuils et les ligues retenues.",

      perf_label_wait: "Performance :",
      perf_wait: "en attente de résultats",
      perf_label_window: "Performance observée :",
      perf_voids: "issues remboursées (DNB)",
      perf_kpi_title: "Performance observée",
      perf_kpi_subtitle: "Fenêtre historique récente",
      perf_kpi_rate: "Taux de réussite",
      perf_kpi_rate_meta: (total) => `${total} sélections réglées`,
      perf_kpi_record: "Picks validés",
      perf_kpi_record_meta: (wins, total) => `${wins} validés sur ${total}`,
      perf_kpi_wait_hint: "Les résultats apparaîtront ici dès que les premiers matchs seront terminés.",
      perf_kpi_voids_inline: (voids) => `${voids} remboursée${voids > 1 ? "s" : ""} non comptée${voids > 1 ? "s" : ""} dans le taux.`,

      date_match_count: "matchs",
      date_today: "AUJOURD'HUI",
      error_loading: "Erreur de chargement.",
      loading_title: "Chargement des analyses",
      loading_confidence: "Chargement des performances historiques...",
      loading_init: "Chargement des données...",
      loading_fetch_bulk: "Chargement des matchs...",
      loading_fetch_progress: "Chargement des matchs : {count}/{total}...",
      loading_render: "Préparation de l'affichage...",

      no_bet_title: "Aucune sélection ne franchit les seuils actuels.",
      no_bet_hint: "Astuce : baisse un peu les seuils, augmente le Top, ou coche plus de ligues.",

      top_scores_label: "Top scores : ",
      top_scores_none: "-",
      elo_home: "ELO",
      elo_away: "ELO",
      rank_home: "Classement",
      rank_away: "Classement",
      rank_empty: "Données indisponibles",
      home_side: "Domicile",
      away_side: "Extérieur",
      form_label: "Forme",
      form_empty: "Données indisponibles",
      form_scale_hint: "Indice de forme normalisé de -1 (très faible) à +1 (excellent).",
      form_bands: {
        veryGood: "Très bonne",
        good: "Bonne",
        neutral: "Neutre",
        poor: "Faible",
        veryPoor: "Très faible",
      },

      outcome_win: "✅ Validé",
      outcome_lose: "❌ Non validé",
      outcome_void: "↔️ Remboursé",
      outcome_pending: "⏳ À venir",
      prob_label: "Proba",
      confidence_label: "Fiabilité IA",

      perf_type_empty:
        "Pas encore assez de matchs terminés pour afficher des stats par type.",
      perf_type_empty_suggestions:
        "Pas encore assez d’historique pour proposer des seuils conseillés par type.",
      perf_type_best: "Meilleur signal",
      perf_type_volume_short: "réglés",
      perf_type_voids_short: "remb.",
      perf_type_recommended: "Seuil conseillé",
      perf_type_recommended_chip: (thr, rate, volume) => `${thr}%+ conseillé · ${rate.toFixed(1)}% sur ${volume} cas`,
      perf_type_suggestion_lead: "Seuils conseillés pour démarrer",
      perf_type_no_data: "Pas assez de données",
      threshold_rate_unavailable: " · Non calculé",
      perf_type_no_data_hint: "Ce type s'affichera ici dès qu'assez de matchs seront terminés.",
      day_rate: (rate, total) => `Taux: ${rate.toFixed(1)}% sur ${total} sélections terminées`,
      day_waiting: (voidTxt, pendingTxt, all) =>
        `En attente de résultats${voidTxt}${pendingTxt} · ${all} sélections après filtres (journée).`,
      day_pending_label: "en attente",
      day_upcoming_hint: "Sélections non terminées (score non final).",
      filters_default: "Filtres : valeurs par défaut",

      suggestion_sentence: (label, thr, rate, volume) =>
        `${label} : seuil conseillé ≈ ${thr}% (taux observé ${rate.toFixed(1)}% sur ${volume} cas).`,
      advanced_summary_closed: "Optionnel. Garde les seuils conseillés si tout te convient.",
      advanced_summary_open: "Ouvert. Ajuste un type sans toucher aux autres.",
      advanced_custom_count: (count) => `${count} type${count > 1 ? "s" : ""} ajusté${count > 1 ? "s" : ""} manuellement.`,

      // Labels
      label_dc1x: (home) => `Double chance 1X - ${home} ou N`,
      label_dcx2: (away) => `Double chance X2 - ${away} ou N`,
      label_dnb_home: (home) => `DNB (${home})`,
      label_dnb_away: (away) => `DNB (${away})`,
      label_1x2: (k, team) => `1X2 - ${k} (${team})`,
      label_u25: "Under 2.5",
      label_o25: "Over 2.5",
      label_o15: "Over 1.5",
      label_u35: "Under 3.5",
      label_btts: "BTTS",

      perf_type_labels: {
        DC: "Double chance (1X, X2)",
        DNB: "DNB",
        "1X2": "1X2 (issue la plus probable)",
        U25: "Under 2,5",
        O25: "Over 2,5",
        O15: "Over 1,5",
        U35: "Under 3,5",
        BTTS: "BTTS (Both Teams To Score)",
      },

      type_volume_voids: (wins, total, voids) => `${wins}/${total} (voids: ${voids})`,
      expert_mode_label: "Mode expert",
      compact_mode_label: "Vue condensée",
      details_button: "Détails",
      details_show: "Voir les détails",
      details_hide: "Masquer les détails",
      compact_show: "Voir le match en détail",
      compact_hide: "Masquer le détail du match",
      compact_pick_count: (count) => `${count} pick${count > 1 ? "s" : ""}`,
      compact_result_win: "OK",
      compact_result_lose: "KO",
      compact_result_void: "Remb.",
      compact_result_pending: "À venir",
      reading_force: "Rapport de force",
      reading_stability: "Stabilité",
      details_block_proba: "Probas 1/X/2",
      details_block_reliability: "Fiabilité",
      details_block_context: "Contexte",
      details_block_volumes: "Volumes matchs comparables",
      details_hist_volume: "Volume historique",
      details_margin: "Écart favori - 2e issue",
      details_pdraw: "Proba nul (X)",
      details_conf_hist: "Confiance historique",
      details_conf_ml: "Confiance IA",
      details_conf_final: "Confiance finale",
      details_conf_observed: "Confiance observée",
      details_hist_sample: "Volume historique",
      details_elo_diff: "ELO diff",
      details_league: "Ligue",
      details_kickoff: "Date/heure",
      details_form_block: "Forme & séries",
      details_goals_block: "Profil buts",
      details_streak_win: "Série de victoires",
      details_streak_unbeaten: "Série invaincue",
      details_streak_loss: "Série de défaites",
      details_last_results: "8 derniers",
      details_recent_ppm: "Pts/match récents",
      details_goals_for_avg: "BM/m",
      details_goals_against_avg: "BE/m",
      details_goals_total_avg: "Total/m",
      details_matches_played: "MJ",
      details_na: "Données indisponibles",
    },

    en: {
      filters_show: "Show filters",
      filters_hide: "Hide filters",
      filters_state_closed: "Hidden to keep the view simple.",
      filters_state_open: "Open to customize the list.",
      mode_hint_all: "All-matches mode active: all thresholds are forced to 33%.",
      mode_hint_performance: "Performance mode active: dynamic recommended thresholds, all leagues stay enabled.",
      mode_hint_high: (leagueCount) => `High-performance mode active: leagues then thresholds, ${leagueCount} leagues selected.`,
      mode_hint_high_fallback: "High-performance mode active: stricter thresholds applied, not enough settled history to filter leagues.",
      mode_hint_ultra: (leagueCount) => `Ultra high-performance mode active: thresholds then leagues, ${leagueCount} leagues kept.`,
      mode_hint_ultra_fallback: "Ultra high-performance mode active: stricter thresholds applied, not enough settled history to filter leagues.",

      mode_menu_group_base: "Base modes",
      mode_menu_group_profiles: "Top Predictions profiles",
      mode_menu_manage: "Create / manage",
      mode_menu_profiles_empty: "No compatible multi-market profile. Simple 1X2 profiles remain available on their dedicated pages.",
      mode_menu_current_label: "Active mode",
      mode_profile_desc_fallback: "Saved custom filters.",
      mode_profile_hint: (name) => `${name} profile active: custom filters applied.`,
      bridge_title: "Top AI picks for today",
      bridge_text: "This page stays intentionally easy to read. Build your own modes and filters on the profile page, then reuse them from the dropdown menu.",
      bridge_button: "Open prediction profile",
      mode_relax_title: "Expanded mode",
      mode_relax_message: "No pick is available in the selected mode. Showing the best available wider mode today.",
      trend_empty: "No data to show yet over the last 7 loaded days.",
      trend_volume: "Sample",
      trend_day_sample: (total, voids) => `${total} settled${voids ? ` · ${voids} void` : ""}`,
      trend_day_pending: (pending) => `${pending} upcoming`,

      mode_hint_frozen_suffix: "Calibration frozen on settled matches up to yesterday.",
      mode_hint_live_suffix: "Live optimization enabled: today's results may still change the picks.",
      optimize_today_hint_frozen: "By default, Performance / High performance / Ultra use settled history up to yesterday.",
      optimize_today_hint_live: "Live mode enabled: today's results may change thresholds and selected leagues.",

      perf_label_wait: "Performance:",
      perf_wait: "waiting for results",
      perf_label_window: "Observed performance:",
      perf_voids: "void cases (DNB)",
      perf_kpi_title: "Observed performance",
      perf_kpi_subtitle: "Recent historical window",
      perf_kpi_rate: "Hit rate",
      perf_kpi_rate_meta: (total) => `${total} settled selections`,
      perf_kpi_record: "Winning picks",
      perf_kpi_record_meta: (wins, total) => `${wins} wins out of ${total}`,
      perf_kpi_wait_hint: "Results will appear here once the first matches settle.",
      perf_kpi_voids_inline: (voids) => `${voids} void case${voids > 1 ? "s" : ""} excluded from the rate.`,

      date_match_count: "matches",
      date_today: "TODAY",
      error_loading: "Error while loading.",
      loading_title: "Loading analysis",
      loading_confidence: "Loading historical performance...",
      loading_init: "Loading data...",
      loading_fetch_bulk: "Loading matches...",
      loading_fetch_progress: "Loading matches: {count}/{total}...",
      loading_render: "Preparing display...",

      no_bet_title: "No selection passes current thresholds.",
      no_bet_hint: "Tip: lower thresholds, increase Top, or select more leagues.",

      top_scores_label: "Top scores: ",
      top_scores_none: "-",
      elo_home: "Home ELO",
      elo_away: "Away ELO",
      rank_home: "Home rank",
      rank_away: "Away rank",
      rank_empty: "Unavailable",
      home_side: "Home",
      away_side: "Away",
      form_label: "Form",
      form_empty: "Unavailable",
      form_scale_hint: "Normalized form index from -1 (very poor) to +1 (excellent).",
      form_bands: {
        veryGood: "Very good",
        good: "Good",
        neutral: "Neutral",
        poor: "Poor",
        veryPoor: "Very poor",
      },

      outcome_win: "✅ Validated",
      outcome_lose: "❌ Not validated",
      outcome_void: "↔️ Void / refunded",
      outcome_pending: "⏳ Upcoming",
      prob_label: "Prob",
      confidence_label: "AI reliability",

      perf_type_empty: "Not enough finished matches to show type stats yet.",
      perf_type_empty_suggestions:
        "Not enough settled history to suggest thresholds per type yet.",
      perf_type_best: "Best signal",
      perf_type_volume_short: "settled",
      perf_type_voids_short: "void",
      perf_type_recommended: "Suggested threshold",
      perf_type_recommended_chip: (thr, rate, volume) => `Suggested ${thr}%+ · ${rate.toFixed(1)}% over ${volume}`,
      perf_type_suggestion_lead: "Suggested thresholds to start fast",
      perf_type_no_data: "Not enough data",
      threshold_rate_unavailable: " · Not calculated",
      perf_type_no_data_hint: "This type will show up here once enough matches settle.",
      day_rate: (rate, total) => `Rate: ${rate.toFixed(1)}% over ${total} settled selections`,
      day_waiting: (voidTxt, pendingTxt, all) =>
        `Waiting for results${voidTxt}${pendingTxt} · ${all} selections after filters (day).`,
      day_pending_label: "pending",
      day_upcoming_hint: "Unsettled selections (no final score).",
      filters_default: "Filters: (default values)",

      suggestion_sentence: (label, thr, rate, volume) =>
        `${label}: suggested threshold ≈ ${thr}% (observed hit rate ${rate.toFixed(1)}% over ${volume} cases).`,
      advanced_summary_closed: "Optional. Keep the suggested thresholds if everything looks fine.",
      advanced_summary_open: "Open. Adjust one type without touching the others.",
      advanced_custom_count: (count) => `${count} type${count > 1 ? "s" : ""} manually adjusted.`,

      label_dc1x: (home) => `Double Chance 1X - ${home} or Draw`,
      label_dcx2: (away) => `Double Chance X2 - ${away} or Draw`,
      label_dnb_home: (home) => `DNB (home) - ${home}`,
      label_dnb_away: (away) => `DNB (away) - ${away}`,
      label_1x2: (k, team) => `1X2 - ${k} (${team})`,
      label_u25: "Under 2.5 goals",
      label_o25: "Over 2.5 goals",
      label_o15: "Over 1.5 goals",
      label_u35: "Under 3.5 goals",
      label_btts: "BTTS - Both Teams To Score",

      perf_type_labels: {
        DC: "Double Chance (1X, X2)",
        DNB: "DNB",
        "1X2": "1X2 (most likely outcome)",
        U25: "Under 2.5 goals",
        O25: "Over 2.5 goals",
        O15: "Over 1.5 goals",
        U35: "Under 3.5 goals",
        BTTS: "BTTS (Both Teams To Score)",
      },

      type_volume_voids: (wins, total, voids) => `${wins}/${total} (void: ${voids})`,
      expert_mode_label: "Expert mode",
      compact_mode_label: "Compact view",
      details_button: "Details",
      details_show: "Show details",
      details_hide: "Hide details",
      compact_show: "Show match details",
      compact_hide: "Hide match details",
      compact_pick_count: (count) => `${count} pick${count > 1 ? "s" : ""}`,
      compact_result_win: "OK",
      compact_result_lose: "Miss",
      compact_result_void: "Void",
      compact_result_pending: "Upcoming",
      reading_force: "Balance of power",
      reading_stability: "Stability",
      details_block_proba: "1/X/2 probabilities",
      details_block_reliability: "Reliability",
      details_block_context: "Context",
      details_block_volumes: "Historical comparable matches",
      details_hist_volume: "Historical volume",
      details_margin: "Gap favorite - 2nd outcome",
      details_pdraw: "Draw probability (X)",
      details_conf_hist: "Historical confidence",
      details_conf_ml: "ML confidence",
      details_conf_final: "Final confidence",
      details_conf_observed: "Observed confidence",
      details_hist_sample: "Historical sample",
      details_elo_diff: "ELO diff",
      details_league: "League",
      details_kickoff: "Kickoff",
      details_form_block: "Form & streaks",
      details_goals_block: "Goals profile",
      details_streak_win: "Win streak",
      details_streak_unbeaten: "Unbeaten streak",
      details_streak_loss: "Loss streak",
      details_last_results: "Last 8",
      details_recent_ppm: "Recent pts/match",
      details_goals_for_avg: "GF/m",
      details_goals_against_avg: "GA/m",
      details_goals_total_avg: "Total/m",
      details_matches_played: "MP",
      details_na: "Unavailable",
    },
  };

  TEXT.es = {
    ...TEXT.en,
    filters_show: "Mostrar filtros",
    filters_hide: "Ocultar filtros",
    filters_state_closed: "Ocultos para mantener una lectura simple.",
    filters_state_open: "Abiertos para personalizar la lista.",
    mode_hint_all: "Modo todos los partidos activo: todos los umbrales se fuerzan al 33%.",
    mode_hint_performance: "Modo performance activo: umbrales recomendados dinámicos, todas las ligas siguen activas.",
    mode_hint_high: (leagueCount) => `Modo alta performance activo: ligas y umbrales, ${leagueCount} ligas seleccionadas.`,
    mode_hint_high_fallback: "Modo alta performance activo: umbrales más estrictos aplicados, historial insuficiente para filtrar ligas.",
    mode_hint_ultra: (leagueCount) => `Modo ultra activo: umbrales y ligas, ${leagueCount} ligas conservadas.`,
    mode_hint_ultra_fallback: "Modo ultra activo: umbrales más estrictos aplicados, historial insuficiente para filtrar ligas.",
    mode_menu_group_base: "Modos base",
    mode_menu_group_profiles: "Perfiles de Top Pronósticos",
    mode_menu_manage: "Crear / gestionar",
    mode_menu_profiles_empty: "No hay perfiles multimercado compatibles. Los perfiles 1X2 simples siguen disponibles en sus páginas específicas.",
    mode_menu_current_label: "Modo activo",
    mode_profile_desc_fallback: "Filtros personalizados guardados.",
    mode_profile_hint: (name) => `Perfil ${name} activo: filtros personalizados aplicados.`,
    bridge_title: "Top pronósticos IA del día",
    bridge_text: "Esta página mantiene una lectura simple. Crea tus modos y filtros en la página de perfil y reutilízalos desde el menú.",
    bridge_button: "Abrir perfil de pronósticos",
    mode_relax_title: "Modo ampliado",
    mode_relax_message: "No hay pronósticos disponibles en el modo seleccionado. Mostramos el mejor modo ampliado disponible hoy.",
    trend_empty: "Aún no hay datos para mostrar en los últimos 7 días cargados.",
    trend_volume: "Muestra",
    trend_day_sample: (total, voids) => `${total} cerrados${voids ? ` · ${voids} anulados` : ""}`,
    trend_day_pending: (pending) => `${pending} pendientes`,
    mode_hint_frozen_suffix: "Calibración fijada con partidos cerrados hasta ayer.",
    mode_hint_live_suffix: "Optimización live activa: los resultados de hoy aún pueden mover los picks.",
    optimize_today_hint_frozen: "Por defecto, Performance / Alta performance / Ultra usan historial cerrado hasta ayer.",
    optimize_today_hint_live: "Modo live activo: los resultados de hoy pueden cambiar umbrales y ligas seleccionadas.",
    perf_label_wait: "Performance:",
    perf_wait: "en espera de resultados",
    perf_label_window: "Performance observada:",
    perf_voids: "casos anulados (DNB)",
    perf_kpi_title: "Performance observada",
    perf_kpi_subtitle: "Ventana histórica reciente",
    perf_kpi_rate: "Tasa de acierto",
    perf_kpi_rate_meta: (total) => `${total} selecciones cerradas`,
    perf_kpi_record: "Picks acertados",
    perf_kpi_record_meta: (wins, total) => `${wins} aciertos de ${total}`,
    perf_kpi_wait_hint: "Los resultados aparecerán aquí cuando terminen los primeros partidos.",
    perf_kpi_voids_inline: (voids) => `${voids} caso${voids > 1 ? "s" : ""} anulado${voids > 1 ? "s" : ""} excluido${voids > 1 ? "s" : ""} de la tasa.`,
    date_match_count: "partidos",
    date_today: "HOY",
    error_loading: "Error de carga.",
    loading_title: "Cargando análisis",
    loading_confidence: "Cargando rendimiento histórico...",
    loading_init: "Cargando datos...",
    loading_fetch_bulk: "Cargando partidos...",
    loading_fetch_progress: "Cargando partidos: {count}/{total}...",
    loading_render: "Preparando visualización...",
    no_bet_title: "Ninguna selección supera los umbrales actuales.",
    no_bet_hint: "Consejo: baja los umbrales, aumenta el Top o selecciona más ligas.",
    top_scores_label: "Top marcadores: ",
    rank_home: "Ranking local",
    rank_away: "Ranking visitante",
    rank_empty: "No disponible",
    home_side: "Local",
    away_side: "Visitante",
    form_label: "Forma",
    form_empty: "No disponible",
    form_scale_hint: "Índice de forma normalizado de -1 (muy bajo) a +1 (excelente).",
    form_bands: {
      veryGood: "Muy buena",
      good: "Buena",
      neutral: "Neutra",
      poor: "Baja",
      veryPoor: "Muy baja",
    },
    outcome_win: "✅ Acertado",
    outcome_lose: "❌ No acertado",
    outcome_void: "↔️ Anulado",
    outcome_pending: "⏳ Pendiente",
    prob_label: "Prob.",
    confidence_label: "Fiabilidad IA",
    perf_type_empty: "Aún no hay suficientes partidos finalizados para mostrar estadísticas por tipo.",
    perf_type_empty_suggestions: "Aún no hay suficiente historial cerrado para sugerir umbrales por tipo.",
    perf_type_best: "Mejor señal",
    perf_type_volume_short: "cerrados",
    perf_type_voids_short: "anul.",
    perf_type_recommended: "Umbral recomendado",
    perf_type_recommended_chip: (thr, rate, volume) => `${thr}%+ recomendado · ${rate.toFixed(1)}% en ${volume} casos`,
    perf_type_suggestion_lead: "Umbrales recomendados para empezar",
    perf_type_no_data: "No hay suficientes datos",
    threshold_rate_unavailable: " · No calculado",
    perf_type_no_data_hint: "Este tipo aparecerá aquí cuando terminen suficientes partidos.",
    day_rate: (rate, total) => `Tasa: ${rate.toFixed(1)}% en ${total} selecciones cerradas`,
    day_waiting: (voidTxt, pendingTxt, all) => `En espera de resultados${voidTxt}${pendingTxt} · ${all} selecciones tras filtros (día).`,
    day_pending_label: "pendientes",
    day_upcoming_hint: "Selecciones no finalizadas (sin marcador final).",
    filters_default: "Filtros: valores por defecto",
    suggestion_sentence: (label, thr, rate, volume) => `${label}: umbral recomendado ≈ ${thr}% (tasa observada ${rate.toFixed(1)}% en ${volume} casos).`,
    advanced_summary_closed: "Opcional. Mantén los umbrales recomendados si todo te conviene.",
    advanced_summary_open: "Abierto. Ajusta un tipo sin tocar los demás.",
    advanced_custom_count: (count) => `${count} tipo${count > 1 ? "s" : ""} ajustado${count > 1 ? "s" : ""} manualmente.`,
    label_dc1x: (home) => `Doble oportunidad 1X - ${home} o empate`,
    label_dcx2: (away) => `Doble oportunidad X2 - ${away} o empate`,
    label_dnb_home: (home) => `DNB local - ${home}`,
    label_dnb_away: (away) => `DNB visitante - ${away}`,
    label_1x2: (k, team) => `1X2 - ${k} (${team})`,
    label_u25: "Menos de 2.5 goles",
    label_o25: "Más de 2.5 goles",
    label_o15: "Más de 1.5 goles",
    label_u35: "Menos de 3.5 goles",
    label_btts: "BTTS - ambos equipos marcan",
    perf_type_labels: {
      DC: "Doble oportunidad (1X, X2)",
      DNB: "DNB",
      "1X2": "1X2 (resultado más probable)",
      U25: "Menos de 2.5 goles",
      O25: "Más de 2.5 goles",
      O15: "Más de 1.5 goles",
      U35: "Menos de 3.5 goles",
      BTTS: "BTTS (ambos equipos marcan)",
    },
    type_volume_voids: (wins, total, voids) => `${wins}/${total} (anulados: ${voids})`,
    expert_mode_label: "Modo experto",
    compact_mode_label: "Vista compacta",
    details_button: "Detalles",
    details_show: "Mostrar detalles",
    details_hide: "Ocultar detalles",
    compact_show: "Ver detalle del partido",
    compact_hide: "Ocultar detalle del partido",
    compact_pick_count: (count) => `${count} pick${count > 1 ? "s" : ""}`,
    compact_result_lose: "Fallo",
    compact_result_void: "Anulado",
    compact_result_pending: "Pendiente",
    reading_force: "Relación de fuerzas",
    reading_stability: "Estabilidad",
    details_block_proba: "Probabilidades 1/X/2",
    details_block_reliability: "Fiabilidad",
    details_block_context: "Contexto",
    details_block_volumes: "Partidos comparables históricos",
    details_hist_volume: "Volumen histórico",
    details_margin: "Margen favorito - 2a opción",
    details_pdraw: "Probabilidad de empate (X)",
    details_conf_hist: "Confianza histórica",
    details_conf_ml: "Confianza IA",
    details_conf_final: "Confianza final",
    details_conf_observed: "Confianza observada",
    details_hist_sample: "Muestra histórica",
    details_elo_diff: "Diferencia ELO",
    details_league: "Liga",
    details_kickoff: "Inicio",
    details_form_block: "Forma y rachas",
    details_goals_block: "Perfil de goles",
    details_streak_win: "Racha de victorias",
    details_streak_unbeaten: "Racha invicta",
    details_streak_loss: "Racha de derrotas",
    details_last_results: "Últimos 8",
    details_recent_ppm: "Puntos/partido recientes",
    details_goals_for_avg: "GF/p",
    details_goals_against_avg: "GC/p",
    details_goals_total_avg: "Total/p",
    details_matches_played: "PJ",
    details_na: "No disponible",
  };

  const t = TEXT[lang] || TEXT.fr;

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  let teamLinksPromise = null;

  function ensureTeamLinksLoaded() {
    if (teamLinksPromise) return teamLinksPromise;
    teamLinksPromise = typeof window.fsTeamLinks?.loadTeamIndex === "function"
      ? window.fsTeamLinks.loadTeamIndex().catch(() => null)
      : Promise.resolve(null);
    return teamLinksPromise;
  }

  // Libellé d'affichage des sélections nationales (FR + INT_FRIENDLIES).
  // DISPLAY ONLY : jamais utilisé pour les noms bruts (logos, liens, clés).
  // Source unique : js/national_team_labels.js. Fallback sûr -> nom brut.
  function localizeTeamLabel(name, leagueCode) {
    const api = window.fsNationalTeamLabels;
    return api ? api.localize(name, leagueCode, lang) : name;
  }

  function renderLinkedTeamName(teamName, leagueCode, options = {}) {
    const className = String(options.className || "tp-team-name").trim();
    // Libellé localisé pour l'affichage ; teamName brut conservé pour le lien.
    const safeTeamName = escapeHtml(localizeTeamLabel(teamName, leagueCode));
    const href = typeof window.fsTeamLinks?.getTeamLinkByName === "function"
      ? window.fsTeamLinks.getTeamLinkByName(teamName, leagueCode)
      : null;

    const linkHook = `data-tp-team-link data-team-name="${escapeHtml(teamName)}" data-league="${escapeHtml(leagueCode)}"`;
    if (!href) {
      return `<span ${linkHook} class="${className}" title="${safeTeamName}">${safeTeamName}</span>`;
    }

    return `<a ${linkHook} href="${escapeHtml(href)}" class="${className} tp-team-name-link" title="${safeTeamName}">${safeTeamName}</a>`;
  }

  // Endpoints identiques
  const API_LEAGUE_MARKETS = "/api/proxy_league_markets.php";
  const API_LEAGUE_MARKETS_BULK = "/api/league_markets_bulk_top_pronostics_v1.php";
  const API_PICKS_PERF = "/api/picks_perf_by_threshold.php?slim=1&view=top_pronostics_v1";
  const SUPPORTED_TOP_PERFORMANCE_INDEX_VERSIONS = new Set([
    "top_pronostics_perf_v1",
    "top_pronostics_perf_v2",
  ]);
  const API_TEAM_FORM = "/api/team_form.php";
  const API_TEAM_FORM_BULK = "/api/team_form_bulk.php";
  const ENTROPY_MAX_NATS = Math.log(3);
  const ENTROPY_MAX_BITS = ENTROPY_MAX_NATS / Math.LN2;
  const CONTEXT_WATCH_FIELDS = Object.freeze([
    "league_stakes_supported",
    "stakes_support_type",
    "stakes_phase_sensitive",
    "stakes_relegation_applicable",
    "stakes_title_applicable",
    "stakes_playoff_applicable",
    "stakes_context_reliable",
    "stakes_context_source",
    "stakes_context_reason",
    "competition_context",
    "competition_phase",
    "competition_format",
    "competition_leg",
    "competition_is_decisive",
    "competition_context_reliable",
    "competition_context_source",
    "is_group_stage",
    "is_knockout",
    "is_playoff",
    "is_final",
    "is_first_leg",
    "is_second_leg",
    "is_two_legged_tie",
    "seasonal_favorite_trap_flag",
    "seasonal_favorite_trap_v2_flag",
    "seasonal_favorite_trap_v2_reason",
    "late_season_context_level",
    "late_season_flag",
    "draw_sensitive_flag",
    "draw_sensitive_reason",
    "draw_risk_level",
    "draw_risk_high_flag",
    "draw_pressure",
    "draw_gap",
    "away_favorite_end_season_trap_flag",
    "away_favorite_end_season_trap_reason",
    "home_title_already_decided_flag",
    "away_title_already_decided_flag",
    "home_relegation_pressure_flag",
    "away_relegation_pressure_flag",
    "home_already_relegated_flag",
    "away_already_relegated_flag",
    "home_no_clear_stakes_flag",
    "away_no_clear_stakes_flag",
    "motivation_asymmetry_flag",
    "motivation_asymmetry_side",
    "motivation_asymmetry_reason",
    "picked_team_active_streak_flag",
    "picked_team_long_streak_flag",
    "picked_team_streak_regression_risk_flag",
    "derby_flag",
    "derby_id",
    "derby_type",
    "derby_tier",
    "derby_display_level",
    "derby_label_fr",
    "derby_label_en",
    "derby_context_reason",
    "derby_context_reliable",
    "context_flag",
    "context_flag_type",
    "context_flag_reason",
    "context_flag_severity",
    "context_flag_team",
    "context_flag_teams",
    "context_flag_label_fr",
    "context_flag_label_en",
    "context_flag_label_es",
    "context_flag_short_fr",
    "context_flag_short_en",
    "context_flag_short_es",
    "context_flag_text_fr",
    "context_flag_text_en",
    "context_flag_text_es"
  ]);

  // DOM
  const elButtons = document.querySelector(".league-buttons");
  const elGrid = document.getElementById("bb-grid");
  const elDates = document.querySelector(".date-selector");
  const elDateNavPrev = document.querySelector(".tp-date-nav--prev");
  const elDateNavNext = document.querySelector(".tp-date-nav--next");
  const elLoad = document.getElementById("bb-loading");
  const elLoadTitle = document.getElementById("bb-loading-title");
  const elLoadText = document.getElementById("bb-loading-text");
  const elResults = document.getElementById("tp-results");
  if (elResults) elResults.classList.add("tp-results--hydrating");

  const elSort  = document.getElementById("bb-sort");
  if (elSort) elSort.value = "time";
  const elGroup = document.getElementById("bb-group");
  const elRange = document.getElementById("bb-range");
  const elDisplayMode = document.getElementById("bb-display-mode");
  const elDisplayModeHint = document.getElementById("bb-display-mode-hint");
  const chkOptimizeTodayResults = document.getElementById("bb-optimize-today-results");
  const elOptimizeTodayHint = document.getElementById("bb-optimize-today-hint");
  const btnLeaguesAll = document.getElementById("tp-leagues-all");
  const btnLeaguesNone = document.getElementById("tp-leagues-none");
  const inlineModeButtons = Array.from(document.querySelectorAll("[data-tp-selectivity-mode]"));
  const elExpertMode = document.getElementById("tp-expert-mode");
  const elCompactMode = document.getElementById("tp-compact-mode");
  const elV2Sort = document.getElementById("tpv2-sort");
  const elV2HidePast = document.getElementById("tpv2-hide-past");
  const elV2ViewButtons = Array.from(document.querySelectorAll("[data-tpv2-view]"));
  const profilesApi = window.FSPronosticsProfiles || null;
  markTopPerf("profile_local_ready", {
    activeSelection: profilesApi?.getActiveSelection?.() || "builtin:performance"
  });
  const profilePageHref = lang === "en" ? "/en/prediction-profiles.html" : lang === "es" ? "/es/profil-pronostics.html" : "/profil-pronostics.html";
  const modeMenu = document.getElementById("tp-mode-menu");
  const modeMenuButton = document.getElementById("tp-selectivity-profile-button");
  const modeMenuPanel = document.getElementById("tp-mode-menu-panel");
  const modeMenuCurrent = document.getElementById("tp-selectivity-profile-label");
  const modeMenuCurrentMobile = document.getElementById("tp-selectivity-profile-label-mobile");
  const modeMenuCurrentMeta = document.getElementById("tp-selectivity-profile-meta");
  const modeMenuBuiltins = document.getElementById("tp-mode-menu-builtins");
  const modeMenuProfiles = document.getElementById("tp-mode-menu-profiles");

  const filtersPanel = document.getElementById("filters-panel");
  const filtersToggle = document.getElementById("filters-toggle");
  const filtersLabel = document.getElementById("filters-toggle-label");

  const elMinDC = document.getElementById("bb-min-dc");
  const elMinDNB = document.getElementById("bb-min-dnb");
  const elMin1X2 = document.getElementById("bb-min-1x2");
  const elMinU25 = document.getElementById("bb-min-u25");
  const elMinO25 = document.getElementById("bb-min-o25");
  const elMinO15 = document.getElementById("bb-min-o15");
  const elMinU35 = document.getElementById("bb-min-u35");
  const elMinBTTS = document.getElementById("bb-min-btts");

  const elMinDCVal = document.getElementById("bb-min-dc-val");
  const elMinDNBVal = document.getElementById("bb-min-dnb-val");
  const elMin1X2Val = document.getElementById("bb-min-1x2-val");
  const elMinU25Val = document.getElementById("bb-min-u25-val");
  const elMinO25Val = document.getElementById("bb-min-o25-val");
  const elMinO15Val = document.getElementById("bb-min-o15-val");
  const elMinU35Val = document.getElementById("bb-min-u35-val");
  const elMinBTTSVal = document.getElementById("bb-min-btts-val");
  const elRateDC = document.getElementById("bb-rate-dc");
  const elRateDNB = document.getElementById("bb-rate-dnb");
  const elRate1X2 = document.getElementById("bb-rate-1x2");
  const elRateU25 = document.getElementById("bb-rate-u25");
  const elRateO25 = document.getElementById("bb-rate-o25");
  const elRateO15 = document.getElementById("bb-rate-o15");
  const elRateU35 = document.getElementById("bb-rate-u35");
  const elRateBTTS = document.getElementById("bb-rate-btts");

  const sliderByTypeKey = {
    DC: { el: elMinDC, valEl: elMinDCVal },
    DNB: { el: elMinDNB, valEl: elMinDNBVal },
    "1X2": { el: elMin1X2, valEl: elMin1X2Val },
    U25: { el: elMinU25, valEl: elMinU25Val },
    O25: { el: elMinO25, valEl: elMinO25Val },
    O15: { el: elMinO15, valEl: elMinO15Val },
    U35: { el: elMinU35, valEl: elMinU35Val },
    BTTS: { el: elMinBTTS, valEl: elMinBTTSVal },
  };
  const rateElByTypeKey = {
    DC: elRateDC,
    DNB: elRateDNB,
    "1X2": elRate1X2,
    U25: elRateU25,
    O25: elRateO25,
    O15: elRateO15,
    U35: elRateU35,
    BTTS: elRateBTTS,
  };

  const elAdvanced = document.getElementById("bb-advanced");
  const btnAdvancedToggle = document.getElementById("bb-advanced-toggle");
  const elAdvancedSummary = document.getElementById("bb-advanced-summary");

  const btnRefresh = document.getElementById("bb-refresh");
  const btnResetAdvanced = document.getElementById("bb-reset-advanced");

  const chkDC = document.getElementById("chk-dc");
  const chkDNB = document.getElementById("chk-dnb");
  const chk1X2 = document.getElementById("chk-1x2");
  const chkUnder25 = document.getElementById("chk-under25");
  const chkOver25 = document.getElementById("chk-over25");
  const chkOver15 = document.getElementById("chk-over15");
  const chkUnder35 = document.getElementById("chk-under35");
  const chkBTTS = document.getElementById("chk-btts");

  const chkHidePast = document.getElementById("chk-hide-past");
  const MIN_THRESHOLD = 30;
  const MAX_THRESHOLD = 95;
  const DEFAULT_THRESHOLD = 55;
  const ALL_MATCHES_THRESHOLD = 33;
  const X12_LEVEL_CORRECT_PLUS = "correct_plus";
  const X12_LEVEL_STABLE_ONLY = "stable_only";
  const X12_LEVEL_ULTRA_ONLY = "ultra_only";
  const X12_FILTER_SCORE_CORRECT = 55;
  const X12_FILTER_SCORE_STABLE = 65;
  const HIGH_PERF_TARGET_RATE = 82;
  const HIGH_PERF_MIN_TYPE_VOLUME = 8;
  const HIGH_PERF_MIN_LEAGUE_VOLUME = 8;
  const HIGH_PERF_MAX_LEAGUES = 12;
  const HIGH_PERF_MIN_FILTERED_LEAGUES = 3;
  const REACTIVATED_TOTAL_MARKET_BASELINE = 60;
  const PERFORMANCE_MAX_NON_TOTAL_THRESHOLD = 70;
  const REACTIVATED_TOTAL_MARKETS = new Set(["U25", "O25", "O15", "U35", "BTTS"]);
  const BUSINESS_TOTAL_MARKET_FLOORS = Object.freeze({ O15: 75, U35: 70 });
  // Over/Under 2.5 coherence guard — strict mirror of the backend
  // apply_goals_25_exclusion (foresportia-backend performance_index.py).
  // A single match must NEVER expose both Over 2.5 and Under 2.5.
  const GOALS_25_MIN_PROBABILITY = 50;
  const GM_CLUSTER_UNKNOWN_FALLBACK = "unknown_or_low_volume";
  // Goal-market cluster policy — NO hardcoded copy. The backend serializes it
  // into the performance index (top_pronostics_performance_index.goal_market_policy)
  // as the single source of truth; we read it verbatim. The evaluation below is
  // the exact algorithm of backend goal_market_policy.is_goal_pick_allowed and is
  // pinned to it by test_serialized_policy_consumer_matches_backend.
  function goalMarketPolicy(){
    const p = topPronosticsPerformanceIndex?.goal_market_policy;
    return (p && typeof p === "object") ? p : null;
  }
  function leagueCluster(league){
    const p = goalMarketPolicy();
    const map = (p && p.league_clusters) || {};
    return map[String(league || "").trim().toUpperCase()] || (p && p.default_cluster) || GM_CLUSTER_UNKNOWN_FALLBACK;
  }
  function isGoalPickAllowed(typeKey, league, prob){
    const key = String(typeKey || "").toUpperCase();
    const p = goalMarketPolicy();
    // Policy missing (stale JSON / cache): fail safe — block the only
    // policy-gated market (Under 2.5), never publish it uncontrolled.
    if (!p) return key !== "U25";
    const marketPolicy = p.cluster_policy && p.cluster_policy[key];
    if (!marketPolicy) return true; // O2.5 / BTTS / DC / DNB / 1X2: always allowed
    const rule = marketPolicy[leagueCluster(league)];
    if (!rule) return true;
    if (rule.status === "disabled") return false;
    if (!isNum(prob)) return true;
    const pr = Number(prob);
    return Number(rule.min_prob ?? 0) <= pr && pr <= Number(rule.max_prob ?? 100);
  }
  const PAST_MATCH_GRACE_MS = 2 * 60 * 60 * 1000;
  const MAX_LEAGUE_MARKETS_DAYS_PER_REQUEST = 31;
  const RESULTS_VIEW_STORAGE_KEY = "fs_top_pronostics_view_mode";
  const OPTIMIZE_TODAY_RESULTS_STORAGE_KEY = "fs_top_pronostics_optimize_today_results";
  const COMPUTED_MODE_THRESHOLDS_KEY = "fs_mode_computed_thresholds_v2";
  const TOP_FILTERS_STORAGE_KEY = "fs_top_pronostics_last_filters_v1";
  const hadTopPronosticsVisitBeforeBoot = (() => {
    try {
      return (
        localStorage.getItem(TOP_FILTERS_STORAGE_KEY) !== null
      );
    } catch (error) {
      return false;
    }
  })();
  const DAILY_MODE_CACHE_KEY_PREFIX = "tp_thresholds_v2";
  const DAILY_MODE_CACHE_VERSION = "v7";
  const MODE_THRESHOLD_OFFSETS = Object.freeze({
    performance: 0,
    high: 4,
    ultra: 8,
  });
  const MODE_THRESHOLD_MIN_GAP = 2;
  const PERFORMANCE_MIN_OBSERVED_RATE = 65;
  const PERFORMANCE_MIN_OBSERVED_RATE_BY_TYPE = { BTTS: 60 };
  const getPerformanceMinObservedRate = (typeKey) =>
    PERFORMANCE_MIN_OBSERVED_RATE_BY_TYPE[typeKey] ?? PERFORMANCE_MIN_OBSERVED_RATE;
  const PERFORMANCE_MIN_VOLUME_SHARE = 0.4;
  const MODE_OPTIMIZATION_CONFIG = Object.freeze({
    recentWindowId: "30d",
    recentDays: 30,
    fallbackWindowId: "all",
    recentMinSettledPicks: 24,
  });
  const THRESHOLD_PRESETS = {
    default: {
      DC: DEFAULT_THRESHOLD,
      DNB: DEFAULT_THRESHOLD,
      "1X2": DEFAULT_THRESHOLD,
      U25: DEFAULT_THRESHOLD,
      O25: DEFAULT_THRESHOLD,
      O15: 75,
      U35: 70,
      BTTS: DEFAULT_THRESHOLD,
    },
    all: {
      DC: ALL_MATCHES_THRESHOLD,
      DNB: ALL_MATCHES_THRESHOLD,
      "1X2": ALL_MATCHES_THRESHOLD,
      U25: ALL_MATCHES_THRESHOLD,
      O25: ALL_MATCHES_THRESHOLD,
      O15: 75,
      U35: 70,
      BTTS: ALL_MATCHES_THRESHOLD,
    },
  };

  const ANALYTICAL_TYPE_KEYS = ["1X2", "DC", "DNB", "U25", "O25", "O15", "U35", "BTTS"];
  const CHIP_TYPE_KEYS = ANALYTICAL_TYPE_KEYS; // compatibility: analytical UI/reporting
  const FAIL_SAFE_PUBLICATION_ENABLED = {
    "1X2": true, DC: true, DNB: true, U25: false, O25: true, O15: true, U35: true, BTTS: true,
  };
  function getPublishableTypeKeys(){
    const contract = topPronosticsPerformanceIndex?.market_publication;
    if (Array.isArray(contract?.publishable_markets)) {
      const declared = new Set(contract.publishable_markets.map((key) => String(key || "").toUpperCase()));
      return ANALYTICAL_TYPE_KEYS.filter((key) => declared.has(key));
    }
    const explicit = contract?.publication_enabled;
    const policy = explicit && typeof explicit === "object" ? explicit : FAIL_SAFE_PUBLICATION_ENABLED;
    return ANALYTICAL_TYPE_KEYS.filter((key) => policy[key] === true);
  }
  const CHIP_TYPE_TO_PERF = {
    "1X2": "1x2",
    DC: "double_chance",
    DNB: "dnb",
    U25: "under25",
    O25: "over25",
    O15: "over15",
    U35: "under35",
    BTTS: "btts",
  };

  function getTypeMinThresholdForBuiltInMode(typeKey, mode = "performance") {
    if (!REACTIVATED_TOTAL_MARKETS.has(typeKey)) {
      return mode === "all" ? ALL_MATCHES_THRESHOLD : MIN_THRESHOLD;
    }
    if (BUSINESS_TOTAL_MARKET_FLOORS[typeKey]) return BUSINESS_TOTAL_MARKET_FLOORS[typeKey];
    if (mode === "all") return ALL_MATCHES_THRESHOLD;
    return REACTIVATED_TOTAL_MARKET_BASELINE;
  }

  function applyBuiltInTotalsFloor(preset, mode = "performance") {
    const normalized = normalizeThresholdPreset(preset, THRESHOLD_PRESETS.default);
    REACTIVATED_TOTAL_MARKETS.forEach((typeKey) => {
      const floor = getTypeMinThresholdForBuiltInMode(typeKey, mode);
      normalized[typeKey] = clampModeThreshold(Math.max(normalized[typeKey], floor));
    });
    return normalized;
  }

  // State
  let combinedIdx = {};
  let windowMatches = [];
  let windowMatchesRaw = [];
  let windowMatchesFull = [];
  let windowMatchesFullRaw = [];
  let dateCounts = new Map();
  let selectedDate = null;
  const touchedTypes = new Set();
  let suggestionsAppliedOnce = false;
  let optimizeWithTodayResults = false;
  let lastSuggestions = {};
  let picksPerfIdx = null;
  let topPronosticsPerformanceIndex = null;
  let automaticModeBaseline = null;
  let profileControlsBaseline = null;
  let appliedProfileSignature = "";
  let sourcesReady = false;
  let refreshTask = null;
  let sourceRevision = 0;
  let freshnessMessage = "";
  let refreshingSources = false;
  let latestPerfByType = null;
  let activeDisplayMode = elDisplayMode ? String(elDisplayMode.value || "performance") : "performance";
  let activeModeSelection = profilesApi ? profilesApi.getActiveSelection() : `builtin:${activeDisplayMode}`;
  let activeWizardX12Custom = null;
  let activeProfileMinConfidence = 0;
  let activeProfileStabilityFilter = "all";
  const modeSelectedDateMemory = {
    performance: null,
    high: null,
    ultra: null,
    all: null,
  };
  let isApplyingDisplayMode = false;
  let pendingDisplayMode = null;
  let expertModeEnabled = !!(elExpertMode && elExpertMode.checked);
  let compactModeEnabled = false;
  let detailsBindingDone = false;
  let detailsIdCounter = 0;
  let modeMenuOpen = false;
  let persistTopFiltersTimer = 0;
  let initialModeRelaxationPending = false;
  let modeRelaxationToastShown = false;
  let activeModeRelaxation = null;
  let requestedModeSelectionBeforeRelaxation = null;
  let lastTopPronosticsRenderCount = 0;
  const INLINE_MATCH_AD_SLOT = "3545150534";
  const ADS_CLIENT = "ca-pub-5203539705534158";
  let resolveControlsReady = null;
  const controlsReadyPromise = new Promise((resolve) => {
    resolveControlsReady = resolve;
  });
  let displayModeTask = Promise.resolve();
  const dailyModeCacheMemory = new Map();
  const leagueMarketsBulkCache = new Map();
  const leagueMarketsBulkInFlight = new Map();
  const teamFormBulkCache = new Map();
  const teamFormBulkInFlight = new Map();
  let deferredTeamFormMatches = null;
  let deferredTeamFormPromise = null;
  let deferredEnrichmentsStarted = false;
  let initialProgressiveRenderPending = true;
  const pendingMatchLinkCards = new Set();

  function markTopModeUserInteraction() {
    initialModeRelaxationPending = false;
    activeModeRelaxation = null;
    requestedModeSelectionBeforeRelaxation = null;
  }

  function showFilterRelaxToast({ title, message }) {
    if (modeRelaxationToastShown || !title || !message || !document.body) return;
    modeRelaxationToastShown = true;

    if (!document.getElementById("fs-filter-relax-toast-style")) {
      const style = document.createElement("style");
      style.id = "fs-filter-relax-toast-style";
      style.textContent = `
        .fs-filter-relax-toast {
          position: fixed;
          left: max(12px, env(safe-area-inset-left));
          right: max(12px, env(safe-area-inset-right));
          bottom: calc(14px + env(safe-area-inset-bottom));
          z-index: 1200;
          max-width: 520px;
          margin: 0 auto;
          display: flex;
          align-items: flex-start;
          gap: 12px;
          padding: 12px 14px;
          border: 1px solid rgba(148, 163, 184, 0.35);
          border-radius: 8px;
          background: rgba(15, 23, 42, 0.94);
          color: #f8fafc;
          box-shadow: 0 14px 32px rgba(15, 23, 42, 0.24);
          transform: translateY(calc(100% + 24px));
          opacity: 0;
          transition: transform 220ms ease, opacity 220ms ease;
          pointer-events: auto;
        }
        .fs-filter-relax-toast.is-visible {
          transform: translateY(0);
          opacity: 1;
        }
        .fs-filter-relax-toast__body {
          min-width: 0;
          flex: 1;
        }
        .fs-filter-relax-toast__title {
          display: block;
          margin-bottom: 2px;
          font-weight: 700;
          font-size: 0.92rem;
          line-height: 1.25;
        }
        .fs-filter-relax-toast__message {
          margin: 0;
          color: #cbd5e1;
          font-size: 0.84rem;
          line-height: 1.35;
        }
        .fs-filter-relax-toast__close {
          width: 28px;
          height: 28px;
          border: 0;
          border-radius: 999px;
          background: rgba(255, 255, 255, 0.08);
          color: #f8fafc;
          font-size: 18px;
          line-height: 1;
          cursor: pointer;
        }
        @media (max-width: 520px) {
          .fs-filter-relax-toast {
            max-width: none;
            padding: 11px 12px;
          }
        }
      `;
      document.head.appendChild(style);
    }

    const toast = document.createElement("div");
    toast.className = "fs-filter-relax-toast";
    toast.setAttribute("role", "status");
    toast.setAttribute("aria-live", "polite");
    toast.innerHTML = `
      <div class="fs-filter-relax-toast__body">
        <strong class="fs-filter-relax-toast__title">${escapeHtml(title)}</strong>
        <p class="fs-filter-relax-toast__message">${escapeHtml(message)}</p>
      </div>
      <button class="fs-filter-relax-toast__close" type="button" aria-label="Close">×</button>
    `;
    document.body.appendChild(toast);

    const closeToast = () => {
      toast.classList.remove("is-visible");
      window.setTimeout(() => toast.remove(), 240);
    };
    toast.querySelector(".fs-filter-relax-toast__close")?.addEventListener("click", closeToast);
    requestAnimationFrame(() => toast.classList.add("is-visible"));
    window.setTimeout(closeToast, 7000);
  }
  let windowDataLoadPromise = null;
  let listingRenderGeneration = 0;
  let activeListingGeneration = 0;
  let listingLoadingVisible = false;

  function isListingGenerationCurrent(generation) {
    return generation === activeListingGeneration;
  }

  function emitListingLoading(loading, reason = "") {
    if (listingLoadingVisible === !!loading && loading) return;
    listingLoadingVisible = !!loading;

    if (elGrid) {
      elGrid.classList.toggle("tp-grid--loading", !!loading);
      elGrid.setAttribute("aria-busy", loading ? "true" : "false");
      if (reason) elGrid.dataset.loadingReason = reason;
      else delete elGrid.dataset.loadingReason;
    }

    // The old global loading banner is deliberately kept invisible:
    // only the match list shows a pending state.
    if (elLoad) elLoad.style.display = "none";

    if (typeof CustomEvent === "function") {
      window.dispatchEvent(new CustomEvent("tp:listing-loading", {
        detail: { loading: !!loading, reason: String(reason || "") }
      }));
    }
  }

  function beginListingUpdate(reason = "render") {
    const generation = ++listingRenderGeneration;
    activeListingGeneration = generation;
    emitListingLoading(true, reason);
    return generation;
  }

  function endListingUpdate(generation) {
    if (!isListingGenerationCurrent(generation)) return;
    emitListingLoading(false, "");
  }

  function yieldToBrowser() {
    return new Promise((resolve) => requestAnimationFrame(() => resolve()));
  }

  async function yieldInitialPaint() {
    // Two frames let the shell and the high-priority visible ad enter the
    // rendering pipeline before API/data work starts.
    await new Promise((resolve) =>
      requestAnimationFrame(() => requestAnimationFrame(resolve))
    );
  }

  async function renderCardBatch(entries, target, renderState, generation, batchSize = 6, options = {}) {
    const list = Array.isArray(entries) ? entries : [];
    for (let index = 0; index < list.length; index += batchSize) {
      if (!isListingGenerationCurrent(generation)) return false;

      const batch = list.slice(index, index + batchSize);
      const cards = await Promise.all(
        batch.map(([matchKey, picks]) => renderMatchCard(matchKey, picks))
      );

      if (!isListingGenerationCurrent(generation)) return false;

      cards.forEach((card) => {
        appendMatchCardWithInlineAd(target, card, renderState);
        queueDeferredMatchLink(card);
      });
      if (typeof options.onBatchRendered === "function") {
        options.onBatchRendered({ index, count: cards.length });
      }

      // Prevent long DOM/card-generation tasks from monopolising the main thread.
      if (index + batchSize < list.length) await yieldToBrowser();
    }
    return true;
  }

  function chipReadPerf(src, typeKey, leagues, thr) {
    const block = src?.[CHIP_TYPE_TO_PERF[typeKey]];
    if (!block) return null;
    const thrStr = String(thr);

    if (!Array.isArray(leagues)) {
      const leagueKey = (!leagues || leagues === "all") ? "all" : leagues;
      const entry = block?.[leagueKey]?.[thrStr];
      if (!entry) return null;
      return {
        wins: Number(entry.wins || 0),
        total: Number(entry.total || 0),
      };
    }

    let wins = 0;
    let total = 0;
    for (const league of leagues) {
      const entry = block?.[league]?.[thrStr];
      if (!entry) continue;
      wins += Number(entry.wins || 0);
      total += Number(entry.total || 0);
    }
    return total > 0 ? { wins, total } : null;
  }

  function chipComputeSuggestionThresholds(src, league) {
    const thresholdList = [30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85];
    const result = {};

    for (const typeKey of getPublishableTypeKeys()) {
      let best = null;
      const minVolume = typeKey === "BTTS" ? 3 : 10;
      const minThreshold = getTypeMinThresholdForBuiltInMode(typeKey, "performance");

      for (const thr of thresholdList) {
        const entry = chipReadPerf(src, typeKey, league, thr);
        if (!entry || entry.total < minVolume) continue;
        const rate = (entry.wins / entry.total) * 100;
        const volumeWeight = REACTIVATED_TOTAL_MARKETS.has(typeKey) ? 0.5 : 0.2;
        const score = rate + Math.min(entry.total, 60) * volumeWeight;
        if (!best || score > best.score) best = { thr, score };
      }

      const fallback = Math.max(DEFAULT_THRESHOLD, minThreshold);
      const picked = best ? best.thr : fallback;
      result[typeKey] = clampModeThreshold(Math.max(picked, minThreshold));
    }

    return result;
  }

  function chipComputeHighThresholds(src, leagues) {
    const ladder = [85, 80, 75, 70, 65, 60, 55, 50, 45, 40, 35, 33];
    const result = {};

    for (const typeKey of getPublishableTypeKeys()) {
      const minThreshold = getTypeMinThresholdForBuiltInMode(typeKey, "high");
      const minVolume = typeKey === "BTTS"
        ? Math.max(4, HIGH_PERF_MIN_TYPE_VOLUME - 2)
        : HIGH_PERF_MIN_TYPE_VOLUME;
      const samples = [];

      for (const thr of ladder) {
        const entry = chipReadPerf(src, typeKey, leagues, thr);
        if (!entry || entry.total < minVolume) continue;
        const rate = (entry.wins / entry.total) * 100;
        samples.push({ thr, rate, total: entry.total });
      }

      if (!samples.length) {
        result[typeKey] = clampModeThreshold(minThreshold);
        continue;
      }

      const overTarget = samples
        .filter((sample) => sample.rate >= HIGH_PERF_TARGET_RATE)
        .sort((a, b) => (b.rate - a.rate) || (b.thr - a.thr) || (b.total - a.total));

      if (overTarget.length) {
        result[typeKey] = clampModeThreshold(Math.max(overTarget[0].thr, minThreshold));
        continue;
      }

      const fallback = samples
        .slice()
        .sort((a, b) => {
          const scoreA = a.rate + (a.thr * 0.04) + Math.min(a.total, 40) * 0.2;
          const scoreB = b.rate + (b.thr * 0.04) + Math.min(b.total, 40) * 0.2;
          return scoreB - scoreA;
        })[0];

      const fallbackThreshold = fallback ? fallback.thr : minThreshold;
      result[typeKey] = clampModeThreshold(Math.max(fallbackThreshold, minThreshold));
    }

    return result;
  }

  function chipSelectBestLeagues(src, preset) {
    const allLeagues = new Set();
    for (const perfKey of Object.values(CHIP_TYPE_TO_PERF)) {
      const block = src?.[perfKey];
      if (!block) continue;
      for (const key of Object.keys(block)) {
        if (key !== "all") allLeagues.add(key);
      }
    }

    const leagueStats = [];
    for (const leagueCode of allLeagues) {
      let wins = 0;
      let total = 0;
      for (const typeKey of getPublishableTypeKeys()) {
        const thr = preset?.[typeKey] || ALL_MATCHES_THRESHOLD;
        const entry = chipReadPerf(src, typeKey, leagueCode, thr);
        if (!entry) continue;
        wins += entry.wins;
        total += entry.total;
      }
      if (total > 0) {
        leagueStats.push({
          league: leagueCode,
          wins,
          total,
          rate: (wins / total) * 100,
        });
      }
    }

    if (!leagueStats.length) return [];

    const strict = leagueStats
      .filter((row) => row.total >= HIGH_PERF_MIN_LEAGUE_VOLUME && row.rate >= HIGH_PERF_TARGET_RATE)
      .sort((a, b) => (b.rate - a.rate) || (b.total - a.total))
      .slice(0, HIGH_PERF_MAX_LEAGUES)
      .map((row) => row.league);

    if (strict.length) return strict;

    return leagueStats
      .filter((row) => row.total >= 4)
      .sort((a, b) => {
        const scoreA = a.rate + Math.min(a.total, 30) * 0.7;
        const scoreB = b.rate + Math.min(b.total, 30) * 0.7;
        return scoreB - scoreA;
      })
      .slice(0, 8)
      .map((row) => row.league);
  }

  function chipAggregateStats(src, thresholds, leagueFilter) {
    let totalAll = 0;
    let winsAll = 0;

    for (const typeKey of getPublishableTypeKeys()) {
      const thr = thresholds?.[typeKey] || DEFAULT_THRESHOLD;
      const entry = chipReadPerf(src, typeKey, leagueFilter, thr);
      if (!entry) continue;
      totalAll += entry.total;
      winsAll += entry.wins;
    }

    const rate = totalAll > 0 ? (winsAll / totalAll) * 100 : 0;
    return {
      rate: totalAll > 0 ? `${rate.toFixed(1)}%` : null,
      count: totalAll,
    };
  }

  function buildModeStatsPerfByType(matches, minProbPerf = 30) {
    const source = Array.isArray(matches) ? matches : [];
    const perfByType = {
      DC: { total: 0, wins: 0, voids: 0, buckets: {} },
      DNB: { total: 0, wins: 0, voids: 0, buckets: {} },
      "1X2": { total: 0, wins: 0, voids: 0, buckets: {} },
      U25: { total: 0, wins: 0, voids: 0, buckets: {} },
      O25: { total: 0, wins: 0, voids: 0, buckets: {} },
      O15: { total: 0, wins: 0, voids: 0, buckets: {} },
      U35: { total: 0, wins: 0, voids: 0, buckets: {} },
      BTTS: { total: 0, wins: 0, voids: 0, buckets: {} },
    };

    for (const m of source) {
      const cands = buildCandidatesForPerfBase(m, minProbPerf);
      for (const c of cands) {
        const key = candidateTypeKey(c);
        if (!key || !perfByType[key]) continue;

        const outcome = outcomeForCandidate(c);
        if (!outcome) continue;

        const grp = perfByType[key];
        if (outcome === "void") grp.voids++;
        else {
          grp.total++;
          if (outcome === "win") grp.wins++;
        }

        const prob = getCandidateFilterScore(c);
        const bucketKey = Math.floor(prob / 5) * 5;
        const bucket = grp.buckets[bucketKey] || (grp.buckets[bucketKey] = {
          prob: bucketKey,
          total: 0,
          wins: 0,
          voids: 0
        });

        if (outcome === "void") bucket.voids++;
        else {
          bucket.total++;
          if (outcome === "win") bucket.wins++;
        }
      }
    }

    return perfByType;
  }

  function buildModeStatsSuggestedThresholds(matches) {
    const perfByType = buildModeStatsPerfByType(matches, 30);
    const suggestions = computeTypeSuggestions(perfByType);
    const preset = { ...THRESHOLD_PRESETS.default };

    Object.keys(preset).forEach((typeKey) => {
      const suggested = Number(suggestions?.[typeKey]?.thr);
      if (Number.isFinite(suggested)) preset[typeKey] = suggested;
    });

    return preset;
  }

  function buildModeStatsHighThresholds(matches) {
    const perfByType = buildModeStatsPerfByType(matches, 30);
    const out = { ...THRESHOLD_PRESETS.all };
    const thresholdLadder = [85, 80, 75, 70, 65, 60, 55, 50, 45, 40, 35, 33];

    Object.keys(sliderByTypeKey).forEach((typeKey) => {
      const group = perfByType?.[typeKey];
      if (!group) return;

      const minVolume = typeKey === "BTTS"
        ? Math.max(4, HIGH_PERF_MIN_TYPE_VOLUME - 2)
        : HIGH_PERF_MIN_TYPE_VOLUME;

      const samples = [];
      for (const thr of thresholdLadder) {
        const stats = thresholdHitRate(group, thr);
        if (!stats || stats.total < minVolume) continue;
        samples.push({ thr, ...stats });
      }
      if (!samples.length) return;

      const overTarget = samples
        .filter((sample) => sample.rate >= HIGH_PERF_TARGET_RATE)
        .sort((a, b) => (b.rate - a.rate) || (b.thr - a.thr) || (b.total - a.total));

      if (overTarget.length) {
        out[typeKey] = overTarget[0].thr;
        return;
      }

      const fallback = samples
        .slice()
        .sort((a, b) => {
          const scoreA = a.rate + (a.thr * 0.04) + Math.min(a.total, 40) * 0.2;
          const scoreB = b.rate + (b.thr * 0.04) + Math.min(b.total, 40) * 0.2;
          return scoreB - scoreA;
        })[0];

      if (fallback) out[typeKey] = fallback.thr;
    });

    return out;
  }

  function aggregateModeStatsFromMatches(matches, thresholds, leagueFilter) {
    const allowedLeagues = Array.isArray(leagueFilter)
      ? new Set(leagueFilter.map((league) => String(league || "").toUpperCase()).filter(Boolean))
      : null;

    let wins = 0;
    let total = 0;

    for (const match of (Array.isArray(matches) ? matches : [])) {
      const cands = buildCandidatesForPerfBase(match, 0, {
        selectedLeagueSet: allowedLeagues,
        includeGlobal1X2: true,
      });
      for (const cand of cands) {
        const typeKey = candidateTypeKey(cand);
        if (!typeKey || !getPublishableTypeKeys().includes(typeKey)) continue;

        const threshold = Number(thresholds?.[typeKey] ?? DEFAULT_THRESHOLD);
        if (getCandidateFilterScore(cand) < threshold) continue;

        const outcome = outcomeForCandidate(cand);
        if (!outcome || outcome === "void") continue;

        total++;
        if (outcome === "win") wins++;
      }
    }

    return {
      rate: total > 0 ? `${((wins / total) * 100).toFixed(1)}%` : null,
      count: total,
    };
  }

  function getSourceForBuiltInModes() {
    if (windowMatchesFullRaw && windowMatchesFullRaw.length) return windowMatchesFullRaw;
    if (windowMatchesRaw && windowMatchesRaw.length) return windowMatchesRaw;
    return windowMatches;
  }

  function buildModeStatsMeta(windowInfo) {
    return {
      windowId: windowInfo?.id || MODE_OPTIMIZATION_CONFIG.recentWindowId,
      windowLabel: windowInfo?.id === MODE_OPTIMIZATION_CONFIG.fallbackWindowId
        ? "hist."
        : `${MODE_OPTIMIZATION_CONFIG.recentDays}${lang === "fr" ? "j" : "d"}`,
      sourceKind: windowInfo?.sourceKind || "recent-matches",
    };
  }

  function getPerformanceSuggestionMinVolume(typeKey) {
    return typeKey === "BTTS" ? 3 : 10;
  }

  function getWindowPerfByType(windowInfo) {
    if (!windowInfo) return null;
    if (!windowInfo._perfByType) {
      windowInfo._perfByType = buildModeStatsPerfByType(windowInfo.matches || [], MIN_THRESHOLD);
    }
    return windowInfo._perfByType;
  }

  function readObservedThresholdStats(windowInfo, typeKey, threshold) {
    const thr = clampModeThreshold(threshold);

    const perfByType = getWindowPerfByType(windowInfo);
    const stats = thresholdHitRate(perfByType?.[typeKey], thr);
    if (!stats || !stats.total) return null;
    return stats;
  }

  function enforcePerformanceBaseFloor(baseThresholds, windowInfo) {
    const out = normalizeThresholdPreset(baseThresholds, THRESHOLD_PRESETS.default);
    const thresholdLadder = [30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85];

    getPublishableTypeKeys().forEach((typeKey) => {
      // Product rule: this strict uplift is only for totals markets.
      if (!REACTIVATED_TOTAL_MARKETS.has(typeKey)) return;
      const currentThreshold = clampModeThreshold(out[typeKey]);
      const currentStats = readObservedThresholdStats(windowInfo, typeKey, currentThreshold);
      const minRate = getPerformanceMinObservedRate(typeKey);
      if (!currentStats || currentStats.rate >= minRate) return;

      // Garde-fou produit : on relève Performance seulement si un seuil plus strict
      // permet d'atteindre ~65% observé sans effondrer totalement le volume utile.
      const minVolume = Math.max(
        getPerformanceSuggestionMinVolume(typeKey),
        Math.ceil(currentStats.total * PERFORMANCE_MIN_VOLUME_SHARE)
      );

      const fallbackThreshold = thresholdLadder
        .filter((thr) => thr >= currentThreshold)
        .find((thr) => {
          const sample = readObservedThresholdStats(windowInfo, typeKey, thr);
          return sample && sample.total >= minVolume && sample.rate >= minRate;
        });

      if (Number.isFinite(fallbackThreshold)) {
        out[typeKey] = fallbackThreshold;
      }
    });

    return out;
  }

  function buildBaseThresholdsForOptimizationWindow(windowInfo) {
    const baseThresholds = normalizeThresholdPreset(
      buildModeStatsSuggestedThresholds(windowInfo?.matches || []),
      THRESHOLD_PRESETS.default
    );

    const withFloor = enforcePerformanceBaseFloor(baseThresholds, windowInfo);
    return applyBuiltInTotalsFloor(withFloor, "performance");
  }

  function buildLeagueSelectionForMode(windowInfo, thresholdsByMode) {
    const highCandidates = selectHighPerformanceLeagues(windowInfo?.matches || [], thresholdsByMode.high);

    const highRaw = Array.isArray(highCandidates) ? highCandidates : [];
    const high = highRaw.length >= HIGH_PERF_MIN_FILTERED_LEAGUES ? highRaw : [];
    const highSet = new Set(high.map((league) => String(league || "").toUpperCase()).filter(Boolean));

    let ultraSourceMatches = windowInfo?.matches || [];
    if (highSet.size && Array.isArray(ultraSourceMatches)) {
      ultraSourceMatches = ultraSourceMatches.filter((match) => highSet.has(String(match?.league || "").toUpperCase()));
    }

    const ultraCandidates = selectHighPerformanceLeagues(ultraSourceMatches, thresholdsByMode.ultra);

    let ultraRaw = Array.isArray(ultraCandidates) ? ultraCandidates : [];
    if (highSet.size) {
      ultraRaw = ultraRaw.filter((league) => highSet.has(String(league || "").toUpperCase()));
    }
    const ultra = ultraRaw.length >= HIGH_PERF_MIN_FILTERED_LEAGUES ? ultraRaw : [];

    return {
      performance: [],
      high,
      ultra,
    };
  }

  function buildStatsForMode(windowInfo, thresholds, leagues) {
    const leagueFilter = Array.isArray(leagues) && leagues.length ? leagues : null;
    const stats = aggregateModeStatsFromMatches(windowInfo?.matches || [], thresholds, leagueFilter);

    return {
      ...stats,
      ...buildModeStatsMeta(windowInfo),
    };
  }

  function buildDailyBuiltInModeConfigs(sourceMatches, referenceDate) {
    const windowInfo = getThresholdOptimizationWindow(sourceMatches, referenceDate);
    const baseThresholds = buildBaseThresholdsForOptimizationWindow(windowInfo);
    const thresholdsByMode = enforceModeThresholdOrdering(baseThresholds);
    const leaguesByMode = buildLeagueSelectionForMode(windowInfo, thresholdsByMode);
    const meta = buildModeStatsMeta(windowInfo);

    return {
      performance: {
        mode: "performance",
        referenceDate: getThresholdReferenceDate(referenceDate),
        thresholds: thresholdsByMode.performance,
        leagues: leaguesByMode.performance,
        stats: buildStatsForMode(windowInfo, thresholdsByMode.performance, leaguesByMode.performance),
        meta,
      },
      high: {
        mode: "high",
        referenceDate: getThresholdReferenceDate(referenceDate),
        thresholds: thresholdsByMode.high,
        leagues: leaguesByMode.high,
        stats: buildStatsForMode(windowInfo, thresholdsByMode.high, leaguesByMode.high),
        meta,
      },
      ultra: {
        mode: "ultra",
        referenceDate: getThresholdReferenceDate(referenceDate),
        thresholds: thresholdsByMode.ultra,
        leagues: leaguesByMode.ultra,
        stats: buildStatsForMode(windowInfo, thresholdsByMode.ultra, leaguesByMode.ultra),
        meta,
      },
    };
  }

  function getBuiltInModeDailyConfigs(referenceDate) {
    // Only the service index may be described as an automatic configuration.
    return getRemoteBuiltInModeConfigs(referenceDate);
  }

  function dispatchModeStatsFromPicksPerf(referenceDate) {
    const configs = getBuiltInModeDailyConfigs(referenceDate);
    if (!configs) return;

    const stats = {
      all: configs.all?.stats || null,
      performance: configs.performance?.stats || null,
      high: configs.high?.stats || null,
      ultra: configs.ultra?.stats || null,
    };

    if (referenceDate === selectedDate && hasDaySummarySnapshot && isBuiltInAutomaticSelection()) {
      const daily = computeDaySummaryFromCandidates(lastCandidatesForDay);
      if (daily.total > 0 && stats[activeDisplayMode]) {
        stats[activeDisplayMode] = {
          ...stats[activeDisplayMode],
          rate: `${(daily.wins / daily.total * 100).toFixed(1)}%`,
          count: daily.total,
          total: daily.total,
          wins: daily.wins,
          rateBasis: "daily",
          windowLabel: selectedDate,
        };
      }
    }

    window._tpModeStats = stats;
    window.dispatchEvent(new CustomEvent("tp:mode-stats-ready", { detail: stats }));
  }

  function readStoredResultsViewMode() {
    try {
      return localStorage.getItem(RESULTS_VIEW_STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }
  function readStoredOptimizeTodayResults() {
    try {
      return localStorage.getItem(OPTIMIZE_TODAY_RESULTS_STORAGE_KEY) === "1";
    } catch (e) {
      return false;
    }
  }

  function persistOptimizeTodayResults(enabled) {
    try {
      localStorage.setItem(OPTIMIZE_TODAY_RESULTS_STORAGE_KEY, enabled ? "1" : "0");
    } catch (e) {}
  }
  function readStoredTopFiltersState() {
    try {
      const raw = localStorage.getItem(TOP_FILTERS_STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }
  function persistTopFiltersState() {
    try {
      const selectionToPersist =
        activeModeRelaxation && requestedModeSelectionBeforeRelaxation
          ? requestedModeSelectionBeforeRelaxation
          : activeModeSelection;
      localStorage.setItem(
        TOP_FILTERS_STORAGE_KEY,
        JSON.stringify({
          selection: selectionToPersist,
          optimizeWithTodayResults: !!optimizeWithTodayResults,
        })
      );
    } catch (e) {}
  }
  function schedulePersistTopFiltersState() {
    window.clearTimeout(persistTopFiltersTimer);
    persistTopFiltersTimer = window.setTimeout(() => {
      persistTopFiltersState();
    }, 120);
  }

  function clampModeThreshold(value) {
    const n = Math.round(Number(value) || DEFAULT_THRESHOLD);
    return Math.max(MIN_THRESHOLD, Math.min(MAX_THRESHOLD, n));
  }

  function clampBusinessMarketFloor(typeKey, value) {
    return Math.max(BUSINESS_TOTAL_MARKET_FLOORS[typeKey] || MIN_THRESHOLD, value);
  }

  function normalizeThresholdPreset(preset, fallback = THRESHOLD_PRESETS.default) {
    const source = preset && typeof preset === "object" ? preset : {};
    const out = {};
    CHIP_TYPE_KEYS.forEach((typeKey) => {
      const rawValue = Number.isFinite(Number(source[typeKey]))
        ? Number(source[typeKey])
        : Number(fallback?.[typeKey]);
      out[typeKey] = typeKey === "1X2"
        ? normalize1X2ControlValue(rawValue)
        : clampBusinessMarketFloor(typeKey, clampModeThreshold(rawValue));
    });
    return out;
  }

  function getThresholdReferenceDate(referenceDate) {
    const raw = String(referenceDate || selectedDate || todayISO()).trim();
    return /^\d{4}-\d{2}-\d{2}$/.test(raw) ? raw : todayISO();
  }

  function buildDailyThresholdContextHash() {
    return [
      DAILY_MODE_CACHE_VERSION,
      optimizeWithTodayResults ? "live" : "frozen",
      `${MODE_OPTIMIZATION_CONFIG.recentWindowId}-${MODE_OPTIMIZATION_CONFIG.recentDays}`,
      `min${MODE_OPTIMIZATION_CONFIG.recentMinSettledPicks}`,
      `off${MODE_THRESHOLD_OFFSETS.high}-${MODE_THRESHOLD_OFFSETS.ultra}`,
      `gap${MODE_THRESHOLD_MIN_GAP}`,
      `totbase${REACTIVATED_TOTAL_MARKET_BASELINE}`,
      `nontotmax${PERFORMANCE_MAX_NON_TOTAL_THRESHOLD}`,
    ].join("_");
  }

  function getDailyThresholdCacheKey(referenceDate, mode, windowId, contextHash) {
    return [
      DAILY_MODE_CACHE_KEY_PREFIX,
      getThresholdReferenceDate(referenceDate),
      String(mode || "performance"),
      String(windowId || MODE_OPTIMIZATION_CONFIG.recentWindowId),
      String(contextHash || buildDailyThresholdContextHash()),
    ].join(":");
  }

  function readDailyThresholdCache(referenceDate, mode, windowId, contextHash) {
    const key = getDailyThresholdCacheKey(referenceDate, mode, windowId, contextHash);
    if (dailyModeCacheMemory.has(key)) return dailyModeCacheMemory.get(key);

    try {
      const raw = localStorage.getItem(key);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed || parsed.version !== DAILY_MODE_CACHE_VERSION) return null;
      dailyModeCacheMemory.set(key, parsed);
      return parsed;
    } catch (e) {
      return null;
    }
  }

  function writeDailyThresholdCache(referenceDate, mode, windowId, contextHash, payload) {
    const key = getDailyThresholdCacheKey(referenceDate, mode, windowId, contextHash);
    const record = {
      version: DAILY_MODE_CACHE_VERSION,
      ...payload,
    };
    dailyModeCacheMemory.set(key, record);
    try {
      localStorage.setItem(key, JSON.stringify(record));
    } catch (e) {}
    return record;
  }

  function countSettledOptimizationCandidates(matches) {
    let total = 0;
    for (const match of (Array.isArray(matches) ? matches : [])) {
      const cands = buildCandidatesForPerfBase(match, MIN_THRESHOLD);
      for (const cand of cands) {
        const outcome = outcomeForCandidate(cand);
        if (!outcome || outcome === "void") continue;
        total += 1;
      }
    }
    return total;
  }

  function shouldIncludeReferenceDayInOptimization(referenceDate) {
    return optimizeWithTodayResults && getThresholdReferenceDate(referenceDate) === todayISO();
  }

  function enforceModeThresholdOrdering(baseThresholds) {
    const performance = normalizeThresholdPreset(baseThresholds, THRESHOLD_PRESETS.default);
    const high = {};
    const ultra = {};

    getPublishableTypeKeys().forEach((typeKey) => {
      if (typeKey === "1X2") {
        performance[typeKey] = X12_FILTER_SCORE_CORRECT;
        high[typeKey] = X12_FILTER_SCORE_STABLE;
        ultra[typeKey] = X12_FILTER_SCORE_STABLE;
        return;
      }

      let perfValue = performance[typeKey];
      if (!REACTIVATED_TOTAL_MARKETS.has(typeKey)) {
        perfValue = Math.min(perfValue, PERFORMANCE_MAX_NON_TOTAL_THRESHOLD);
      }
      const perfFloor = getTypeMinThresholdForBuiltInMode(typeKey, "performance");
      if (perfValue < perfFloor) {
        perfValue = clampModeThreshold(perfFloor);
      }
      performance[typeKey] = perfValue;
      let highValue = clampModeThreshold(perfValue + MODE_THRESHOLD_OFFSETS.high);
      let ultraValue = clampModeThreshold(perfValue + MODE_THRESHOLD_OFFSETS.ultra);

      if (perfValue + MODE_THRESHOLD_MIN_GAP <= MAX_THRESHOLD) {
        highValue = Math.max(highValue, perfValue + MODE_THRESHOLD_MIN_GAP);
      }
      highValue = clampModeThreshold(Math.max(
        highValue,
        perfValue,
        getTypeMinThresholdForBuiltInMode(typeKey, "high")
      ));

      if (highValue + MODE_THRESHOLD_MIN_GAP <= MAX_THRESHOLD) {
        ultraValue = Math.max(ultraValue, highValue + MODE_THRESHOLD_MIN_GAP);
      }
      ultraValue = clampModeThreshold(Math.max(
        ultraValue,
        highValue,
        getTypeMinThresholdForBuiltInMode(typeKey, "ultra")
      ));

      high[typeKey] = highValue;
      ultra[typeKey] = ultraValue;
    });

    return { performance, high, ultra };
  }

  function getAllOptimizationMatches(matches) {
    const base = Array.isArray(matches)
      ? matches
      : ((windowMatchesFullRaw && windowMatchesFullRaw.length)
        ? windowMatchesFullRaw
        : ((windowMatchesRaw && windowMatchesRaw.length) ? windowMatchesRaw : windowMatches));
    return Array.isArray(base) ? base : [];
  }

  function hasSettledHistoryInMatches(matches) {
    return (matches || []).some((m) => {
      const cands = buildCandidatesForPerfBase(m, 0);
      return cands.some((c) => outcomeForCandidate(c) != null);
    });
  }

  function getModeOptimizationSource(matches, options = {}) {
    const source = getAllOptimizationMatches(matches);
    const windowId = String(options.windowId || MODE_OPTIMIZATION_CONFIG.recentWindowId);
    const referenceDate = getThresholdReferenceDate(options.referenceDate);
    const includeReferenceDay = options.includeReferenceDay != null
      ? !!options.includeReferenceDay
      : shouldIncludeReferenceDayInOptimization(referenceDate);

    if (windowId === MODE_OPTIMIZATION_CONFIG.fallbackWindowId) {
      return source;
    }

    const minDate = addDays(referenceDate, -MODE_OPTIMIZATION_CONFIG.recentDays);
    const frozenSource = source.filter((m) => {
      const dayKey = localDayKeyFromUTC(m);
      if (!dayKey) return false;
      if (dayKey < minDate) return false;
      return includeReferenceDay ? dayKey <= referenceDate : dayKey < referenceDate;
    });

    if (options.allowFullFallback === false) {
      return frozenSource;
    }

    // Sécurité : si la fenêtre récente est vide, on retombe sur la source élargie.
    return hasSettledHistoryInMatches(frozenSource) ? frozenSource : source;
  }

  function getThresholdOptimizationWindow(matches, referenceDate) {
    const resolvedDate = getThresholdReferenceDate(referenceDate);
    const recentMatches = getModeOptimizationSource(matches, {
      referenceDate: resolvedDate,
      windowId: MODE_OPTIMIZATION_CONFIG.recentWindowId,
      allowFullFallback: false,
    });
    const recentSettledCount = countSettledOptimizationCandidates(recentMatches);

    // On privilégie 30 jours pour lisser le bruit. Si le volume réglé est trop faible,
    // on bascule sur l'index historique global pour éviter des seuils trop bruités.
    if (recentSettledCount >= MODE_OPTIMIZATION_CONFIG.recentMinSettledPicks) {
      return {
        id: MODE_OPTIMIZATION_CONFIG.recentWindowId,
        sourceKind: "recent-matches",
        referenceDate: resolvedDate,
        matches: recentMatches,
        settledCount: recentSettledCount,
      };
    }

    if (picksPerfIdx) {
      return {
        id: MODE_OPTIMIZATION_CONFIG.fallbackWindowId,
        sourceKind: "historical-index",
        referenceDate: resolvedDate,
        matches: getAllOptimizationMatches(matches),
        settledCount: recentSettledCount,
      };
    }

    const loadedMatches = getModeOptimizationSource(matches, {
      referenceDate: resolvedDate,
      windowId: MODE_OPTIMIZATION_CONFIG.fallbackWindowId,
    });

    return {
      id: MODE_OPTIMIZATION_CONFIG.fallbackWindowId,
      sourceKind: "loaded-window",
      referenceDate: resolvedDate,
      matches: loadedMatches,
      settledCount: countSettledOptimizationCandidates(loadedMatches),
    };
  }

  function optimizationModeSuffix() {
    return optimizeWithTodayResults
      ? t.mode_hint_live_suffix
      : t.mode_hint_frozen_suffix;
  }

  function withOptimizationModeHint(msg) {
    if (!msg) return optimizationModeSuffix();
    return `${msg} ${optimizationModeSuffix()}`;
  }

  function syncOptimizeTodayUI() {
    if (chkOptimizeTodayResults) {
      chkOptimizeTodayResults.checked = optimizeWithTodayResults;
    }

    if (elOptimizeTodayHint) {
      elOptimizeTodayHint.textContent = optimizeWithTodayResults
        ? t.optimize_today_hint_live
        : t.optimize_today_hint_frozen;
    }
  }
  function defaultResultsViewMode() {
    // Mockup validé : la vue de scan est le point d'entrée sur desktop comme sur mobile.
    return "compact";
  }

  function persistResultsViewMode(mode) {
    try {
      localStorage.setItem(RESULTS_VIEW_STORAGE_KEY, mode);
    } catch (e) {}
  }

  function currentDeviceType() {
    return window.matchMedia && window.matchMedia("(max-width: 720px)").matches
      ? "mobile"
      : "desktop";
  }

  function trackResultsViewModeChange(mode, origin) {
    if (typeof window.gtag !== "function") return;
    window.gtag("event", "results_view_mode_changed", {
      view_mode: mode,
      origin,
      device_type: currentDeviceType(),
      page_path: window.location?.pathname || "/",
    });
  }

  // La page démarre TOUJOURS en vue compacte, indépendamment du dernier choix mémorisé.
  // L’utilisateur peut basculer en vue détaillée pendant sa session, mais un rechargement
  // revient systématiquement au mode de scan compact.
  const initialResultsViewMode = defaultResultsViewMode();
  compactModeEnabled = true;
  persistResultsViewMode("compact");
  optimizeWithTodayResults = readStoredOptimizeTodayResults();
  syncOptimizeTodayUI();
  if (elCompactMode) {
    elCompactMode.checked = compactModeEnabled;
  }

  function syncV2ViewSwitch() {
    elV2ViewButtons.forEach((button) => {
      const mode = String(button.getAttribute("data-tpv2-view") || "compact");
      const active = mode === (compactModeEnabled ? "compact" : "detailed");
      button.classList.toggle("is-active", active);
      button.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }

  function syncV2ListingControls() {
    if (elV2Sort && elSort) elV2Sort.value = elSort.value || "time";
    if (elV2HidePast && chkHidePast) elV2HidePast.checked = !!chkHidePast.checked;
    syncV2ViewSwitch();
  }

  syncV2ListingControls();

  function hasActiveNoAdsCache() {
    try {
      const raw = localStorage.getItem("fs_noads_cache");
      if (!raw) return false;
      const cached = JSON.parse(raw);
      return !!(
        cached &&
        cached.no_ads === true &&
        typeof cached.exp === "number" &&
        Date.now() < cached.exp
      );
    } catch (_) {
      return false;
    }
  }

  function shouldRenderInlineMatchAds() {
    return (
      !document.documentElement.classList.contains("user-no-ads") &&
      !hasActiveNoAdsCache()
    );
  }

  function createInlineMatchAdCard() {
    const adCard = document.createElement("div");
    const label = lang === "es" ? "Publicidad" : lang === "en" ? "Ad" : "Publicité";

    adCard.className = "tp-match-card tp-match-card--ad js-manual-ad";
    adCard.setAttribute("data-ad-slot", INLINE_MATCH_AD_SLOT);
    adCard.setAttribute("data-ad-placement", "top-pronostics-mid");
    adCard.setAttribute("aria-label", lang === "es" ? "Publicidad" : lang === "en" ? "Advertisement" : "Publicité");
    adCard.innerHTML = `
      <div class="tp-inline-ad-label" aria-hidden="true">${label}</div>
      <ins class="adsbygoogle"
           style="display:block"
           data-ad-client="${ADS_CLIENT}"
           data-ad-format="auto"
           data-full-width-responsive="false"></ins>
    `;

    return adCard;
  }

  function refreshInlineMatchAds() {
    if (typeof window.__fsManualAdsRefresh === "function") {
      window.__fsManualAdsRefresh();
      return;
    }
    if (typeof CustomEvent === "function") {
      document.dispatchEvent(
        new CustomEvent("fs-noads-status", { detail: { noAds: false } })
      );
    }
  }

  function appendMatchCardWithInlineAd(parent, card, state) {
    parent.appendChild(card);
    state.renderedMatchCards += 1;

    if (
      state.injectInlineAds &&
      state.renderedMatchCards % state.inlineAdInterval === 0
    ) {
      parent.appendChild(createInlineMatchAdCard());
      state.insertedInlineAd = true;
    }
  }

  async function preloadPicksPerf(options = {}){
    const revision = sourceRevision;
    try{
      const r = await fetch(API_PICKS_PERF, { cache: options.force ? "no-cache" : "default", headers: { Accept: "application/json" } });
      if (!r.ok) throw new Error("HTTP " + r.status);
      const payload = await r.json();
      const index = normalizeRemotePerformanceIndex(payload);
      if (!index) throw new Error("invalid automatic configuration");
      if (revision !== sourceRevision) return false;
      if (options.force) return { payload, index };
      picksPerfIdx = payload;
      topPronosticsPerformanceIndex = index;
      return true;
    } catch(e){
      console.warn("picks_perf_by_threshold preload failed", e);
      if (revision !== sourceRevision) return false;
      if (!options.force) {
        picksPerfIdx = null;
        topPronosticsPerformanceIndex = null;
      }
      return false;
    } finally {
      markTopPerf("performance_data_ready", { available: !!topPronosticsPerformanceIndex });
    }
  }

  function normalizeRemotePerformanceIndex(payload) {
    return selectionRules.readIndex(payload);
  }

  function normalizeRemoteModeThresholds(mode, rawThresholds) {
    const thresholds = {
      ...((rawThresholds && typeof rawThresholds === "object") ? rawThresholds : {}),
    };
    // v2 publishes 1X2=null because automatic modes use stability badges,
    // not a numeric probability threshold. Sliders still need a numeric
    // presentation value, while the badge policy remains authoritative.
    if (mode !== "all" && thresholds["1X2"] == null) {
      thresholds["1X2"] = mode === "performance"
        ? X12_FILTER_SCORE_CORRECT
        : X12_FILTER_SCORE_STABLE;
    }
    return normalizeThresholdPreset(
      thresholds,
      mode === "all" ? THRESHOLD_PRESETS.all : THRESHOLD_PRESETS.default
    );
  }

  function normalizeRemoteModeConfig(mode, raw, referenceDate) {
    if (!raw || typeof raw !== "object") return null;
    const thresholds = normalizeRemoteModeThresholds(mode, raw.thresholds);
    const leagues = Array.isArray(raw.leagues) ? raw.leagues.slice() : [];
    const source = topPronosticsPerformanceIndex?.source || {};
    return {
      mode,
      referenceDate: String(source.reference_date || getThresholdReferenceDate(referenceDate)),
      thresholds,
      leagues,
      stats: raw.stats || null,
      meta: {
        windowId: source.window_id || MODE_OPTIMIZATION_CONFIG.fallbackWindowId,
        windowLabel: source.window_id === MODE_OPTIMIZATION_CONFIG.recentWindowId
          ? `${MODE_OPTIMIZATION_CONFIG.recentDays}${lang === "fr" ? "j" : "d"}`
          : "hist.",
        sourceKind: source.source_kind || "service-index",
      },
      source: "service",
    };
  }

  function getRemoteBuiltInModeConfigs(referenceDate) {
    const modes = topPronosticsPerformanceIndex?.modes;
    if (!modes || typeof modes !== "object") return null;
    const out = {};
    for (const mode of ["all", "performance", "high", "ultra"]) {
      const cfg = normalizeRemoteModeConfig(mode, modes[mode], referenceDate);
      if (cfg) out[mode] = cfg;
    }
    return out.performance ? out : null;
  }


  // Leagues (inchangé)
  let LEAGUES = [
    { code:"LIGUE_1", name_fr:"Ligue 1", name_en:"Ligue 1", logo:"/logos/LIGUE_1/ligue_1.webp" },
    { code:"LIGUE_2", name_fr:"Ligue 2", name_en:"Ligue 2", logo:"/logos/LIGUE_2/ligue_2.webp" },
    { code:"PREMIER_LEAGUE", name_fr:"Premier League", name_en:"Premier League", logo:"/logos/PREMIER_LEAGUE/premier_league.webp" },
    { code:"CHAMPIONSHIP", name_fr:"Championship", name_en:"Championship", logo:"/logos/CHAMPIONSHIP/championship.webp" },
    { code:"CHAMPIONSLEAGUE", name_fr:"Ligue des champions", name_en:"Champions League", logo:"/logos/CHAMPIONSLEAGUE/championsleague.webp" },
    { code:"EUROPALEAGUE", name_fr:"Europa League", name_en:"Europa League", logo:"/logos/EUROPALEAGUE/europaleague.webp" },
    { code:"CONFERENCELEAGUE", name_fr:"Conference League", name_en:"Conference League", logo:"/logos/CONFERENCELEAGUE/conferenceleague.webp" },
    { code:"INT_FRIENDLIES", name_fr:"Matchs amicaux internationaux", name_en:"International Friendlies", logo:"/logos/INT_FRIENDLIES/int_friendlies.webp" },
    { code:"WORLD_CUP_2026", name_fr:"Coupe du Monde 2026", name_en:"World Cup 2026", logo:"/logos/WORLD_CUP_2026/world_cup_2026.webp" },
    { code:"UEFA_NATIONS_LEAGUE", name_fr:"Ligue des nations de l’UEFA", name_en:"UEFA Nations League", name_es:"Liga de Naciones de la UEFA", logo:"/logos/INT_FRIENDLIES/int_friendlies.webp" },
    { code:"AFCON_QUALIFICATION", name_fr:"Qualifications à la Coupe d’Afrique des nations", name_en:"Africa Cup of Nations Qualification", name_es:"Clasificación para la Copa Africana de Naciones", logo:"/logos/INT_FRIENDLIES/int_friendlies.webp" },
    { code:"CONCACAF_NATIONS_LEAGUE", name_fr:"Ligue des nations de la CONCACAF", name_en:"CONCACAF Nations League", name_es:"Liga de Naciones de la CONCACAF", logo:"/logos/INT_FRIENDLIES/int_friendlies.webp" },
    { code:"BDL", name_fr:"Bundesliga", name_en:"Bundesliga", logo:"/logos/BDL/bdl.webp" },
    { code:"BDL2", name_fr:"Bundesliga 2", name_en:"Bundesliga 2", logo:"/logos/BDL2/bdl2.webp" },
    { code:"SERIEA", name_fr:"Serie A", name_en:"Serie A", logo:"/logos/SERIEA/seriea.webp" },
    { code:"SERIEB", name_fr:"Serie B", name_en:"Serie B", logo:"/logos/SERIEB/serieb.webp" },
    { code:"LIGA", name_fr:"La Liga", name_en:"La Liga", logo:"/logos/LIGA/liga.webp" },
    { code:"LIGA2", name_fr:"La Liga 2", name_en:"La Liga 2", logo:"/logos/LIGA2/liga2.webp" },
    { code:"SCOTLAND", name_fr:"Scottish Premiership", name_en:"Scottish Premiership", logo:"/logos/SCOTLAND/scotland.webp" },
    { code:"GREECE", name_fr:"Super League Grèce", name_en:"Super League Greece", logo:"/logos/GREECE/greece.webp" },
    { code:"CZECH", name_fr:"Liga Tchèque", name_en:"Czech Liga", logo:"/logos/CZECH/czech.webp" },
    { code:"AUSTRIA", name_fr:"Bundesliga Autrichienne", name_en:"Austrian Bundesliga", logo:"/logos/AUSTRIA/austria.webp" },
    { code:"POLAND", name_fr:"Ekstraklasa", name_en:"Ekstraklasa", logo:"/logos/POLAND/poland.webp" },
    { code:"CROATIA", name_fr:"HNL Croatie", name_en:"Croatian HNL", logo:"/logos/CROATIA/croatia.webp" },
    { code:"ROMANIA", name_fr:"Superliga Roumanie", name_en:"Romanian Superliga", logo:"/logos/ROMANIA/romania.webp" },
    { code:"RUSSIA", name_fr:"Russian Premier League", name_en:"Russian Premier League", logo:"/logos/RUSSIA/russia.webp" },
    { code:"UKRAINE", name_fr:"Ukrainian Premier League", name_en:"Ukrainian Premier League", logo:"/logos/UKRAINE/ukraine.webp" },
    { code:"PORT", name_fr:"Liga Portugal", name_en:"Liga Portugal", logo:"/logos/PORT/port.webp" },
    { code:"PORT2", name_fr:"Liga Portugal 2", name_en:"Liga Portugal 2", logo:"/logos/PORT2/port2.webp" },
    { code:"BEL", name_fr:"Jupiler league", name_en:"Jupiler Pro League", logo:"/logos/BEL/bel.webp" },
    { code:"BRE", name_fr:"D1 Brésil", name_en:"Brazil Série A", logo:"/logos/BRE/bre.webp" },
    { code:"ARGENTINA", name_fr:"Liga Profesional", name_en:"Liga Profesional", logo:"/logos/ARGENTINA/argentina.webp" },
    { code:"LIGAMX", name_fr:"Liga MX", name_en:"Liga MX", logo:"/logos/LIGAMX/ligamx.webp" },
    { code:"JAP", name_fr:"J1 league", name_en:"J1 League", logo:"/logos/JAP/jap.webp" },
    { code:"COR", name_fr:"L1 Corée", name_en:"K League 1", logo:"/logos/COR/cor.webp" },
    { code:"MLS", name_fr:"MLS", name_en:"MLS", logo:"/logos/MLS/mls.webp" },
    { code:"CANADA", name_fr:"Canadian Premier League", name_en:"Canadian Premier League", logo:"/logos/CANADA/canada.webp" },
    { code:"NOR", name_fr:"L1 Norvège", name_en:"Eliteserien (Norway)", logo:"/logos/NOR/nor.webp" },
    { code:"SUE", name_fr:"L1 Suède", name_en:"Allsvenskan (Sweden)", logo:"/logos/SUE/sue.webp" },
    { code:"FIN", name_fr:"L1 Finlande", name_en:"Veikkausliiga (Finland)", logo:"/logos/FIN/fin.webp" },
    { code:"ISL", name_fr:"Besta deildin", name_en:"Besta deildin", logo:"/logos/ISL/isl.webp" },
    { code:"IRL", name_fr:"League of Ireland", name_en:"League of Ireland", logo:"/logos/IRL/irl.webp" },
    { code:"CHN", name_fr:"Chinese super league", name_en:"Chinese Super League", logo:"/logos/CHN/chn.webp" },
    { code:"SAUDI", name_fr:"Saudi Pro League", name_en:"Saudi Pro League", logo:"/logos/SAUDI/saudi.webp" },
    { code:"AUSTRALIE", name_fr:"A-League", name_en:"A-League", logo:"/logos/AUSTRALIE/australie.webp" },
    { code:"NL", name_fr:"Eredivisie", name_en:"Eredivisie", logo:"/logos/NL/nl.webp" },
    { code:"CH", name_fr:"Super Ligue", name_en:"Super Ligue", logo:"/logos/CH/ch.webp" },
    { code:"TUR", name_fr:"Süperlig", name_en:"Süperlig", logo:"/logos/TUR/tur.webp" },
    { code:"DAN", name_fr:"Superliga", name_en:"Superliga", logo:"/logos/DAN/dan.webp" },
    { code:"CHILE", name_fr:"Primera División du Chili", name_en:"Chilean Primera División", name_es:"Primera División de Chile", logo:"/logos/CHILE/chile.webp" },
    { code:"INDIA", name_fr:"Indian Super League", name_en:"Indian Super League", name_es:"Indian Super League", logo:"/logos/INDIA/india.webp" },
    { code:"LIBERTADORES", name_fr:"CONMEBOL Libertadores", name_en:"CONMEBOL Libertadores", name_es:"CONMEBOL Libertadores", logo:"/logos/LIBERTADORES/libertadores.webp" },
    { code:"PERU", name_fr:"Liga 1 du Pérou", name_en:"Peruvian Liga 1", name_es:"Liga 1 de Perú", logo:"/logos/PERU/peru.webp" },
    { code:"SUDAMERICANA", name_fr:"CONMEBOL Sudamericana", name_en:"CONMEBOL Sudamericana", name_es:"CONMEBOL Sudamericana", logo:"/logos/SUDAMERICANA/sudamericana.webp" },
    { code:"SOUTH_AFRICA", name_fr:"Premier Soccer League sud-africaine", name_en:"South African Premier Soccer League", name_es:"Premier Soccer League de Sudáfrica", logo:"/logos/SOUTH_AFRICA/southafrica.webp" },
    { code:"ALGERIA_LIGUE_1", name_fr:"Ligue 1 algérienne", name_en:"Algerian Ligue 1", name_es:"Ligue 1 de Argelia", logo:"/logos/ALGERIA_LIGUE_1/algeria_ligue_1.webp" },
    { code:"MOROCCO_BOTOLA_PRO", name_fr:"Botola Pro marocaine", name_en:"Moroccan Botola Pro", name_es:"Botola Pro de Marruecos", logo:"/logos/MOROCCO_BOTOLA_PRO/morocco_botola_pro.webp" },
    { code:"EGYPT_PREMIER_LEAGUE", name_fr:"Premier League égyptienne", name_en:"Egyptian Premier League", name_es:"Premier League de Egipto", logo:"/logos/EGYPT_PREMIER_LEAGUE/egypt_premier_league.webp" },
    { code:"HUNGARY_NB_I", name_fr:"NB I hongroise", name_en:"Hungarian NB I", name_es:"NB I de Hungría", logo:"/logos/HUNGARY_NB_I/hungary_nb_i.webp" }
  ];
  const LEAGUE_COUNTRY_CODES = Object.freeze({
    LIGUE_1: "fr", LIGUE_2: "fr", PREMIER_LEAGUE: "gb", CHAMPIONSHIP: "gb",
    BDL: "de", BDL2: "de", SERIEA: "it", SERIEB: "it", LIGA: "es", LIGA2: "es",
    SCOTLAND: "gb", GREECE: "gr", CZECH: "cz", AUSTRIA: "at", POLAND: "pl",
    CROATIA: "hr", ROMANIA: "ro", RUSSIA: "ru", UKRAINE: "ua", PORT: "pt",
    PORT2: "pt", BEL: "be", BRE: "br", ARGENTINA: "ar", LIGAMX: "mx", JAP: "jp",
    COR: "kr", MLS: "us", CANADA: "ca", NOR: "no", SUE: "se", FIN: "fi", ISL: "is",
    IRL: "ie", CHN: "cn", SAUDI: "sa", AUSTRALIE: "au", DAN: "dk", CH: "ch",
    NL: "nl", TUR: "tr", CHILE: "cl", INDIA: "in", PERU: "pe", SOUTH_AFRICA: "za",
    ALGERIA_LIGUE_1: "dz", MOROCCO_BOTOLA_PRO: "ma", EGYPT_PREMIER_LEAGUE: "eg",
    HUNGARY_NB_I: "hu"
  });

  function renderLeagueCountryFlag(code, className = "tp-league-country-flag") {
    const countryCode = LEAGUE_COUNTRY_CODES[String(code || "").toUpperCase()] || "";
    if (!countryCode) return "";
    return `<img class="${className}" src="https://flagcdn.com/w40/${countryCode}.png" width="20" height="14" loading="lazy" decoding="async" alt="" aria-hidden="true">`;
  }
  const FORCED_VISIBLE_LEAGUES = Object.freeze(["RUSSIA", "UKRAINE"]);
  // Sources internationales: affichage explicite, sans exclusion des stats
  // quand le backend les expose dans l'index de performance.
  const EXPERIMENTAL_LEAGUES = Object.freeze(
    new Set([
      "INT_FRIENDLIES", "WORLD_CUP_2026", "UEFA_NATIONS_LEAGUE",
      "AFCON_QUALIFICATION", "CONCACAF_NATIONS_LEAGUE"
    ])
  );
  // Intégration transverse Coupe du Monde 2026 (flag partagé).
  const WC2026_CROSS_PAGE =
    typeof window.fsWorldCup2026CrossPageEnabled === "function" &&
    window.fsWorldCup2026CrossPageEnabled("top_pronostics");
  if (!WC2026_CROSS_PAGE) {
    LEAGUES = LEAGUES.filter((l) => l.code !== "WORLD_CUP_2026");
  }

  function isWorldCup2026League(code) {
    return String(code || "").trim().toUpperCase() === "WORLD_CUP_2026";
  }

  function withForcedVisibleLeagues(codes){
    const selected = new Set(
      (Array.isArray(codes) ? codes : [])
        .map((code) => String(code || "").toUpperCase())
        .filter(Boolean)
    );
    FORCED_VISIBLE_LEAGUES.forEach((code) => selected.add(code));
    return Array.from(selected);
  }

  function toRootAssetPath(path){
    const raw = String(path || "").trim();
    if (!raw) return "";
    if (/^(?:https?:)?\/\//i.test(raw) || raw.startsWith("/")) return raw;
    return `/${raw.replace(/^\.?\//, "")}`;
  }

  function marketKeyForCandidate(c){
    if (c.type === "1X2") return "1x2";
    if (c.type === "DC")  return "double_chance";
    if (c.type === "DNB") return "dnb";
    if (c.type === "TOT"){
      if (c.sub === "U2.5") return "under25";
      if (c.sub === "O2.5") return "over25";
      if (c.sub === "O1.5") return "over15";
      if (c.sub === "U3.5") return "under35";
      if (c.sub === "BTTS") return "btts";
    }
    return null;
  }

  function confidenceLeagueForCandidate(c) {
    return (c.league || "").toUpperCase() || "all";
  }

  function confidenceThresholdKeyForCandidate(c) {
    let thr = parseInt(c._thr ?? c.prob ?? 0, 10);
    if (!Number.isFinite(thr)) thr = 0;
    thr = Math.max(20, Math.min(80, thr));
    return String(thr);
  }

  function legacyConfidenceCellForCandidate(mk, league, tkey) {
    return (
      picksPerfIdx?.data?.[mk]?.[league]?.[tkey]
      ?? picksPerfIdx?.data?.[mk]?.all?.[tkey]
      ?? null
    );
  }

  function outcomeConfidenceCellForCandidate(mk, league, tkey, pickCode) {
    if (mk !== "1x2" && mk !== "double_chance") return null;

    const thresholdCell = (
      picksPerfIdx?.outcome_data?.[mk]?.[league]?.[tkey]
      ?? picksPerfIdx?.outcome_data?.[mk]?.all?.[tkey]
      ?? null
    );
    if (!thresholdCell || typeof thresholdCell !== "object") return null;

    if (mk === "double_chance") {
      const normalizedPickCode = String(pickCode || "").trim().toUpperCase();
      if (!normalizedPickCode) return null;
      return thresholdCell?.pick_codes?.[normalizedPickCode] ?? null;
    }

    return thresholdCell;
  }

  function confidenceMetricsForCandidate(c) {
    const mk = marketKeyForCandidate(c);
    if (!mk) return null;

    const league = confidenceLeagueForCandidate(c);
    const tkey = confidenceThresholdKeyForCandidate(c);
    const outcomeCell = outcomeConfidenceCellForCandidate(mk, league, tkey, c?.sub);
    const cell = outcomeCell ?? legacyConfidenceCellForCandidate(mk, league, tkey);
    if (!cell || typeof cell !== "object") return null;

    const sr = (cell.sr_final != null) ? cell.sr_final : cell.sr;
    const total = Number(cell.total ?? cell.match_count ?? 0);

    return {
      cell,
      sr,
      total,
      source: cell.confidence_source ?? cell.source ?? null,
    };
  }

  function displayedPickConfidenceForCandidate(c) {
    const mk = marketKeyForCandidate(c);

    if (mk === "1x2") {
      const matchConfidenceFinal = toPercentValue(c?.confidence_final_raw);
      if (Number.isFinite(matchConfidenceFinal)) return matchConfidenceFinal;

      const matchConfidenceRaw = toPercentValue(c?.confidence_raw);
      if (Number.isFinite(matchConfidenceRaw)) return matchConfidenceRaw;
    }

    const routedConfidence = toPercentValue(c?._conf);
    if (Number.isFinite(routedConfidence)) return routedConfidence;

    return null;
  }

  function sortablePickConfidenceForCandidate(c) {
    const value = displayedPickConfidenceForCandidate(c);
    return Number.isFinite(value) ? value : 0;
  }

  const formatLeagueName = (code) => {
    const L = LEAGUES.find((l) => l.code === code);
    if (!L) return code;
    if (lang === "es") return L.name_es || L.name_en || L.name_fr || code;
    return lang === "en" ? (L.name_en || L.name_fr || code) : (L.name_fr || L.name_en || code);
  };

  function isExperimentalLeague(code) {
    return EXPERIMENTAL_LEAGUES.has(String(code || "").trim().toUpperCase());
  }

  function renderExperimentalBadge(code) {
    if (isWorldCup2026League(code)) {
      const wcLabel = lang === "es" ? "Mundial 2026" : lang === "en" ? "World Cup 2026" : "Coupe du Monde 2026";
      return `<span class="fs-experimental-badge fs-experimental-badge--worldcup">${escapeHtml(wcLabel)}</span>`;
    }
    if (!isExperimentalLeague(code)) return "";
    const label = lang === "es" ? "Internacional" : lang === "en" ? "International" : "International";
    return `<span class="fs-experimental-badge fs-experimental-badge--warning">${escapeHtml(label)}</span>`;
  }

  // Section dédiée Coupe du Monde 2026 : rend les picks CDM dans leur propre
  // bloc pour une lecture claire, tout en conservant les stats backend.
  async function renderWorldCupDedicatedSection(candidates) {
    if (!WC2026_CROSS_PAGE || !Array.isArray(candidates) || !candidates.length) {
      return null;
    }
    const cfg = window.FS_WORLD_CUP_2026 || {};
    const title = lang === "es"
      ? "Mundial 2026 - pronósticos dedicados"
      : lang === "en"
      ? (cfg.section_title_en || "World Cup 2026 — dedicated predictions")
      : (cfg.section_title_fr || "Coupe du Monde 2026 — pronostics dédiés");
    const linkLabel = lang === "es" ? "Todos los partidos del Mundial →" : lang === "en" ? "All World Cup matches →" : "Tous les matchs Coupe du Monde →";
    const note = lang === "es"
      ? "Pronósticos de torneo incluidos en las estadísticas cuando el backend los expone."
      : lang === "en"
      ? "Tournament picks are included in performance stats when exposed by the backend."
      : "Pronostics de tournoi inclus dans les statistiques quand le backend les expose.";

    const section = document.createElement("section");
    section.className = "tp-worldcup-section";
    const hubUrl = typeof window.fsWorldCup2026HubUrl === "function"
      ? window.fsWorldCup2026HubUrl(lang)
      : (lang === "es" ? "/es/copa-del-mundo-2026.html" : lang === "en" ? "/en/world-cup-2026.html" : "/coupe-du-monde-2026.html");
    const head = document.createElement("div");
    head.className = "tp-worldcup-section__head";
    head.innerHTML =
      `<span class="tp-worldcup-section__title">${escapeHtml(title)}</span>` +
      `<a class="tp-worldcup-section__link" href="${escapeHtml(hubUrl)}">${escapeHtml(linkLabel)}</a>`;
    section.appendChild(head);
    const noteEl = document.createElement("p");
    noteEl.className = "tp-worldcup-section__note";
    noteEl.textContent = note;
    section.appendChild(noteEl);

    const byMatch = new Map();
    for (const c of candidates) {
      const mk = `${c.league}|${c.utc}|${c.home}|${c.away}`;
      if (!byMatch.has(mk)) byMatch.set(mk, []);
      byMatch.get(mk).push(c);
    }
    let entries = Array.from(byMatch.entries());
    if (chkHideFinishedDay && chkHideFinishedDay.checked) {
      entries = entries.filter(([mk, picks]) => !matchHasAnySettledPick(picks));
    }
    entries.sort((A, B) => parseUtcTime(A[1][0]) - parseUtcTime(B[1][0]));

    for (const [mk, picks] of entries) {
      picks.sort((a, b) => (b.prob - a.prob) || (sortablePickConfidenceForCandidate(b) - sortablePickConfidenceForCandidate(a)));
      const el = await renderMatchCard(mk, picks);
      section.appendChild(el);
      queueDeferredMatchLink(el);
    }
    return entries.length ? section : null;
  }

  const LEAGUE_RESULTS_SLUG = Object.freeze({
    LIGUE_1: "ligue-1",
    LIGUE_2: "ligue-2",
    PREMIER_LEAGUE: "premier-league",
    CHAMPIONSHIP: "championship",
    SERIEA: "serie-a",
    SERIEB: "serie-b",
    LIGA: "laliga",
    LIGA2: "laliga-2",
    BDL: "bundesliga",
    BDL2: "bundesliga-2",
    PORT: "primeira-liga",
    PORT2: "segunda-liga",
    BRE: "brasileirao",
    BEL: "jupiler-pro-league",
    JAP: "j-league",
    NOR: "eliteserien",
    COR: "kor-k-league",
    MLS: "mls",
    SUE: "allsvenskan",
    CHN: "chinese-super-league",
    FIN: "veikkausliiga",
    ISL: "besta-deildin",
    IRL: "league-of-ireland",
    DAN: "superliga",
    CH: "superligue",
    TUR: "superlig",
    NL: "eredivisie",
    CHAMPIONSLEAGUE: "champions-league",
    EUROPALEAGUE: "europa-league",
    CANADA: "canadian-premier-league",
    AUSTRALIE: "a-league",
    SCOTLAND: "scottish-premiership",
    GREECE: "super-league-greece",
    CZECH: "czech-liga",
    CONFERENCELEAGUE: "conference-league",
    ARGENTINA: "liga-profesional",
    LIGAMX: "liga-mexico",
    AUSTRIA: "austrian-bundesliga",
    POLAND: "ekstraklasa",
    CROATIA: "croatia-hnl",
    ROMANIA: "superliga-romania",
    RUSSIA: "russian-premier-league",
    UKRAINE: "ukrainian-premier-league",
    INT_FRIENDLIES: "international-friendlies",
    UEFA_NATIONS_LEAGUE: "uefa-nations-league",
    AFCON_QUALIFICATION: "africa-cup-of-nations-qualification",
    CONCACAF_NATIONS_LEAGUE: "concacaf-nations-league",
    SAUDI: "saudi-pro-league",
    CHILE: "primera-division-chile",
    INDIA: "indian-super-league",
    LIBERTADORES: "copa-libertadores",
    PERU: "liga-1-peru",
    SUDAMERICANA: "copa-sudamericana",
    SOUTH_AFRICA: "south-africa-premier-soccer-league",
  });

  function getLeaguePredictionHref(leagueCode) {
    // Coupe du Monde : page produit dédiée plutôt que le hub ligue générique.
    if (isWorldCup2026League(leagueCode)) {
      return typeof window.fsWorldCup2026HubUrl === "function"
        ? window.fsWorldCup2026HubUrl(lang)
        : (lang === "es" ? "/es/copa-del-mundo-2026.html" : lang === "en" ? "/en/world-cup-2026.html" : "/coupe-du-monde-2026.html");
    }
    const slug = LEAGUE_RESULTS_SLUG[leagueCode];
    const fallback = lang === "es" ? "/es/predicciones.html" : lang === "en" ? "/en/predictions.html" : "/predictions.html";
    if (!slug) return fallback;
    if (lang === "es") return `/es/pronostico-${slug}.html`;
    if (lang === "en") return `/en/${slug}-predictions.html`;
    return `/pronostic-${slug}.html`;
  }

  // Utils
  function isSettledCandidate(c){
    // settled = outcome non null => score final dispo (win/lose/void)
    return outcomeForCandidate(c) != null;
  }

  function matchHasAnySettledPick(picks){
    return picks.some(isSettledCandidate);
  }

  function pad2(n){ return String(n).padStart(2, "0"); }

  // YYYY-MM-DD *en heure locale*
  function isoLocalDate(d = new Date()){
    return `${d.getFullYear()}-${pad2(d.getMonth()+1)}-${pad2(d.getDate())}`;
  }

  const parseLocalDateISO = (iso) => {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso || ""));
    if (!match) return null;

    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    const d = new Date(year, month - 1, day);

    if (d.getFullYear() !== year || d.getMonth() !== month - 1 || d.getDate() !== day) return null;
    return d;
  };

  // Résout uniquement l'instant canonique kickoff_iso.
  function parseFrenchDateTime(match){
    if (window.fsDateTime && typeof window.fsDateTime.parseMatchInstant === "function") {
      return window.fsDateTime.parseMatchInstant(match);
    }
    const raw = match && typeof match === "object" ? match.kickoff_iso : match;
    if (!raw || !(/[Zz]$/.test(raw) || /[+\-]\d{2}(?::?\d{2})?$/.test(raw))) return null;
    const d = new Date(raw);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  // Convertit un timestamp en YYYY-MM-DD en heure locale navigateur.
  function localDayKeyFromUTC(match){
    if (!match) return "";
    if (window.fsDateTime && typeof window.fsDateTime.localDayKey === "function") {
      return window.fsDateTime.localDayKey(match);
    }
    const d = parseFrenchDateTime(match);
    if (d) return isoLocalDate(d);
    return "";
  }

  const todayISO = () => isoLocalDate(new Date());

  const addDays = (iso, n) => {
    const d = parseLocalDateISO(iso);
    if (!d) return "";
    d.setDate(d.getDate() + n);
    return isoLocalDate(d);
  };

  const isNum = (v) => typeof v === "number" && isFinite(v);
  const pct = (v) => (v == null ? null : Number(v));
  const _teamFormByLeagueCache = new Map();

  function teamFormMapFromTeams(teams) {
    const map = new Map();
    Object.entries(teams || {}).forEach(([teamName, metrics]) => {
      if (!metrics || typeof metrics !== "object") return;
      map.set(normTeamKey(teamName), {
        form_index: Number.isFinite(Number(metrics?.form_index))
          ? Number(metrics.form_index)
          : null,
        current_win_streak: Number.isFinite(Number(metrics?.current_win_streak))
          ? Number(metrics.current_win_streak)
          : null,
        current_unbeaten_streak: Number.isFinite(Number(metrics?.current_unbeaten_streak))
          ? Number(metrics.current_unbeaten_streak)
          : null,
        current_loss_streak: Number.isFinite(Number(metrics?.current_loss_streak))
          ? Number(metrics.current_loss_streak)
          : null,
        last_results: typeof metrics?.last_results === "string" ? metrics.last_results : "",
        recent_points_per_match: Number.isFinite(Number(metrics?.recent_points_per_match))
          ? Number(metrics.recent_points_per_match)
          : null,
        recent_matches: Number.isFinite(Number(metrics?.recent_matches))
          ? Number(metrics.recent_matches)
          : null,
        matches_played: Number.isFinite(Number(metrics?.matches_played))
          ? Number(metrics.matches_played)
          : null,
        goals_for: Number.isFinite(Number(metrics?.goals_for))
          ? Number(metrics.goals_for)
          : null,
        goals_against: Number.isFinite(Number(metrics?.goals_against))
          ? Number(metrics.goals_against)
          : null,
        avg_goals_for: Number.isFinite(Number(metrics?.avg_goals_for))
          ? Number(metrics.avg_goals_for)
          : null,
        avg_goals_against: Number.isFinite(Number(metrics?.avg_goals_against))
          ? Number(metrics.avg_goals_against)
          : null
      });
    });
    return map;
  }

  function toPercentValue(raw) {
    const n = Number(raw);
    if (!Number.isFinite(n)) return null;
    if (n >= 0 && n <= 1) return n * 100;
    if (n >= 0 && n <= 100) return n;
    return null;
  }

  function toFiniteNumber(raw) {
    if (raw == null) return null;
    if (typeof raw === "string" && raw.trim() === "") return null;
    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
  }

  function normalizeProbabilityShare(raw) {
    const pctValue = toPercentValue(raw);
    return Number.isFinite(pctValue) ? pctValue / 100 : 0;
  }

  function get1X2OutcomeRanking(match) {
    return [
      { key: "home", share: normalizeProbabilityShare(match?.p_home), index: 0 },
      { key: "draw", share: normalizeProbabilityShare(match?.p_draw), index: 1 },
      { key: "away", share: normalizeProbabilityShare(match?.p_away), index: 2 },
    ].sort((a, b) => b.share - a.share || a.index - b.index);
  }

  function normalizeApi1X2StabilityBadgeKey(rawBadge) {
    const value = String(rawBadge || "").trim().toLowerCase();
    if (value === "ultra_stable" || value === "ultra-stable") return "ultra_stable";
    if (value === "stable" || value === "correct" || value === "risk") return value;
    if (value === "fair") return "correct";
    return "";
  }

  function readApi1X2StabilityBadgeKey(match) {
    const stability1x2 = match?.stability_1x2;
    const stability1x2FromObject =
      stability1x2 && typeof stability1x2 === "object"
        ? (stability1x2.badge ?? stability1x2.key ?? stability1x2.level ?? "")
        : stability1x2;

    const candidates = [
      match?._x12Badge,
      match?._stability_badge,
      match?.stability_badge,
      match?.stabilityBadge,
      stability1x2FromObject,
      match?.["stability_badge"],
    ];

    for (const candidate of candidates) {
      const normalized = normalizeApi1X2StabilityBadgeKey(candidate);
      if (normalized) return normalized;
    }
    return "";
  }

  function get1X2StabilityBadge(match) {
    const key = readApi1X2StabilityBadgeKey(match);
    return { key: key || "risk" };
  }

  function get1X2FilterScoreFromBadgeKey(badgeKey) {
    if (badgeKey === "ultra_stable") return X12_FILTER_SCORE_STABLE;
    if (badgeKey === "stable") return X12_FILTER_SCORE_STABLE;
    if (badgeKey === "correct") return X12_FILTER_SCORE_CORRECT;
    return 0;
  }

  function get1X2LevelFromThreshold(raw) {
    return Number(raw) >= X12_FILTER_SCORE_STABLE
      ? X12_LEVEL_STABLE_ONLY
      : X12_LEVEL_CORRECT_PLUS;
  }

  function get1X2LevelForActiveMode(raw) {
    if (isBuiltInAutomaticSelection()) {
      if (activeDisplayMode === "ultra") return X12_LEVEL_ULTRA_ONLY;
      if (activeDisplayMode === "high") return X12_LEVEL_STABLE_ONLY;
      if (activeDisplayMode === "performance") return X12_LEVEL_CORRECT_PLUS;
    }
    return get1X2LevelFromThreshold(raw);
  }

  function get1X2ThresholdForLevel(level) {
    return level === X12_LEVEL_STABLE_ONLY || level === X12_LEVEL_ULTRA_ONLY
      ? X12_FILTER_SCORE_STABLE
      : X12_FILTER_SCORE_CORRECT;
  }

  function get1X2LevelLabel(level) {
    if (level === X12_LEVEL_ULTRA_ONLY) return lang === "es" ? "Muy estable" : lang === "en" ? "Very stable" : "Très stable";
    if (level === X12_LEVEL_STABLE_ONLY) return "Stable";
    return "Correct+";
  }

  function get1X2BadgePresentation(badgeKey) {
    if (badgeKey === "ultra_stable") {
      return { value: lang === "es" ? "Muy estable" : lang === "en" ? "Very stable" : "Très stable", tone: "focus" };
    }
    if (badgeKey === "stable") {
      return { value: "Stable", tone: "positive" };
    }
    if (badgeKey === "correct") {
      return { value: "Correct+", tone: "warn" };
    }
    return { value: lang === "es" ? "Riesgo" : lang === "en" ? "Risk" : "Risque", tone: "neutral" };
  }

  function getPrimary1X2BadgeFromPicks(picks) {
    const primary1X2 = (Array.isArray(picks) ? picks : []).find((pick) => {
      return pick?.type === "1X2" && typeof pick?._x12Badge === "string";
    });
    return primary1X2 ? get1X2BadgePresentation(String(primary1X2._x12Badge || "")) : null;
  }

  function normalize1X2ControlValue(raw) {
    return get1X2ThresholdForLevel(get1X2LevelFromThreshold(raw));
  }

  function matches1X2BadgeLevel(badgeKey, level) {
    if (level === X12_LEVEL_ULTRA_ONLY) return badgeKey === "ultra_stable";
    if (level === X12_LEVEL_STABLE_ONLY) return badgeKey === "ultra_stable" || badgeKey === "stable";
    return badgeKey === "ultra_stable" || badgeKey === "stable" || badgeKey === "correct";
  }

  function buildPrimary1X2Candidate(match) {
    const homeProb = pct(match?.p_home);
    const drawProb = pct(match?.p_draw);
    const awayProb = pct(match?.p_away);
    const trio = [];

    if (isNum(homeProb)) trio.push({ k: "1", team: localizeTeamLabel(match?.home, match?.league), v: homeProb });
    if (isNum(drawProb)) trio.push({ k: "N", team: "Draw", v: drawProb });
    if (isNum(awayProb)) trio.push({ k: "2", team: localizeTeamLabel(match?.away, match?.league), v: awayProb });
    trio.sort((a, b) => b.v - a.v);

    if (!trio.length) return null;

    const badge = get1X2StabilityBadge({
      ...match,
      p_home: homeProb,
      p_draw: drawProb,
      p_away: awayProb,
    });

    return {
      type: "1X2",
      sub: trio[0].k,
      label: t.label_1x2(trio[0].k, trio[0].team),
      prob: trio[0].v,
      _x12Badge: badge.key,
      _filterScore: get1X2FilterScoreFromBadgeKey(badge.key),
    };
  }

  function buildLinkedDoubleChanceCandidates(match, primary1X2) {
    if (!primary1X2 || primary1X2.type !== "1X2" || !["ultra_stable", "stable"].includes(primary1X2._x12Badge)) {
      return [];
    }

    const ph = pct(match?.p_home);
    const pd = pct(match?.p_draw);
    const pa = pct(match?.p_away);
    let dc1x = pct(match?.double_chance_1x);
    let dcx2 = pct(match?.double_chance_x2);

    if (!isNum(dc1x) && isNum(ph) && isNum(pd)) dc1x = ph + pd;
    if (!isNum(dcx2) && isNum(pa) && isNum(pd)) dcx2 = pa + pd;

    if (primary1X2.sub === "1" && isNum(dc1x)) {
      return [{ type: "DC", sub: "1X", label: t.label_dc1x(localizeTeamLabel(match?.home, match?.league)), prob: dc1x }];
    }
    if (primary1X2.sub === "2" && isNum(dcx2)) {
      return [{ type: "DC", sub: "X2", label: t.label_dcx2(localizeTeamLabel(match?.away, match?.league)), prob: dcx2 }];
    }
    if (primary1X2.sub === "N") {
      const out = [];
      if (isNum(dc1x)) out.push({ type: "DC", sub: "1X", label: t.label_dc1x(localizeTeamLabel(match?.home, match?.league)), prob: dc1x });
      if (isNum(dcx2)) out.push({ type: "DC", sub: "X2", label: t.label_dcx2(localizeTeamLabel(match?.away, match?.league)), prob: dcx2 });
      return out;
    }

    return [];
  }

  function getCandidateFilterScore(candidate) {
    if (!candidate) return 0;
    if (candidate.type === "1X2") {
      const direct = Number(candidate._filterScore);
      if (Number.isFinite(direct)) return direct;
      return get1X2FilterScoreFromBadgeKey(String(candidate._x12Badge || ""));
    }
    return Number(candidate.prob) || 0;
  }

  function getCurrent1X2Level() {
    return get1X2LevelForActiveMode(elMin1X2?.value);
  }

  function fmtPercent(raw, digits = 1) {
    const n = Number(raw);
    if (!Number.isFinite(n)) return t.details_na;
    return `${n.toFixed(digits)}%`;
  }

  function fmtNumber(raw, digits = 2) {
    const n = Number(raw);
    if (!Number.isFinite(n)) return t.details_na;
    return n.toFixed(digits);
  }

  function clampNumber(raw, min, max) {
    const n = Number(raw);
    if (!Number.isFinite(n)) return null;
    return Math.max(min, Math.min(max, n));
  }

  function renderReadingStat(label, value, options = {}) {
    const classes = options.classes || "";
    const pct = clampNumber(options.percent, 0, 100);
    const meterClass = Number.isFinite(pct) ? "has-meter" : "no-meter";
    const styleAttr = Number.isFinite(pct) ? ` style="--tp-stat-pct:${pct.toFixed(1)}%;"` : "";
    return `
      <span class="tp-reading-stat ${classes} ${meterClass}"${styleAttr}>
        <span class="tp-reading-stat__meta">${label}</span>
        <strong class="tp-reading-stat__num">${value}</strong>
        ${Number.isFinite(pct) ? '<span class="tp-reading-stat__meter" aria-hidden="true"><span class="tp-reading-stat__fill"></span></span>' : ""}
      </span>
    `.trim();
  }

  function renderReadingContextTokens(rawText, variant = "form") {
    const raw = String(rawText || "").trim();
    if (!raw || raw === t.details_na) {
      return `<span class="tp-reading-token tp-reading-token--na">${t.details_na}</span>`;
    }
    const parts = raw.split("|").map((p) => p.trim()).filter(Boolean);
    if (!parts.length) {
      return `<span class="tp-reading-token tp-reading-token--na">${t.details_na}</span>`;
    }

    const normalizeLooseKey = (txt) => {
      return String(txt || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9]/g, "");
    };

    const parseMetricPart = (part) => {
      const idx = part.indexOf(":");
      if (idx <= 0) return null;
      const label = part.slice(0, idx).trim();
      const value = part.slice(idx + 1).trim();
      if (!label || !value) return null;
      return { label, value };
    };

    const extractNumericValue = (txt) => {
      const m = String(txt || "").match(/-?\d+(?:[.,]\d+)?/);
      if (!m) return null;
      const n = Number(m[0].replace(",", "."));
      return Number.isFinite(n) ? n : null;
    };

    const resolveMetricMeta = (label, value) => {
      const key = normalizeLooseKey(label);
      const lookup = {
        [normalizeLooseKey(t.details_streak_win)]: "streak_win",
        [normalizeLooseKey(t.details_streak_unbeaten)]: "streak_unbeaten",
        [normalizeLooseKey(t.details_streak_loss)]: "streak_loss",
        [normalizeLooseKey(t.details_recent_ppm)]: "recent_ppm",
        [normalizeLooseKey(t.details_last_results)]: "last_results",
        [normalizeLooseKey(t.details_goals_for_avg)]: "goals_for",
        [normalizeLooseKey(t.details_goals_against_avg)]: "goals_against",
        [normalizeLooseKey(t.details_goals_total_avg)]: "goals_total",
        [normalizeLooseKey(t.details_matches_played)]: "matches_played"
      };
      const metric = lookup[key] || "generic";
      const n = extractNumericValue(value);

      let tone = "neutral";
      let meterPct = null;
      if (metric === "streak_win") {
        tone = "positive";
        meterPct = Number.isFinite(n) ? Math.min(100, (n / 6) * 100) : null;
      } else if (metric === "streak_unbeaten") {
        tone = "calm";
        meterPct = Number.isFinite(n) ? Math.min(100, (n / 10) * 100) : null;
      } else if (metric === "streak_loss") {
        tone = "risk";
        meterPct = Number.isFinite(n) ? Math.min(100, (n / 6) * 100) : null;
      } else if (metric === "recent_ppm") {
        tone = "focus";
        meterPct = Number.isFinite(n) ? Math.min(100, (n / 3) * 100) : null;
      } else if (metric === "goals_for") {
        tone = "positive";
        meterPct = Number.isFinite(n) ? Math.min(100, (n / 3.2) * 100) : null;
      } else if (metric === "goals_against") {
        tone = "risk";
        meterPct = Number.isFinite(n) ? Math.min(100, (n / 3.2) * 100) : null;
      } else if (metric === "goals_total") {
        tone = "focus";
        meterPct = Number.isFinite(n) ? Math.min(100, (n / 4.5) * 100) : null;
      } else if (metric === "matches_played") {
        tone = "neutral";
        meterPct = Number.isFinite(n) ? Math.min(100, (n / 40) * 100) : null;
      } else if (metric === "last_results") {
        tone = "calm";
      }

      if (variant === "goals" && tone === "focus") tone = "calm";
      return { metric, tone, meterPct };
    };

    return parts.map((part) => {
      const metric = parseMetricPart(part);
      if (!metric) return `<span class="tp-reading-token">${part}</span>`;
      const meta = resolveMetricMeta(metric.label, metric.value);
      const meterStyle = Number.isFinite(meta.meterPct) ? ` style="--tp-token-pct:${meta.meterPct.toFixed(1)}%;"` : "";
      const meterHtml = Number.isFinite(meta.meterPct)
        ? '<span class="tp-reading-token__meter" aria-hidden="true"><span class="tp-reading-token__fill"></span></span>'
        : "";
      return `
        <span class="tp-reading-token tp-reading-token--metric tp-reading-token--${meta.tone} ${Number.isFinite(meta.meterPct) ? "has-meter" : "no-meter"}"${meterStyle}>
          <span class="tp-reading-token__k">${metric.label}</span>
          <strong class="tp-reading-token__v">${metric.value}</strong>
          ${meterHtml}
        </span>
      `.trim();
    }).join("");
  }

  function buildProbaRibbonHtml(probaMetrics) {
    const home = Number(probaMetrics?.home);
    const draw = Number(probaMetrics?.draw);
    const away = Number(probaMetrics?.away);
    if (!Number.isFinite(home) || !Number.isFinite(draw) || !Number.isFinite(away)) return "";
    const total = home + draw + away;
    if (!(total > 0)) return "";
    const hW = (home / total) * 100;
    const dW = (draw / total) * 100;
    const aW = (away / total) * 100;
    return `
      <div class="tp-reading-proba-ribbon" aria-hidden="true">
        <span class="tp-reading-proba-ribbon__seg tp-reading-proba-ribbon__seg--home" style="--tp-seg:${hW.toFixed(2)}%;">
          <span class="tp-reading-proba-ribbon__txt">1 ${fmtPercent(home)}</span>
        </span>
        <span class="tp-reading-proba-ribbon__seg tp-reading-proba-ribbon__seg--draw" style="--tp-seg:${dW.toFixed(2)}%;">
          <span class="tp-reading-proba-ribbon__txt">X ${fmtPercent(draw)}</span>
        </span>
        <span class="tp-reading-proba-ribbon__seg tp-reading-proba-ribbon__seg--away" style="--tp-seg:${aW.toFixed(2)}%;">
          <span class="tp-reading-proba-ribbon__txt">2 ${fmtPercent(away)}</span>
        </span>
      </div>
    `.trim();
  }

  function parseTopScores(raw) {
    const txt = String(raw || "").trim();
    if (!txt) return [];

    const out = [];
    const parts = txt.split(/\s*,\s*/);
    for (const part of parts) {
      const m = String(part).match(/^(.+?)\s*\(([\d.,]+)%\)$/);
      if (!m) continue;
      const score = String(m[1] || "").trim();
      const pct = Number(String(m[2] || "").replace(",", "."));
      if (!score || !Number.isFinite(pct)) continue;
      out.push({ score, pct });
    }
    return out.slice(0, 5);
  }

  function fmtLocalPct(raw, digits = 1) {
    const n = Number(raw);
    if (!Number.isFinite(n)) return t.details_na;
    let s = n.toFixed(digits);
    if (lang === "fr") s = s.replace(".", ",");
    return `${s}%`;
  }

  function renderTopGoalsCard(title, raw) {
    const rows = parseTopScores(raw);
    if (!rows.length) {
      return renderReadingStat(title, raw || t.details_na, {
        classes: "tp-reading-stat--meta tp-reading-stat--goalscore"
      });
    }

    const maxPct = rows.reduce((m, item) => Math.max(m, Number(item.pct) || 0), 0) || 1;
    const rowsHtml = rows
      .map((item, idx) => {
        const rel = ((Number(item.pct) || 0) / maxPct) * 100;
        return `
          <div class="tp-topgoals__row ${idx === 0 ? "is-best" : ""}" style="--tp-goals-w:${rel.toFixed(2)}%;">
            <span class="tp-topgoals__score">${item.score}</span>
            <span class="tp-topgoals__bar" aria-hidden="true"><span class="tp-topgoals__fill"></span></span>
            <span class="tp-topgoals__pct">${fmtLocalPct(item.pct, 2)}</span>
          </div>
        `.trim();
      })
      .join("");

    return `
      <div class="tp-topgoals" role="group" aria-label="${title}">
        <div class="tp-topgoals__title">${title}</div>
        <div class="tp-topgoals__list">${rowsHtml}</div>
      </div>
    `.trim();
  }

  function resolveConfidencePercent(candidate) {
    const fromRaw = toPercentValue(candidate?.confidence_raw);
    if (Number.isFinite(fromRaw)) return fromRaw;
    const fromCandidate = toPercentValue(candidate?._conf);
    if (Number.isFinite(fromCandidate)) return fromCandidate;
    return null;
  }

  function resolveEntropyForReading(candidate) {
    const raw = Number(candidate?.entropy_raw);
    // Certaines sources renvoient 0 comme valeur sentinelle "inconnue":
    // dans ce cas, on laisse FSMatchReading recalculer depuis 1/X/2.
    if (!Number.isFinite(raw) || raw <= 0) return null;
    return raw;
  }

  function computeMatchProbabilityMetrics(candidate) {
    const home = toPercentValue(candidate?.p_home);
    const draw = toPercentValue(candidate?.p_draw);
    const away = toPercentValue(candidate?.p_away);
    if (!Number.isFinite(home) || !Number.isFinite(draw) || !Number.isFinite(away)) {
      return null;
    }

    const arr = [
      { side: "home", p: home },
      { side: "draw", p: draw },
      { side: "away", p: away }
    ].sort((a, b) => b.p - a.p);

    const pMax = Number(arr[0]?.p) || 0;
    const pSecond = Number(arr[1]?.p) || 0;

    return {
      home,
      draw,
      away,
      margin: pMax - pSecond
    };
  }

  function toNonNegativeInt(raw) {
    const n = Number(raw);
    if (!Number.isFinite(n) || n < 0) return null;
    return Math.round(n);
  }

  function formatTeamFormDetails(candidate, side) {
    const suffix = side === "away" ? "away" : "home";
    const winStreak = toNonNegativeInt(candidate?.[`current_win_streak_${suffix}`]);
    const unbeatenStreak = toNonNegativeInt(candidate?.[`current_unbeaten_streak_${suffix}`]);
    const lossStreak = toNonNegativeInt(candidate?.[`current_loss_streak_${suffix}`]);
    const lastResults = String(candidate?.[`last_results_${suffix}`] || "").trim();
    const recentPpm = Number(candidate?.[`recent_points_per_match_${suffix}`]);
    const recentMatches = toNonNegativeInt(candidate?.[`recent_matches_${suffix}`]);

    const parts = [];
    if (Number.isFinite(winStreak) && winStreak > 0) {
      parts.push(`${t.details_streak_win}: ${winStreak}`);
    }
    if (Number.isFinite(unbeatenStreak) && unbeatenStreak > 0) {
      parts.push(`${t.details_streak_unbeaten}: ${unbeatenStreak}`);
    }
    if (Number.isFinite(lossStreak) && lossStreak > 0) {
      parts.push(`${t.details_streak_loss}: ${lossStreak}`);
    }
    if (Number.isFinite(recentPpm)) {
      const sampleTxt =
        Number.isFinite(recentMatches) && recentMatches > 0
          ? ` (${recentMatches} ${t.date_match_count})`
          : "";
      parts.push(`${t.details_recent_ppm}: ${recentPpm.toFixed(2)}${sampleTxt}`);
    }
    if (lastResults) {
      parts.push(`${t.details_last_results}: ${lastResults}`);
    }

    if (!parts.length) return t.details_na;
    return parts.join(" | ");
  }

  function formatTeamGoalDetails(candidate, side) {
    const suffix = side === "away" ? "away" : "home";
    const goalsForAvg = Number(candidate?.[`avg_goals_for_${suffix}`]);
    const goalsAgainstAvg = Number(candidate?.[`avg_goals_against_${suffix}`]);
    const matchesPlayed = toNonNegativeInt(candidate?.[`matches_played_${suffix}`]);

    const parts = [];
    if (Number.isFinite(goalsForAvg)) {
      parts.push(`${t.details_goals_for_avg}: ${goalsForAvg.toFixed(2)}`);
    }
    if (Number.isFinite(goalsAgainstAvg)) {
      parts.push(`${t.details_goals_against_avg}: ${goalsAgainstAvg.toFixed(2)}`);
    }
    if (Number.isFinite(goalsForAvg) && Number.isFinite(goalsAgainstAvg)) {
      parts.push(`${t.details_goals_total_avg}: ${(goalsForAvg + goalsAgainstAvg).toFixed(2)}`);
    }
    if (Number.isFinite(matchesPlayed) && matchesPlayed > 0) {
      parts.push(`${t.details_matches_played}: ${matchesPlayed}`);
    }

    if (!parts.length) return t.details_na;
    return parts.join(" | ");
  }

  function normalizeRecentResults(raw) {
    const tokens = String(raw || "")
      .toUpperCase()
      .match(/[WLD]/g) || [];
    return tokens.slice(-8);
  }

  function renderRecentResultsChips(raw, options = {}) {
    const tokens = normalizeRecentResults(raw);
    if (!tokens.length) return `<span class="tpv5-form-empty">${t.details_na}</span>`;
    const compact = options.compact === true;
    return `
      <span class="tpv5-form-chips ${compact ? "tpv5-form-chips--compact" : ""}" aria-label="${t.details_last_results}">
        ${tokens.map((result) => `
          <span class="tpv5-form-chip tpv5-form-chip--${result.toLowerCase()}" title="${result}">${result}</span>
        `.trim()).join("")}
      </span>
    `.trim();
  }

  function renderV4MetricRows(raw) {
    const txt = String(raw || "").trim();
    if (!txt || txt === t.details_na) {
      return `<div class="tpv4-kv tpv4-kv--empty"><span>${t.details_na}</span></div>`;
    }
    return txt.split(/\s*\|\s*/).map((part) => {
      const idx = part.indexOf(":");
      if (idx <= 0) {
        return `<div class="tpv4-kv"><span>${part}</span></div>`;
      }
      const key = part.slice(0, idx).trim();
      const value = part.slice(idx + 1).trim();
      if (key === t.details_last_results) {
        return `<div class="tpv4-kv tpv4-kv--results"><span>${key}</span><strong>${renderRecentResultsChips(value)}</strong></div>`;
      }
      return `<div class="tpv4-kv"><span>${key}</span><strong>${value}</strong></div>`;
    }).join("");
  }

  function renderV4TopScores(raw) {
    const rows = parseTopScores(raw);
    if (!rows.length) return "";
    const maxPct = rows.reduce((m, row) => Math.max(m, Number(row.pct) || 0), 0) || 1;
    return `
      <div class="tpv4-score-list">
        ${rows.map((row, index) => {
          const rel = ((Number(row.pct) || 0) / maxPct) * 100;
          return `
            <div class="tpv4-score-row ${index === 0 ? "is-best" : ""}">
              <span class="tpv4-score-row__score">${row.score}</span>
              <span class="tpv4-score-row__bar"><i style="width:${rel.toFixed(2)}%"></i></span>
              <strong>${fmtLocalPct(row.pct, 2)}</strong>
            </div>
          `.trim();
        }).join("")}
      </div>
    `.trim();
  }

  function renderV4FullPickRows(picks) {
    return (Array.isArray(picks) ? picks : []).map((candidate) => {
      const family = compactPickFamily(candidate);
      const outcomeKey = outcomeForCandidate(candidate) || "pending";
      const probability = Number(candidate?.prob || 0);
      const confidence = displayedPickConfidenceForCandidate(candidate);
      return `
        <div class="tpv4-full-pick tpv4-full-pick--${outcomeKey}">
          <span class="tpv4-full-pick__type">${family.label}</span>
          <span class="tpv4-full-pick__copy">
            <strong>${candidate?.label || family.shortLabel}</strong>
            <small>${Number.isFinite(Number(confidence)) ? `${t.confidence_label} ${fmtPercent(confidence)}` : t.confidence_label}</small>
          </span>
          <strong class="tpv4-full-pick__prob">${probability.toFixed(0)}%</strong>
          <span class="tpv4-full-pick__status">${compactOutcomeLabel(outcomeKey)}</span>
        </div>
      `.trim();
    }).join("");
  }

  function renderV4VolumeRows(items) {
    const valid = (Array.isArray(items) ? items : []).filter((item) => Number.isFinite(item?.n));
    if (!valid.length) return `<div class="tpv4-kv tpv4-kv--empty"><span>${t.details_na}</span></div>`;
    const max = valid.reduce((m, item) => Math.max(m, item.n), 1);
    return valid.map((item) => `
      <div class="tpv4-volume-row">
        <span>${item.label}</span>
        <span class="tpv4-volume-row__bar"><i style="width:${Math.max(4, (item.n / max) * 100).toFixed(1)}%"></i></span>
        <strong>${item.n}</strong>
      </div>
    `.trim()).join("");
  }

  function renderV4MarketRows(picks) {
    return (Array.isArray(picks) ? picks : []).map((candidate) => {
      const family = compactPickFamily(candidate);
      const outcomeKey = outcomeForCandidate(candidate) || "pending";
      const probability = Number(candidate?.prob || 0);
      return `
        <div class="tpv4-market-row tpv4-market-row--${outcomeKey}">
          <span class="tpv4-market-row__type">${family.label}</span>
          <strong>${candidate?.label || family.shortLabel}</strong>
          <span>${probability.toFixed(0)}%</span>
          <small>${compactOutcomeLabel(outcomeKey)}</small>
        </div>
      `.trim();
    }).join("");
  }

  function detectContextLeader(candidate, probaMetrics, eloDiff) {
    const homeForm = Number(candidate?.form_index_home);
    const awayForm = Number(candidate?.form_index_away);
    if (Number.isFinite(homeForm) && Number.isFinite(awayForm) && Math.abs(homeForm - awayForm) >= 0.05) {
      return homeForm > awayForm ? "home" : "away";
    }

    if (Number.isFinite(eloDiff) && Math.abs(eloDiff) >= 20) {
      return eloDiff > 0 ? "home" : "away";
    }

    const home = Number(probaMetrics?.home);
    const away = Number(probaMetrics?.away);
    if (Number.isFinite(home) && Number.isFinite(away) && Math.abs(home - away) >= 3) {
      return home > away ? "home" : "away";
    }

    return null;
  }

  function buildCompactMatchReading(candidate) {
    if (!window.FSMatchReading || typeof window.FSMatchReading.build !== "function") {
      return null;
    }

    return window.FSMatchReading.build(
      {
        p_home: candidate?.p_home,
        p_draw: candidate?.p_draw,
        p_away: candidate?.p_away,

        // ✅ prends la meilleure confiance dispo (final > raw)
        confidence: toPercentValue(candidate?.confidence_final_raw) ?? resolveConfidencePercent(candidate),

        // ✅ entropy (si 0/sentinelle => null => recalc depuis 1X2)
        entropy: resolveEntropyForReading(candidate),

        // ✅ ajoute ML / hist pour divergence & gap
        confidence_ml: candidate?.confidence_ml_raw,
        confidence_hist: candidate?.confidence_hist_raw,

        elo_home: candidate?.elo_home,
        elo_away: candidate?.elo_away
      },
      lang
    );
  }

  function nextDetailsId() {
    detailsIdCounter += 1;
    return `tp-match-details-${detailsIdCounter}`;
  }

  function setDepthState(card, requestedState = "quick") {
    if (!card) return;
    const state = requestedState === "score" || requestedState === "full"
      ? requestedState
      : "quick";

    const switchWrap = card.querySelector("[data-tpv4-depth-switch]");
    const quickButton = card.querySelector("[data-tpv2-quick-reset]");
    const scoreButton = card.querySelector("[data-tpv6-score]");
    const fullButton = card.querySelector("[data-tp-details-toggle]");
    const quickPanel = card.querySelector("[data-tpv6-quick-panel]");
    const scorePanel = card.querySelector("[data-tpv6-score-panel]");
    const fullPanel = card.querySelector("[data-tp-details-panel]");

    card.dataset.tpv6Depth = state;
    card.classList.toggle("is-score-analysis", state === "score");
    card.classList.toggle("is-full-analysis", state === "full");

    switchWrap?.classList.toggle("is-score", state === "score");
    switchWrap?.classList.toggle("is-full", state === "full");

    if (quickPanel) quickPanel.hidden = state !== "quick";
    if (scorePanel) scorePanel.hidden = state !== "score";
    if (fullPanel) fullPanel.hidden = state !== "full";

    [
      [quickButton, "quick"],
      [scoreButton, "score"],
      [fullButton, "full"],
    ].forEach(([button, key]) => {
      if (!button) return;
      const active = state === key;
      button.classList.toggle("is-active", active);
      button.setAttribute("aria-pressed", active ? "true" : "false");
      if (key === "full") {
        button.setAttribute("aria-expanded", active ? "true" : "false");
        button.setAttribute("aria-label", active ? t.details_hide : t.details_show);
      }
    });
  }

  function syncV2AnalysisActionState(button, panel, open) {
    const card = panel?.closest?.(".tp-match-card");
    if (!card) return;
    setDepthState(card, open ? "full" : "quick");
  }

  function setMatchDetailsState(button, panel, open) {
    const card = panel?.closest?.(".tp-match-card") || button?.closest?.(".tp-match-card");
    if (!card) return;
    setDepthState(card, open ? "full" : "quick");
  }

  function setCompactCardState(card, open, options = {}) {
    if (!card) return;
    const toggle = card.querySelector("[data-tp-compact-toggle]");
    const body = card.querySelector("[data-tp-card-body]");
    if (!toggle || !body) return;

    const nextOpen = compactModeEnabled ? !!open : true;
    toggle.setAttribute("aria-expanded", nextOpen ? "true" : "false");
    toggle.setAttribute("aria-label", nextOpen ? t.compact_hide : t.compact_show);
    const shouldAnimate =
      options.animate === true &&
      compactModeEnabled &&
      !window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches &&
      typeof body.animate === "function";

    body.__tpCompactAnimation?.cancel();
    body.__tpCompactRevealAnimation?.cancel();
    card.style.removeProperty("height");
    card.style.removeProperty("overflow");
    body.style.removeProperty("height");
    body.style.removeProperty("opacity");
    body.style.removeProperty("overflow");

    if (!shouldAnimate) {
      card.classList.toggle("is-compact-open", nextOpen);
      body.hidden = !nextOpen;
      if (!nextOpen) setDepthState(card, "quick");
      return;
    }

    if (nextOpen) {
      const collapsedHeight = card.getBoundingClientRect().height;
      card.classList.add("is-compact-open");
      body.hidden = false;
      const expandedHeight = card.getBoundingClientRect().height;
      card.style.overflow = "hidden";

      const animation = card.animate(
        [
          { height: `${collapsedHeight}px` },
          { height: `${expandedHeight}px` },
        ],
        {
          duration: 340,
          easing: "cubic-bezier(.22,1,.36,1)",
        }
      );
      const revealAnimation = body.animate(
        [
          { opacity: 0, transform: "translateY(-8px)" },
          { opacity: 1, transform: "translateY(0)" },
        ],
        {
          duration: 260,
          delay: 45,
          easing: "cubic-bezier(.22,1,.36,1)",
          fill: "both",
        }
      );
      body.__tpCompactAnimation = animation;
      body.__tpCompactRevealAnimation = revealAnimation;

      const clearOpeningStyles = () => {
        if (body.__tpCompactAnimation !== animation) return;
        delete body.__tpCompactAnimation;
        delete body.__tpCompactRevealAnimation;
        card.style.removeProperty("height");
        card.style.removeProperty("overflow");
        revealAnimation.cancel();
      };
      animation.addEventListener("finish", clearOpeningStyles, { once: true });
      animation.addEventListener("cancel", clearOpeningStyles, { once: true });
      return;
    }

    body.hidden = false;
    const startHeight = body.getBoundingClientRect().height;
    body.style.overflow = "hidden";
    const animation = body.animate(
      [
        { height: `${startHeight}px`, opacity: 1 },
        { height: "0px", opacity: 0 },
      ],
      {
        duration: 240,
        easing: "cubic-bezier(.22,1,.36,1)",
      }
    );
    body.__tpCompactAnimation = animation;

    const clearClosingStyles = () => {
      if (body.__tpCompactAnimation !== animation) return;
      delete body.__tpCompactAnimation;
      body.style.removeProperty("height");
      body.style.removeProperty("opacity");
      body.style.removeProperty("overflow");
    };
    animation.addEventListener("finish", () => {
      card.classList.remove("is-compact-open");
      body.hidden = true;
      setDepthState(card, "quick");
      clearClosingStyles();
    }, { once: true });
    animation.addEventListener("cancel", clearClosingStyles, { once: true });
  }

  function closeOtherCompactCards(activeCard) {
    if (!compactModeEnabled || !elGrid) return;
    elGrid.querySelectorAll(".tp-match-card.is-compact-open").forEach((openCard) => {
      if (openCard === activeCard || openCard.classList.contains("tp-match-card--ad")) return;
      setCompactCardState(openCard, false, { animate: true });
    });
  }

  function applyExpertModeToCards(forceState) {
    const nextState = typeof forceState === "boolean" ? forceState : expertModeEnabled;
    if (compactModeEnabled && nextState) {
      if (elExpertMode) elExpertMode.checked = false;
      expertModeEnabled = false;
      return;
    }
    expertModeEnabled = nextState;
    if (!elGrid) return;

    elGrid.classList.toggle("tp-grid--expert", expertModeEnabled);
    const toggles = elGrid.querySelectorAll("[data-tp-details-toggle]");
    toggles.forEach((button) => {
      const panelId = button.getAttribute("aria-controls");
      const panel = panelId ? document.getElementById(panelId) : null;
      button.disabled = false;
      button.classList.remove("is-disabled");
      setMatchDetailsState(button, panel, expertModeEnabled);
    });
  }

  function applyCompactModeToCards(forceState, options = {}) {
    const { track = false, origin = "system" } = options;
    const nextState = typeof forceState === "boolean" ? forceState : compactModeEnabled;
    compactModeEnabled = nextState;

    if (elCompactMode) {
      elCompactMode.checked = compactModeEnabled;
    }

    if (elExpertMode) {
      if (compactModeEnabled) {
        if (elExpertMode.checked) {
          elExpertMode.checked = false;
        }
        expertModeEnabled = false;
        elExpertMode.disabled = true;
      } else {
        elExpertMode.disabled = false;
      }
    }

    // Ne persiste le mode que lorsque l'utilisateur bascule explicitement la vue
    // (case à cocher). Sinon le défaut auto (compact sur mobile) écraserait
    // localStorage au chargement et masquerait le fait que l'utilisateur n'a
    // jamais modifié la vue.
    if (origin === "checkbox") {
      persistResultsViewMode(compactModeEnabled ? "compact" : "detailed");
    }

    if (!elGrid) {
      applyExpertModeToCards(expertModeEnabled);
      if (track) {
        trackResultsViewModeChange(compactModeEnabled ? "compact" : "detailed", origin);
      }
      return;
    }

    elGrid.classList.toggle("tp-grid--compact", compactModeEnabled);
    applyExpertModeToCards(expertModeEnabled);
    elGrid.querySelectorAll(".tp-match-card").forEach((card) => {
      if (card.classList.contains("tp-match-card--ad")) return;
      setCompactCardState(card, !compactModeEnabled);
    });

    if (track) {
      trackResultsViewModeChange(compactModeEnabled ? "compact" : "detailed", origin);
    }
    syncV2ViewSwitch();
  }

  function bindMatchDetailsInteractions() {
    if (detailsBindingDone) return;
    detailsBindingDone = true;

    document.addEventListener("click", (event) => {
      const menuTrigger = event.target?.closest?.("[data-tp-pick-menu-trigger]");
      if (menuTrigger) {
        event.preventDefault();
        event.stopPropagation();
        const overflow = menuTrigger.closest("[data-tp-pick-overflow]");
        const menu = overflow?.querySelector(".tp-pick-overflow__menu");
        const willOpen = !!menu?.hidden;
        document.querySelectorAll("[data-tp-pick-overflow].is-open").forEach((item) => {
          if (item === overflow) return;
          item.classList.remove("is-open");
          item.querySelector("[data-tp-pick-menu-trigger]")?.setAttribute("aria-expanded", "false");
          const otherMenu = item.querySelector(".tp-pick-overflow__menu");
          if (otherMenu) otherMenu.hidden = true;
        });
        if (overflow && menu) {
          overflow.classList.toggle("is-open", willOpen);
          menu.hidden = !willOpen;
          menuTrigger.setAttribute("aria-expanded", willOpen ? "true" : "false");
          if (willOpen) menu.querySelector("button:not([disabled])")?.focus();
        }
        if (willOpen) trackPickAnalytics("tp_overflow_open", overflow);
        return;
      }

      const shareButton = event.target?.closest?.("[data-tp-pick-share]");
      if (shareButton) {
        event.preventDefault();
        event.stopPropagation();
        const text = shareButton.getAttribute("data-share-text") || "";
        const url = shareButton.getAttribute("data-share-url") || "";
        if (!url) return;
        const shareMethod = typeof navigator.share === "function" ? "native" : "clipboard";
        trackPickAnalytics("tp_share_click", shareButton, { share_method: shareMethod });
        const payload = { title: shareButton.getAttribute("data-share-title") || "Foresportia", text, url };
        (async () => {
          try {
            if (typeof navigator.share === "function") {
              await navigator.share(payload);
              trackPickAnalytics("tp_share_success", shareButton, { share_method: "native" });
              return;
            }
            await copyPickShareText(`${text}\n${url}`);
            trackPickAnalytics("tp_share_copy_fallback", shareButton, { share_method: "clipboard" });
            showPickShareToast(lang === "es" ? "Enlace copiado" : lang === "en" ? "Link copied" : "Lien copié");
          } catch (error) {
            if (error?.name !== "AbortError") {
              showPickShareToast(lang === "es" ? "No se puede compartir" : lang === "en" ? "Unable to share" : "Impossible de partager", true);
            }
          }
        })();
        closePickOverflow(shareButton.closest("[data-tp-pick-overflow]"));
        return;
      }

      const favoriteItem = event.target?.closest?.("[data-tp-follow]");
      if (favoriteItem) {
        window.setTimeout(() => closePickOverflow(favoriteItem.closest("[data-tp-pick-overflow]")), 0);
      }
      if (!event.target?.closest?.("[data-tp-pick-overflow]")) {
        document.querySelectorAll("[data-tp-pick-overflow].is-open").forEach(closePickOverflow);
      }

      const quickResetButton = event.target?.closest?.("[data-tpv2-quick-reset]");
      if (quickResetButton) {
        event.preventDefault();
        const card = quickResetButton.closest(".tp-match-card");
        setDepthState(card, "quick");
        return;
      }

      const scoreButton = event.target?.closest?.("[data-tpv6-score]");
      if (scoreButton) {
        event.preventDefault();
        const card = scoreButton.closest(".tp-match-card");
        setDepthState(card, "score");
        return;
      }

      const detailTab = event.target?.closest?.("[data-tpv2-detail-tab]");
      if (detailTab) {
        event.preventDefault();
        const panel = detailTab.closest("[data-tp-details-panel]");
        if (!panel) return;
        const key = String(detailTab.getAttribute("data-tpv2-detail-tab") || "analysis");
        panel.setAttribute("data-tpv2-detail-active", key);
        panel.querySelectorAll("[data-tpv2-detail-tab]").forEach((tab) => {
          const active = tab === detailTab;
          tab.classList.toggle("is-active", active);
          tab.setAttribute("aria-selected", active ? "true" : "false");
        });
        return;
      }

      /*
      * Une ligne de pick compacte peut ouvrir le match elle aussi.
      * Les éléments interactifs internes (⋮, favoris, partage, liens...)
      * gardent leur comportement propre et ne déclenchent pas l'ouverture.
      */
      const compactPickRow =
        event.target && event.target.closest
          ? event.target.closest(".tp-match-summary__list .tp-compact-pick-row")
          : null;

      if (
        compactPickRow &&
        compactModeEnabled &&
        !event.target.closest(
          "button, a, input, select, textarea, [role='button'], [data-tp-pick-overflow]"
        )
      ) {
        const card = compactPickRow.closest(".tp-match-card");

        if (card) {
          closeOtherCompactCards(card);
          setCompactCardState(card, true, { animate: true });
        }

        return;
      }

      const compactToggle =
        event.target && event.target.closest
          ? event.target.closest("[data-tp-compact-toggle]")
          : null;
      if (compactToggle && compactModeEnabled) {
        const card = compactToggle.closest(".tp-match-card");
        const isOpen = compactToggle.getAttribute("aria-expanded") === "true";
        if (!isOpen) closeOtherCompactCards(card);
        setCompactCardState(card, !isOpen, { animate: true });
        return;
      }

      const button =
        event.target && event.target.closest
          ? event.target.closest("[data-tp-details-toggle]")
          : null;
      if (!button) return;

      const panelId = button.getAttribute("aria-controls");
      const panel = panelId ? document.getElementById(panelId) : null;
      if (!panel) return;

      setMatchDetailsState(button, panel, true);
    });

    document.addEventListener("keydown", (event) => {
      if (event.key !== "Escape") return;
      const openMenu = document.querySelector("[data-tp-pick-overflow].is-open");
      if (!openMenu) return;
      const trigger = openMenu.querySelector("[data-tp-pick-menu-trigger]");
      closePickOverflow(openMenu);
      trigger?.focus();
    });
  }

  function closePickOverflow(overflow) {
    if (!overflow) return;
    overflow.classList.remove("is-open");
    overflow.querySelector("[data-tp-pick-menu-trigger]")?.setAttribute("aria-expanded", "false");
    const menu = overflow.querySelector(".tp-pick-overflow__menu");
    if (menu) menu.hidden = true;
  }

  function trackPickAnalytics(eventName, element, extraParams = {}) {
    try {
      const source = element?.closest?.("[data-tp-pick-overflow]") || element;
      const params = {
        market: String(source?.getAttribute?.("data-market") || "").slice(0, 32),
        league: String(source?.getAttribute?.("data-league") || "").slice(0, 32),
        ...extraParams
      };
      window.FSTopPredictionsFollow?.trackEvent?.(eventName, params);
    } catch (_) {}
  }

  function showPickShareToast(message, isError = false) {
    let toast = document.getElementById("tp-pick-share-toast");
    if (!toast) {
      toast = document.createElement("div");
      toast.id = "tp-pick-share-toast";
      toast.className = "tp-follow-toast";
      toast.setAttribute("role", "status");
      toast.setAttribute("aria-live", "polite");
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.dataset.kind = isError ? "error" : "info";
    toast.classList.add("is-visible");
    window.setTimeout(() => toast.classList.remove("is-visible"), 2600);
  }

  async function copyPickShareText(value) {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(value);
      return;
    }
    const field = document.createElement("textarea");
    field.value = value;
    field.setAttribute("readonly", "");
    field.style.position = "fixed";
    field.style.left = "-9999px";
    document.body.appendChild(field);
    field.select();
    const copied = document.execCommand("copy");
    field.remove();
    if (!copied) throw new Error("copy_failed");
  }

  function normTeamKey(team) {
    return String(team || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]/g, "");
  }

  function normalizeFormValue(value) {
    const n = Number(value);
    if (!Number.isFinite(n)) return null;
    return Math.max(-1, Math.min(1, n));
  }

  function formatFormValue(value) {
    const n = normalizeFormValue(value);
    if (n == null) return null;
    let abs = Math.abs(n).toFixed(2);
    if (lang === "fr") abs = abs.replace(".", ",");
    return `${n >= 0 ? "+" : "-"}${abs}`;
  }

  function getFormBandKey(value) {
    const n = normalizeFormValue(value);
    if (n == null) return null;
    if (n >= 0.45) return "veryGood";
    if (n >= 0.15) return "good";
    if (n > -0.15) return "neutral";
    if (n > -0.45) return "poor";
    return "veryPoor";
  }

  function getFormMeta(value) {
    const bandKey = getFormBandKey(value);
    const formatted = formatFormValue(value);
    if (!bandKey || !formatted) return null;

    const label =
      TEXT[lang]?.form_bands?.[bandKey] ??
      TEXT.en.form_bands?.[bandKey] ??
      "";

    return {
      value: formatted,
      label,
      className: `team-form--${bandKey}`,
      title: t.form_scale_hint,
    };
  }

  async function loadTeamFormMap(leagueCode) {
    const leagueKey = String(leagueCode || "").toUpperCase();
    if (!leagueKey) return new Map();
    if (_teamFormByLeagueCache.has(leagueKey)) {
      return _teamFormByLeagueCache.get(leagueKey);
    }

    try {
      const r = await fetch(
        `${API_TEAM_FORM}?league=${encodeURIComponent(leagueKey)}`,
        { headers: { Accept: "application/json" } }
      );
      if (!r.ok) throw new Error(`HTTP ${r.status}`);

      const payload = await r.json();
      const map = teamFormMapFromTeams(payload?.teams || {});
      _teamFormByLeagueCache.set(leagueKey, map);
      return map;
    } catch (e) {
      console.warn("team_form fetch failed", leagueKey, e);
      const empty = new Map();
      _teamFormByLeagueCache.set(leagueKey, empty);
      return empty;
    }
  }

  async function loadTeamFormBulk(leagues) {
    const leagueCodes = Array.from(new Set((Array.isArray(leagues) ? leagues : [])
      .map((league) => String(league || "").trim().toUpperCase())
      .filter((league) => league && !isExperimentalLeague(league))));
    const missing = leagueCodes.filter((league) => !_teamFormByLeagueCache.has(league));
    if (!missing.length) return;

    const cacheKey = missing.slice().sort().join(",");
    if (teamFormBulkCache.has(cacheKey)) {
      applyTeamFormBulkPayload(teamFormBulkCache.get(cacheKey), missing);
      return;
    }
    if (teamFormBulkInFlight.has(cacheKey)) {
      const payload = await teamFormBulkInFlight.get(cacheKey);
      applyTeamFormBulkPayload(payload, missing);
      return;
    }

    const params = new URLSearchParams({ leagues: missing.join(",") });
    const request = (async () => {
      const r = await fetch(`${API_TEAM_FORM_BULK}?${params.toString()}`, {
        headers: { Accept: "application/json" }
      });
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const payload = await r.json();
      if (!payload || typeof payload !== "object" || !payload.leagues || typeof payload.leagues !== "object") {
        throw new Error("team_form_bulk invalid payload");
      }
      teamFormBulkCache.set(cacheKey, payload);
      return payload;
    })();

    teamFormBulkInFlight.set(cacheKey, request);
    try {
      const payload = await request;
      applyTeamFormBulkPayload(payload, missing);
    } finally {
      teamFormBulkInFlight.delete(cacheKey);
    }
  }

  function applyTeamFormBulkPayload(payload, leagues) {
    (Array.isArray(leagues) ? leagues : []).forEach((leagueKey) => {
      const entry = payload?.leagues?.[leagueKey];
      if (!entry) {
        console.warn("team_form_bulk missing league", leagueKey);
        _teamFormByLeagueCache.set(leagueKey, new Map());
        return;
      }
      if (entry.ok !== true) {
        console.warn("team_form_bulk league error", leagueKey, entry);
        _teamFormByLeagueCache.set(leagueKey, new Map());
        return;
      }
      _teamFormByLeagueCache.set(leagueKey, teamFormMapFromTeams(entry.teams || {}));
    });

    if (payload?.errors && Object.keys(payload.errors).length) {
      console.warn("team_form_bulk errors", payload.errors);
    }
  }

  async function hydrateMatchesWithTeamForm(matches) {
    const list = Array.isArray(matches) ? matches : [];
    if (!list.length) return;

    const leagues = Array.from(
      new Set(
        list
          .map((m) => String(m?.league || "").toUpperCase())
          .filter((league) => league && !isExperimentalLeague(league))
      )
    );

    try {
      await loadTeamFormBulk(leagues);
    } catch (bulkError) {
      console.warn("team_form_bulk failed, falling back to per-league fetch", bulkError);
      await mapLimit(leagues, 4, (league) => loadTeamFormMap(league));
    }

    for (const m of list) {
      const leagueKey = String(m?.league || "").toUpperCase();
      const map = _teamFormByLeagueCache.get(leagueKey) || new Map();
      const homeData = map.get(normTeamKey(m?.home)) || null;
      const awayData = map.get(normTeamKey(m?.away)) || null;

      m.form_index_home = Number.isFinite(Number(homeData?.form_index))
        ? Number(homeData.form_index)
        : null;
      m.form_index_away = Number.isFinite(Number(awayData?.form_index))
        ? Number(awayData.form_index)
        : null;

      m.current_win_streak_home = Number.isFinite(Number(homeData?.current_win_streak))
        ? Number(homeData.current_win_streak)
        : null;
      m.current_win_streak_away = Number.isFinite(Number(awayData?.current_win_streak))
        ? Number(awayData.current_win_streak)
        : null;

      m.current_unbeaten_streak_home = Number.isFinite(Number(homeData?.current_unbeaten_streak))
        ? Number(homeData.current_unbeaten_streak)
        : null;
      m.current_unbeaten_streak_away = Number.isFinite(Number(awayData?.current_unbeaten_streak))
        ? Number(awayData.current_unbeaten_streak)
        : null;

      m.current_loss_streak_home = Number.isFinite(Number(homeData?.current_loss_streak))
        ? Number(homeData.current_loss_streak)
        : null;
      m.current_loss_streak_away = Number.isFinite(Number(awayData?.current_loss_streak))
        ? Number(awayData.current_loss_streak)
        : null;

      m.last_results_home = typeof homeData?.last_results === "string" ? homeData.last_results : "";
      m.last_results_away = typeof awayData?.last_results === "string" ? awayData.last_results : "";

      m.recent_points_per_match_home = Number.isFinite(Number(homeData?.recent_points_per_match))
        ? Number(homeData.recent_points_per_match)
        : null;
      m.recent_points_per_match_away = Number.isFinite(Number(awayData?.recent_points_per_match))
        ? Number(awayData.recent_points_per_match)
        : null;

      m.recent_matches_home = Number.isFinite(Number(homeData?.recent_matches))
        ? Number(homeData.recent_matches)
        : null;
      m.recent_matches_away = Number.isFinite(Number(awayData?.recent_matches))
        ? Number(awayData.recent_matches)
        : null;

      m.matches_played_home = Number.isFinite(Number(homeData?.matches_played))
        ? Number(homeData.matches_played)
        : null;
      m.matches_played_away = Number.isFinite(Number(awayData?.matches_played))
        ? Number(awayData.matches_played)
        : null;

      m.goals_for_home = Number.isFinite(Number(homeData?.goals_for))
        ? Number(homeData.goals_for)
        : null;
      m.goals_for_away = Number.isFinite(Number(awayData?.goals_for))
        ? Number(awayData.goals_for)
        : null;

      m.goals_against_home = Number.isFinite(Number(homeData?.goals_against))
        ? Number(homeData.goals_against)
        : null;
      m.goals_against_away = Number.isFinite(Number(awayData?.goals_against))
        ? Number(awayData.goals_against)
        : null;

      m.avg_goals_for_home = Number.isFinite(Number(homeData?.avg_goals_for))
        ? Number(homeData.avg_goals_for)
        : null;
      m.avg_goals_for_away = Number.isFinite(Number(awayData?.avg_goals_for))
        ? Number(awayData.avg_goals_for)
        : null;

      m.avg_goals_against_home = Number.isFinite(Number(homeData?.avg_goals_against))
        ? Number(homeData.avg_goals_against)
        : null;
      m.avg_goals_against_away = Number.isFinite(Number(awayData?.avg_goals_against))
        ? Number(awayData.avg_goals_against)
        : null;
    }
  }

  const locale = lang === "en" ? "en-GB" : lang === "es" ? "es-ES" : "fr-FR";
  const formatDateLocal = (iso) => {
    const d = parseLocalDateISO(iso);
    if (!d) return String(iso || "");

    return d.toLocaleDateString(locale, {
      weekday: "short",
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  function getDatePartsForRail(iso){
    const d = parseLocalDateISO(iso);
    if (!d) return { weekday: String(iso || ''), day: '', isToday: false };
    const weekday = d.toLocaleDateString(locale, { weekday: 'short' })
      .replace(/\.$/, '')
      .toLowerCase();
    const day = d.toLocaleDateString(locale, { day: 'numeric' });
    const now = new Date();
    const isToday = d.getFullYear() === now.getFullYear()
      && d.getMonth() === now.getMonth()
      && d.getDate() === now.getDate();
    return { weekday, day, isToday };
  }

  function formatUTCToLocal(utc){
    if (!utc) return "";

    const d = parseFrenchDateTime(utc);
    if (!d) return "";

    const dateStr = d.toLocaleDateString(locale, {
      weekday: "short",
      day: "2-digit",
      month: "short"
    });

    const timeStr = d.toLocaleTimeString(locale, {
      hour: "2-digit",
      minute: "2-digit"
    });

    return `${dateStr} • ${timeStr}`;
  }

  function formatMatchDateTime(match){
    // Cas 1 : datetime ISO ou quasi-ISO
    const raw =
      match.datetime ||
      match.match_datetime ||
      match.kickoff ||
      match.date_time ||
      null;

    let d = null;
    let time = null;

    if (raw){
      // Exemple: "2024-12-26 20:45" ou ISO
      d = parseFrenchDateTime(raw);
    } else if (match.date && match.hour){
      // Exemple: date + hour séparés (heure Paris naïve)
      d = parseFrenchDateTime(`${match.date}T${match.hour}`);
    }

    if (!d || isNaN(d)){
      return "Date inconnue";
    }

    // Heure TOUJOURS dérivée de l'instant localisé (fuseau du visiteur), jamais
    // l'heure Paris brute de match.hour — sinon un visiteur hors Paris verrait
    // la bonne date mais une heure fausse.
    time = d.toLocaleTimeString(locale, {
      hour: "2-digit",
      minute: "2-digit"
    });

    // Date courte lisible
    const dateStr = d.toLocaleDateString(locale, {
      weekday: "short",
      day: "2-digit",
      month: "short"
    });

    return `${dateStr} • ${time}`;
  }

  function normalizeConfidence(sr){
    const x = Number(sr);
    // pas d'info / NaN
    if (!Number.isFinite(x)) return 50;
    // règle business: 0% ou 100% => fallback 50
    if (x <= 0 || x >= 100) return 50;
    return x;
  }

  function reliabilityForCandidate(c){
    const metrics = confidenceMetricsForCandidate(c);
    if (!metrics) return null;

    const mk = marketKeyForCandidate(c);
    const sr = metrics.sr;
    const total = metrics.total;

    // seuils de volume (à ajuster)
    const minTotalByMarket = {
      double_chance: 20,
      dnb: 20,
      "1x2": 20,
      under25: 12,
      over25: 12,
      btts: 12,
    };
    const minTotal = minTotalByMarket[mk] ?? 20;

    // Min-volume guard intentionally disabled while the fallback threshold is calibrated.
    // if (!Number.isFinite(total) || total < minTotal) return null;

    // sr ok
    if (sr == null) return null;
    const v = Number(sr);
    if (!Number.isFinite(v)) return null;
    if (v <= 0 || v >= 100) return null;
    return v;
  }

  function histSampleForCandidate(c){
    const metrics = confidenceMetricsForCandidate(c);
    if (!metrics) return null;

    const total = Number(metrics.total ?? 0);
    if (!Number.isFinite(total) || total <= 0) return null;

    return total;
  }

  function round5(x){ return Math.round((x || 0) / 5) * 5; }
  function parseUtcTime(match){
    if (!match) return 0;
    const d = parseFrenchDateTime(match);
    return d ? d.getTime() : 0;
  }
  function matchHasStarted(match){
    if (!match) return false;
    const d = parseFrenchDateTime(match);
    const t = d ? d.getTime() : NaN;
    if (!Number.isFinite(t)) return false;
    return t <= Date.now();
  }

  function showLoading(on, message, title){
    // Compatibility shim for old call sites. V20 never blocks the page:
    // only the match grid gets a loading state.
    if (on) {
      emitListingLoading(true, String(message || title || "loading"));
    } else {
      emitListingLoading(false, "");
    }
  }

  // ===========================
  // Day summary (bilan journée) - hors Top10
  // ===========================

  // ===========================
  // Day summary (bilan journée) - hors TopN (toutes les sélections filtrées)
  // ===========================

  function getMatchDateKey(m){
    // Retourne "YYYY-MM-DD" en heure locale.
    // Exemples possibles :
    // - m.date = "2025-12-23"
    // - m.datetime = "2025-12-23 20:45"
    const raw = (m.date || m.match_date || "").trim();
    if (raw) return raw;

    const dt = (m.datetime || m.kickoff || "").trim();
    if (dt) return dt.slice(0, 10);

    return "";
  }

  function isFinished(m){
    if (!fixtureStatus.countsInPerformance(m)) return false;
    // Match terminé si un score final est présent.
    if (m.has_score === true) return true;
    if (m.ft_home != null && m.ft_away != null && `${m.ft_home}` !== "" && `${m.ft_away}` !== "") return true;
    if (m.score_home != null && m.score_away != null && `${m.score_home}` !== "" && `${m.score_away}` !== "") return true;
    return false;
  }

  function isCorrect(m){
    // Compare le pick 1/N/2 avec l'issue réelle calculée à partir du score.
    if (!isFinished(m)) return false;

    // Exemple générique:
    const home = Number(m.ft_home ?? m.score_home);
    const away = Number(m.ft_away ?? m.score_away);
    if (Number.isNaN(home) || Number.isNaN(away)) return false;

    const real = home > away ? "1" : home < away ? "2" : "N";
    const pick = (m.pick || m.selection || "").toString().trim(); // "1" / "N" / "2"

    return pick === real;
  }

  // Prend TOUTES tes données (hors top10), applique la date + seuils, puis calcule
  function computeDaySummary(allMatches, selectedDateKey, filters){
    // filters: objet qui représente tes seuils choisis (proba_min etc.)
    // IMPORTANT: tu dois réutiliser EXACTEMENT la même fonction de filtrage que pour l’affichage,
    // sinon tu vas créer un décalage.
    //
    // => idéalement: réutilise ta fonction existante applyFilters(matches, filters)
    // Fallback "pas de filtre" si aucun périmètre n'est fourni.

    const byDate = allMatches.filter(m =>
      getMatchDateKey(m) === selectedDateKey && fixtureStatus.countsAsAvailable(m)
    );

    const filtered = (typeof applyFilters === "function" && filters)
      ? applyFilters(byDate, filters)
      : byDate;

    const finished = filtered.filter(isFinished);
    const upcoming = filtered.filter(m => !isFinished(m));

    const correct = finished.filter(isCorrect).length;

    return {
      totalAfterFilters: filtered.length,
      finishedCount: finished.length,
      upcomingCount: upcoming.length,
      correctCount: correct
    };
  }

  function getCurrentFiltersForSummary(){
    const parts = [];

    if (chkDC?.checked)   parts.push(`DC ≥ ${parseInt(elMinDC?.value || "30", 10)}%`);
    if (chkDNB?.checked)  parts.push(`DNB ≥ ${parseInt(elMinDNB?.value || "30", 10)}%`);
    if (chk1X2?.checked)  parts.push(`1X2 ${get1X2LevelLabel(getCurrent1X2Level())}`);
    if (chkUnder25?.checked) parts.push(`Under 2.5 ≥ ${parseInt(elMinU25?.value || "30", 10)}%`);
    if (chkOver25?.checked)  parts.push(`Over 2.5 ≥ ${parseInt(elMinO25?.value || "30", 10)}%`);
    if (chkOver15?.checked)  parts.push(`Over 1.5 ≥ ${parseInt(elMinO15?.value || "75", 10)}%`);
    if (chkUnder35?.checked) parts.push(`Under 3.5 ≥ ${parseInt(elMinU35?.value || "70", 10)}%`);
    if (chkBTTS?.checked)    parts.push(`BTTS ≥ ${parseInt(elMinBTTS?.value || "30", 10)}%`);

    return parts.length ? parts.join(" · ") : t.filters_default;
  }

  function computeDaySummaryFromCandidates(cands){
    let wins = 0, total = 0, voids = 0, pending = 0;

    for (const c of cands){
      const o = outcomeForCandidate(c); // déjà dans ton code
      if (!o) { pending++; continue; }
      if (o === "void") { voids++; continue; }
      total++;
      if (o === "win") wins++;
    }

    return { wins, total, voids, pending, all: cands.length };
  }

  function renderDaySummary(summary){
    const doneEl = document.getElementById("tp-day-done");
    const upEl = document.getElementById("tp-day-upcoming");
    const doneHintEl = document.getElementById("tp-day-done-hint");
    const upHintEl = document.getElementById("tp-day-upcoming-hint");
    // const filtersEl = document.getElementById("tp-day-filters");

    if (!doneEl || !upEl ) return;

    // Réussite (hors void)
    const rate = summary.total ? (summary.wins / summary.total) * 100 : null;

    doneEl.innerHTML =
      rate == null
        ? `<span class="ok">${summary.wins}</span> / ${summary.total}`
        : `<span class="ok">${summary.wins}</span> / ${summary.total} <span class="pct">(${rate.toFixed(1)}%)</span>`;

    const voidTxt = summary.voids ? ` · ${summary.voids} void` : "";
    const pendingTxt = summary.pending ? ` · ${summary.pending} ${t.day_pending_label}` : "";

    doneHintEl.textContent =
      summary.total
        ? t.day_rate(rate, summary.total)
        : t.day_waiting(voidTxt, pendingTxt, summary.all);

    // Restent à jouer
    upEl.textContent = `${summary.pending} / ${summary.all}`;
    upHintEl.textContent = t.day_upcoming_hint;

    // Seuils / filtres actifs
    // filtersEl.textContent = getCurrentFiltersForSummary();
  }

  /**
   * candidatesForDay = toutes les sélections générées pour la date sélectionnée
   * (pas juste le Top 10)
   */
  let lastCandidatesForDay = [];
  let hasDaySummarySnapshot = false;

  function updateDaySummaryUI(){
    if (!selectedDate) return;

    // si on n’a rien, on tente de reconstruire “vite” depuis les matchs du jour
    if (!hasDaySummarySnapshot && !lastCandidatesForDay.length){
      const selectedLeagueSet = getSelectedLeagueSet();
      const source = (windowMatchesFullRaw && windowMatchesFullRaw.length)
        ? windowMatchesFullRaw
        : windowMatches;
      const inDay = source.filter((m) => localDayKeyFromUTC(m) === selectedDate);
      let cands = [];
      for (const m of inDay) {
        cands = cands.concat(buildCandidates(m, {
          selectedLeagueSet,
          includeGlobal1X2: true,
        }) || []);
      }
      lastCandidatesForDay = cands;
      hasDaySummarySnapshot = true;
    }

    const summary = computeDaySummaryFromCandidates(lastCandidatesForDay);
    window.ForesportiaLiveScoreOverlay?.trackPerformanceMatches(lastCandidatesForDay);
    renderDaySummary(summary);
  }

  let dailyScoreRefreshPending = false;
  document.addEventListener("foresportia:performance-score", () => {
    if (dailyScoreRefreshPending) return;
    dailyScoreRefreshPending = true;
    requestAnimationFrame(() => {
      dailyScoreRefreshPending = false;
      schedulePostRenderTasks();
    });
  });

  let postRenderWorkToken = 0;

  function schedulePostRenderTasks(options = {}) {
    const {
      refreshInlineAds = false,
      refreshModeStats = true,
    } = options;
    const token = ++postRenderWorkToken;

    requestAnimationFrame(() => {
      const run = () => {
        if (token !== postRenderWorkToken) return;
        if (refreshInlineAds) refreshInlineMatchAds();
        updateDaySummaryUI();
        computeGlobalPerf();
        if (refreshModeStats) {
          dispatchModeStatsFromPicksPerf(selectedDate);
        }
      };

      if ("requestIdleCallback" in window) {
        window.requestIdleCallback(run, { timeout: 200 });
        return;
      }

      setTimeout(run, 0);
    });
  }

  function getAdvancedCustomCount(){
    return Object.keys(sliderByTypeKey).filter((key) => touchedTypes.has(key)).length;
  }

  function syncFiltersPanelUI(isOpen){
    if (!filtersPanel || !filtersToggle || !filtersLabel) return;
    filtersPanel.classList.toggle("collapsed", !isOpen);
    filtersToggle.classList.toggle("is-open", isOpen);
    filtersToggle.setAttribute("aria-expanded", String(isOpen));
    filtersLabel.textContent = isOpen ? t.filters_state_open : t.filters_state_closed;
  }

  function syncAdvancedToggleUI(){
    updateSelectionState();
    if (!btnAdvancedToggle || !elAdvanced) return;
    const isOpen = !elAdvanced.classList.contains("collapsed");
    const customCount = getAdvancedCustomCount();
    const summaryText = customCount
      ? t.advanced_custom_count(customCount)
      : (isOpen ? t.advanced_summary_open : t.advanced_summary_closed);

    btnAdvancedToggle.classList.toggle("is-open", isOpen);
    btnAdvancedToggle.setAttribute("aria-expanded", String(isOpen));
    if (elAdvancedSummary) elAdvancedSummary.textContent = summaryText;
  }

  // Toggle filters
  if (filtersPanel && filtersToggle && filtersLabel){
    syncFiltersPanelUI(false);

    filtersToggle.addEventListener("click", () => {
      const willOpen = filtersPanel.classList.contains("collapsed");
      syncFiltersPanelUI(willOpen);
    });
  }

  function centerSelectedDateInScroller(behavior = "auto") {
    const container = document.querySelector(".tp-date-row .date-selector");
    const selected = container?.querySelector(".date-button.selected");
    if (!container || !selected) return;

    const containerRect = container.getBoundingClientRect();
    const selectedRect = selected.getBoundingClientRect();

    // Position cible calculée dans le repère scrollable réel.
    // Les paddings latéraux du rail permettent aussi de centrer les dates
    // proches du début/de la fin de la fenêtre.
    const delta =
      (selectedRect.left + selectedRect.width / 2) -
      (containerRect.left + containerRect.width / 2);

    const maxLeft = Math.max(0, container.scrollWidth - container.clientWidth);
    const targetLeft = Math.max(0, Math.min(container.scrollLeft + delta, maxLeft));

    container.scrollTo({ left: targetLeft, behavior });

    // Recalage après stabilisation du layout / des polices.
    requestAnimationFrame(() => {
      const liveSelected = container.querySelector(".date-button.selected");
      if (!liveSelected) return;
      const cRect = container.getBoundingClientRect();
      const sRect = liveSelected.getBoundingClientRect();
      const liveDelta =
        (sRect.left + sRect.width / 2) -
        (cRect.left + cRect.width / 2);
      const liveMax = Math.max(0, container.scrollWidth - container.clientWidth);
      container.scrollLeft = Math.max(
        0,
        Math.min(container.scrollLeft + liveDelta, liveMax)
      );
      syncDateRailNavState();
    });
  }

  function scrollDateRail(direction = 1){
    const container = document.querySelector('.tp-date-row .date-selector');
    if (!container) return;
    const step = Math.max(220, Math.round(container.clientWidth * 0.55));
    container.scrollBy({ left: direction * step, behavior: 'smooth' });
    window.setTimeout(syncDateRailNavState, 250);
  }

  function syncDateRailNavState(){
    const container = document.querySelector('.tp-date-row .date-selector');
    if (!container) return;
    const maxLeft = Math.max(0, container.scrollWidth - container.clientWidth);
    const atStart = container.scrollLeft <= 4;
    const atEnd = container.scrollLeft >= maxLeft - 4;
    if (elDateNavPrev){
      elDateNavPrev.disabled = atStart;
      elDateNavPrev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
    }
    if (elDateNavNext){
      elDateNavNext.disabled = atEnd;
      elDateNavNext.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
    }
  }

  if (elDateNavPrev) elDateNavPrev.addEventListener('click', () => scrollDateRail(-1));
  if (elDateNavNext) elDateNavNext.addEventListener('click', () => scrollDateRail(1));
  if (elDates) elDates.addEventListener('scroll', () => window.requestAnimationFrame(syncDateRailNavState), { passive: true });

  // League buttons
  function renderLeagueButtons(){
    elButtons.innerHTML = "";
    LEAGUES.forEach((L) => {
      const div = document.createElement("div");
      div.className = "league-button selected";
      div.dataset.leagueCode = L.code;
      div.innerHTML = `
        <img src="${toRootAssetPath(L.logo)}" alt="${formatLeagueName(L.code)}" onerror="this.style.display='none'">
        ${isWorldCup2026League(L.code) ? '<span class="league-button__fallback">CDM</span>' : (isExperimentalLeague(L.code) ? '<span class="league-button__fallback">INT</span>' : "")}
        ${renderExperimentalBadge(L.code)}
      `;
      div.addEventListener("click", () => {
        if (isLeagueSelectionLocked()){
          selectAllLeagues();
          syncLeagueSelectionLockUI();
          return;
        }
        div.classList.toggle("selected");
        syncCurrentWindowMatchesFromSelection();
        renderDatePills(selectedDate);
        filterAndRender();
      });
      elButtons.appendChild(div);
    });
    syncLeagueSelectionLockUI();
  }

  const selectedLeagues = () =>
    Array.from(document.querySelectorAll(".league-button.selected")).map((b) => b.dataset.leagueCode);

  function getSelectedLeagueSet() {
    return new Set(
      selectedLeagues()
        .map((league) => String(league || "").toUpperCase())
        .filter(Boolean)
    );
  }

  function buildDateCountsFromMatches(matches) {
    const counts = new Map();
    for (const match of (Array.isArray(matches) ? matches : [])) {
      if (!fixtureStatus.countsAsAvailable(match)) continue;
      const dayKey = localDayKeyFromUTC(match);
      if (!dayKey) continue;
      counts.set(dayKey, (counts.get(dayKey) || 0) + 1);
    }
    return counts;
  }

  function isMatchInLeagueSelection(match, selectedLeagueSet) {
    if (!(selectedLeagueSet instanceof Set) || !selectedLeagueSet.size) return true;
    return selectedLeagueSet.has(String(match?.league || "").toUpperCase());
  }

  function resolveSelectableDate(dates, preferredDate) {
    const sorted = Array.isArray(dates) ? dates.slice().sort() : [];
    if (!sorted.length) return null;

    const preferred = preferredDate || selectedDate || null;
    if (preferred && sorted.includes(preferred)) return preferred;

    const today = todayISO();
    if (sorted.includes(today)) return today;

    const upcoming = sorted.find((dayKey) => dayKey >= today);
    if (upcoming) return upcoming;

    return sorted[sorted.length - 1] || null;
  }

  function syncCurrentWindowMatchesFromSelection() {
    const source = (windowMatchesFullRaw && windowMatchesFullRaw.length)
      ? windowMatchesFullRaw
      : [];
    const selectedSet = getSelectedLeagueSet();

    windowMatchesRaw = source.filter((match) => selectedSet.has(String(match?.league || "").toUpperCase()));
    windowMatches = [...windowMatchesRaw];
    dateCounts = buildDateCountsFromMatches(source);
    hasDaySummarySnapshot = false;

    if (!dateCounts.size) {
      lastCandidatesForDay = [];
    }
  }

  function captureAutomaticControls() {
    return {
      thresholds: Object.fromEntries(Object.entries(sliderByTypeKey).map(([key, slot]) => [key, Number(slot.el?.value)])),
      leagues: selectedLeagues().slice().sort(),
      markets: [chkDC, chkDNB, chk1X2, chkUnder25, chkOver25, chkOver15, chkUnder35, chkBTTS].map(el => !!el?.checked)
    };
  }

  function automaticControlChanges() {
    const baseline = isCustomProfileSelection() ? profileControlsBaseline : automaticModeBaseline;
    if (!baseline) return [];
    const controls = captureAutomaticControls();
    const changes = Object.keys(controls.thresholds).filter(key => controls.thresholds[key] !== baseline.thresholds[key])
      .map(key => `${t.perf_type_labels[key]} ≥ ${controls.thresholds[key]}%`);
    if (JSON.stringify(controls.markets) !== JSON.stringify(baseline.markets)) changes.push(selectionCopy.markets);
    if (JSON.stringify(controls.leagues) !== JSON.stringify(baseline.leagues)) changes.push(selectionCopy.leagues);
    return changes;
  }

  function updateSelectionState() {
    const panel = document.getElementById("tp-selection-state");
    if (!panel) return;
    const summary = getActiveModeSummary();
    const changes = automaticControlChanges();
    const valid = !!getRemoteBuiltInModeConfigs()?.[activeDisplayMode];
    const label = isCustomProfileSelection() ? summary.label + (changes.length ? ` · ${selectionCopy.adjusted} (${changes.join(" · ")})` : "") : !sourcesReady ? selectionCopy.loading : !valid ? selectionCopy.unavailable
      : `${selectionRules.modeLabel(lang, activeDisplayMode)} · ${changes.length ? selectionCopy.adjusted + " (" + changes.join(" · ") + ")" : selectionCopy.automatic}`;
    panel.replaceChildren();
    const copy = document.createElement("span");
    copy.textContent = label + (freshnessMessage ? " · " + freshnessMessage : "");
    panel.appendChild(copy);
    if (changes.length && (valid || isCustomProfileSelection())) {
      const restore = document.createElement("button");
      restore.type = "button";
      restore.className = "tp-btn-chip";
      restore.textContent = isCustomProfileSelection() ? selectionCopy.restoreProfile : selectionCopy.restore;
      restore.addEventListener("click", () => {
        if (isCustomProfileSelection()) {
          applyProfileConfig(profilesApi.getProfile(activeModeSelection.slice(8)));
          return;
        }
        const checkboxes = [chkDC, chkDNB, chk1X2, chkUnder25, chkOver25, chkOver15, chkUnder35, chkBTTS];
        checkboxes.forEach((el, i) => { if (el) el.checked = automaticModeBaseline.markets[i]; });
        applyBuiltInMode(activeDisplayMode);
      });
      panel.appendChild(restore);
    }
  }

  function refreshSources() {
    if (refreshTask) return refreshTask;
    refreshTask = (async () => {
      await controlsReadyPromise;
      const revision = ++sourceRevision;
      const generation = beginListingUpdate("refresh");
      refreshingSources = true;
      freshnessMessage = selectionCopy.loading;
      btnRefresh.disabled = true;
      updateSelectionState();
      leagueMarketsBulkCache.clear();
      leagueMarketsBulkInFlight.clear();
      try {
        const results = await Promise.allSettled([
          preloadPicksPerf({ force: true }),
          fetchLeagueFeedBulkWindow(LEAGUES, addDays(todayISO(), -WINDOW_PAST_DAYS), WINDOW_PAST_DAYS + WINDOW_FUTURE_DAYS + 1)
        ]);
        if (revision !== sourceRevision) return;
        if (results.some(result => result.status !== "fulfilled") || !results[0].value || !results[1].value?.length) throw new Error("incomplete refresh");
        if (isBuiltInAutomaticSelection() && !results[0].value.index.modes?.[activeDisplayMode]) throw new Error("mode unavailable");
        const controls = captureAutomaticControls();
        const baseline = automaticModeBaseline;
        const preferredDate = selectedDate;
        picksPerfIdx = results[0].value.payload;
        topPronosticsPerformanceIndex = results[0].value.index;
        windowMatchesFullRaw = results[1].value.filter(match => match.kickoff_iso);
        windowMatchesFull = [...windowMatchesFullRaw];
        if (isBuiltInAutomaticSelection()) {
          const config = getRemoteBuiltInModeConfigs()?.[activeDisplayMode];
          if (!config) throw new Error("mode unavailable");
          applyBuiltInModeThresholdConfig(activeDisplayMode, config, { preferredDate });
          if (baseline) {
            Object.keys(controls.thresholds).forEach(key => {
              if (controls.thresholds[key] !== baseline.thresholds[key]) setTypeSliderValue(key, controls.thresholds[key], { markTouched: true });
            });
            if (JSON.stringify(controls.leagues) !== JSON.stringify(baseline.leagues)) setLeagueSelection(controls.leagues);
          }
        }
        syncCurrentWindowMatchesFromSelection();
        renderDatePills(preferredDate);
        freshnessMessage = selectionCopy.refreshed + " " + new Date().toLocaleTimeString();
        await filterAndRender({ reason: "refresh" });
      } catch (error) {
        freshnessMessage = selectionCopy.refreshError;
        console.warn("[top] refresh failed", error);
      } finally {
        refreshingSources = false;
        btnRefresh.disabled = false;
        updateSelectionState();
        endListingUpdate(generation);
      }
    })().finally(() => { refreshTask = null; });
    return refreshTask;
  }

  function setModeHint(msg){
    if (!elDisplayModeHint) return;
    elDisplayModeHint.textContent = msg || "";
  }

  function isCustomProfileSelection(selection = activeModeSelection){
    return String(selection || "").startsWith("profile:");
  }

  function isBuiltInAutomaticSelection(selection = activeModeSelection){
    return !isCustomProfileSelection(selection);
  }

  function isLeagueSelectionLocked(){
    return activeDisplayMode === "performance" && isBuiltInAutomaticSelection();
  }

  function syncLeagueSelectionLockUI(){
    const locked = isLeagueSelectionLocked();
    document.documentElement.dataset.fsLeagueSelectionLocked = locked ? "1" : "0";

    document.querySelectorAll(".league-button").forEach((btn) => {
      btn.classList.toggle("is-locked", locked);
      btn.setAttribute("aria-disabled", locked ? "true" : "false");
    });

    [btnLeaguesAll, btnLeaguesNone].forEach((btn) => {
      if (!btn) return;
      btn.disabled = locked;
      btn.classList.toggle("is-disabled", locked);
      btn.setAttribute("aria-disabled", locked ? "true" : "false");
    });
  }

  function getBuiltInModeMeta(mode){
    const normalized = String(mode || "performance");
    if (lang === "en"){
      const map = {
        performance: {
          label: "Performance",
          description: "Default mode to keep the reading focused."
        },
        high: {
          label: "High performance",
          description: "Stricter selection with optimized leagues."
        },
        ultra: {
          label: "Ultra performance",
          description: "Only the sharpest picks survive."
        },
        all: {
          label: "All matches",
          description: "Open display with lighter thresholds."
        }
      };
      return map[normalized] || map.performance;
    }

    const map = {
      performance: {
        label: "Performance",
        description: "Base automatique, stable sur la journée."
      },
      high: {
        label: "Haute perf",
        description: "Plus sélectif que Performance, à seuils figés."
      },
      ultra: {
        label: "Ultra haute perf",
        description: "Niveau le plus strict, réservé aux signaux les plus forts."
      },
      all: {
        label: "Tous les matchs",
        description: "Volume maximum avec filtres permissifs."
      }
    };
    return map[normalized] || map.performance;
  }

  function setActiveModeSelection(selection, options = {}){
    activeModeSelection = String(selection || "builtin:performance");
    if (!String(activeModeSelection).startsWith("profile:")) {
      activeWizardX12Custom = null;
      activeProfileMinConfidence = 0;
      activeProfileStabilityFilter = "all";
    }
    if (options.persist !== false && profilesApi){
      profilesApi.setActiveSelection(activeModeSelection);
    }
    syncInlineModeButtons();
  }

  function normalizeTopX12ThresholdSet(raw, fallback) {
    const src = raw && typeof raw === "object" ? raw : {};
    const fb = fallback && typeof fallback === "object" ? fallback : {};

    const clampProb = (v, d) => {
      const n = Number(v);
      if (!Number.isFinite(n)) return d;
      return Math.max(45, Math.min(75, Math.round(n)));
    };
    const clampEntropy = (v, d) => {
      const n = Number(v);
      if (!Number.isFinite(n)) return d;
      const clipped = Math.max(1.10, Math.min(1.55, n));
      return Number((Math.round(clipped / 0.05) * 0.05).toFixed(2));
    };
    const clampElo = (v, d) => {
      const n = Number(v);
      if (!Number.isFinite(n)) return d;
      const clipped = Math.max(0, Math.min(300, n));
      return Math.round(clipped / 5) * 5;
    };

    return {
      probaMin: clampProb(src.probaMin ?? fb.probaMin, 55),
      minConfidence: clampProb(src.minConfidence ?? fb.minConfidence, 55),
      entropyMax: clampEntropy(src.entropyMax ?? fb.entropyMax, 1.40),
      eloDiffMin: clampElo(src.eloDiffMin ?? fb.eloDiffMin, 0)
    };
  }

  function normalizeTopX12Custom(raw) {
    if (!raw || typeof raw !== "object") return null;

    const fallback = {
      probaMin: raw.probaMin,
      minConfidence: raw.minConfidence,
      entropyMax: raw.entropyMax,
      eloDiffMin: raw.eloDiffMin
    };

    const home = normalizeTopX12ThresholdSet(raw.homeThresholds, fallback);
    const away = normalizeTopX12ThresholdSet(raw.awayThresholds, fallback);

    return {
      loadedProfileId: String(raw.loadedProfileId || ""),
      enableFilters: raw.enableFilters !== false,
      sort: String(raw.sort || "confidence"),
      leagues: Array.isArray(raw.leagues) ? raw.leagues.slice() : [],
      homeThresholds: home,
      awayThresholds: away
    };
  }

  function normalizeEntropyForTopX12(rawEntropy) {
    const entropy = Number(rawEntropy);
    if (!Number.isFinite(entropy)) return null;

    if (entropy >= 0 && entropy <= ENTROPY_MAX_BITS + 0.05) {
      return Math.min(entropy, ENTROPY_MAX_BITS);
    }
    if (entropy > 2 && entropy <= 100) return (entropy / 100) * ENTROPY_MAX_BITS;
    if (entropy > 100) return ENTROPY_MAX_BITS;
    return 0;
  }

  function getTopCandidateOutcomeRanking(candidate) {
    const toShare = (raw) => {
      const pct = toPercentValue(raw);
      return Number.isFinite(pct) ? pct / 100 : 0;
    };

    return [
      { key: "home", share: toShare(candidate?.p_home), index: 0 },
      { key: "draw", share: toShare(candidate?.p_draw), index: 1 },
      { key: "away", share: toShare(candidate?.p_away), index: 2 }
    ].sort((a, b) => b.share - a.share || a.index - b.index);
  }

  function getTopCandidateEloDiff(candidate) {
    const direct = Number(candidate?.elo_diff ?? candidate?.eloDiff ?? candidate?.elo_gap ?? candidate?.eloGap);
    if (Number.isFinite(direct)) return Math.abs(direct);

    const home = Number(candidate?.elo_home);
    const away = Number(candidate?.elo_away);
    if (Number.isFinite(home) && Number.isFinite(away)) return Math.abs(home - away);

    return null;
  }

  function matchesWizardX12Custom(candidate, x12Custom) {
    if (!x12Custom || x12Custom.enableFilters === false) return true;
    if (candidate?.type !== "1X2") return true;

    const ranking = getTopCandidateOutcomeRanking(candidate);
    const favoriteKey = ranking[0]?.key;
    const th = favoriteKey === "away"
      ? (x12Custom.awayThresholds || x12Custom.homeThresholds)
      : (x12Custom.homeThresholds || x12Custom.awayThresholds);

    if (!th) return true;

    const mainProb = Number(candidate?.prob ?? 0);
    const confidence = Number(displayedPickConfidenceForCandidate(candidate) ?? candidate?._conf_display ?? candidate?._conf ?? 0);
    const entropy = normalizeEntropyForTopX12(candidate?.entropy_raw);
    const eloDiff = getTopCandidateEloDiff(candidate);

    if (mainProb < Number(th.probaMin || 0)) return false;
    if (confidence < Number(th.minConfidence || 0)) return false;
    if (Number.isFinite(entropy) && entropy > Number(th.entropyMax || 99)) return false;

    if (Number(th.eloDiffMin || 0) > 0) {
      if (!Number.isFinite(eloDiff)) return false;
      if (eloDiff < Number(th.eloDiffMin || 0)) return false;
    }

    return true;
  }

  function getActiveModeSummary(){
    if (isCustomProfileSelection() && profilesApi){
      const profile = profilesApi.getProfile(activeModeSelection.slice(8));
      if (profile){
        return {
          label: profile.name,
          description: profile.description || t.mode_profile_desc_fallback
        };
      }
    }
    return getBuiltInModeMeta(activeDisplayMode);
  }

  function setModeMenuOpen(isOpen){
    if (!modeMenuButton || !modeMenuPanel) return;
    modeMenuOpen = !!isOpen;
    modeMenuButton.setAttribute("aria-expanded", modeMenuOpen ? "true" : "false");
    if (modeMenu) modeMenu.classList.toggle("is-open", modeMenuOpen);
    modeMenuPanel.hidden = !modeMenuOpen;
  }

  function renderModeMenu(){
    const summary = getActiveModeSummary();
    const profileLoaded = isCustomProfileSelection();
    const defaultProfileLabel = lang === "es" ? "Mi perfil" : lang === "en" ? "My profile" : "Mon profil";
    const defaultProfileLabelMobile = lang === "es" ? "Perfil" : lang === "en" ? "Profile" : "Profil";
    const selectedProfileName = profileLoaded && summary?.label
      ? String(summary.label)
      : "";

    if (modeMenuCurrent) {
      modeMenuCurrent.textContent = selectedProfileName || defaultProfileLabel;
    }
    if (modeMenuCurrentMobile) {
      // On affiche aussi le vrai nom sur mobile. Le CSS autorise 2 lignes et
      // conserve le title complet sur le bouton en cas de nom très long.
      modeMenuCurrentMobile.textContent = selectedProfileName || defaultProfileLabelMobile;
    }
    if (modeMenuCurrentMeta) {
      modeMenuCurrentMeta.textContent = profileLoaded
        ? (lang === "es" ? "Perfil activo" : lang === "en" ? "Active profile" : "Profil actif")
        : (lang === "es" ? "Personalizado" : lang === "en" ? "Custom" : "Personnalisé");
    }
    if (modeMenuButton) {
      modeMenuButton.classList.toggle("is-active", profileLoaded);
      modeMenuButton.title = profileLoaded
        ? selectedProfileName
        : (lang === "es" ? "Mi perfil personalizado" : lang === "en" ? "My custom profile" : "Mon profil personnalisé");
      modeMenuButton.setAttribute(
        "aria-label",
        profileLoaded
          ? ((lang === "es" ? "Perfil activo: " : lang === "en" ? "Active profile: " : "Profil actif : ") + selectedProfileName)
          : (lang === "es" ? "Mi perfil personalizado" : lang === "en" ? "My custom profile" : "Mon profil personnalisé")
      );
    }
    if (!modeMenuBuiltins || !modeMenuProfiles) return;

    const builtinModes = ["performance", "high", "ultra", "all"];
    modeMenuBuiltins.innerHTML = "";
    builtinModes.forEach((mode) => {
      const meta = getBuiltInModeMeta(mode);
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "tp-mode-option";
      if (activeModeSelection === `builtin:${mode}`) btn.classList.add("is-active");
      btn.dataset.selection = `builtin:${mode}`;
      btn.innerHTML = `
        <span class="tp-mode-option__title">${meta.label}</span>
        <span class="tp-mode-option__desc">${meta.description}</span>
      `;
      modeMenuBuiltins.appendChild(btn);
    });

    modeMenuProfiles.innerHTML = "";
    const profiles = profilesApi ? profilesApi.getWizardProfiles() : [];

    const panelHead = document.createElement("div");
    panelHead.className = "tp-profile-panel__head";
    panelHead.innerHTML = `
      <strong>${lang === "es" ? "Mis perfiles Top Pronósticos" : lang === "en" ? "My Top Predictions profiles" : "Mes profils Top Pronostics"}</strong>
      <span>${lang === "es" ? "Configuraciones multimercado compatibles" : lang === "en" ? "Compatible multi-market setups" : "Configurations multi-marchés compatibles"}</span>
    `;
    modeMenuProfiles.appendChild(panelHead);

    if (!profiles.length){
      const empty = document.createElement("p");
      empty.className = "tp-mode-menu__empty";
      empty.textContent = t.mode_menu_profiles_empty;
      modeMenuProfiles.appendChild(empty);
      return;
    }

    profiles.forEach((profile) => {
      const isActiveProfile = activeModeSelection === `profile:${profile.id}`;
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "tp-mode-option tp-mode-option--profile";
      if (isActiveProfile) btn.classList.add("is-active");
      btn.dataset.selection = `profile:${profile.id}`;
      btn.innerHTML = `
        <span class="tp-mode-option__selector" aria-hidden="true"></span>
        <span class="tp-mode-option__copy">
          <span class="tp-mode-option__title">${escapeHtml(profile.name)}</span>
          <span class="tp-mode-option__desc">${escapeHtml(profile.description || t.mode_profile_desc_fallback)}</span>
        </span>
        <span class="tp-mode-option__state">${isActiveProfile
          ? (lang === "es" ? "Activo" : lang === "en" ? "Active" : "Actif")
          : (lang === "es" ? "Elegir" : lang === "en" ? "Choose" : "Choisir")}</span>
      `;
      modeMenuProfiles.appendChild(btn);
    });
  }

  function syncInlineModeButtons(){
    const profileActive = isCustomProfileSelection();
    if (inlineModeButtons.length){
      inlineModeButtons.forEach((btn) => {
        const isActive = !profileActive && String(btn.getAttribute("data-tp-selectivity-mode") || "") === activeDisplayMode;
        btn.classList.toggle("is-active", isActive);
        btn.setAttribute("aria-pressed", isActive ? "true" : "false");
      });
    }
    renderModeMenu();
  }

  function setTypeSliderValue(typeKey, value, options = {}){
    const slot = sliderByTypeKey[typeKey];
    if (!slot || !slot.el) return;
    if (typeKey !== "1X2") slot.el.max = String(MAX_THRESHOLD);

    const markTouched = !!options.markTouched;
    const rounded = typeKey === "1X2"
      ? normalize1X2ControlValue(value)
      : clampBusinessMarketFloor(
          typeKey,
          Math.max(MIN_THRESHOLD, Math.min(MAX_THRESHOLD, Math.round(Number(value) || MIN_THRESHOLD)))
        );
    slot.el.value = String(rounded);
    if (slot.valEl) {
      slot.valEl.textContent = typeKey === "1X2"
        ? get1X2LevelLabel(get1X2LevelFromThreshold(rounded))
        : String(rounded);
    }

    if (markTouched) touchedTypes.add(typeKey);
    else touchedTypes.delete(typeKey);
  }

  function saveComputedModeThresholds(mode, thresholds) {
    if (!thresholds || !mode) return;
    try {
      const raw = localStorage.getItem(COMPUTED_MODE_THRESHOLDS_KEY);
      const stored = raw ? JSON.parse(raw) : {};
      stored[mode] = normalizeThresholdPreset(thresholds, THRESHOLD_PRESETS.default);
      stored.ts = Date.now();
      localStorage.setItem(COMPUTED_MODE_THRESHOLDS_KEY, JSON.stringify(stored));
    } catch (_) {}
  }

  function applyThresholdPresetByType(preset, options = {}){
    if (!preset) return;
    const markTouched = !!options.markTouched;

    Object.keys(sliderByTypeKey).forEach((typeKey) => {
      const nextValue = Number(preset[typeKey]);
      if (!Number.isFinite(nextValue)) return;
      setTypeSliderValue(typeKey, nextValue, { markTouched });
    });

    updateAdvancedThresholdRates();
  }

  function buildThresholdPresetFromSuggestions(suggestions){
    const preset = {};
    Object.keys(sliderByTypeKey).forEach((typeKey) => {
      const suggested = Number(suggestions?.[typeKey]?.thr);
      if (!Number.isFinite(suggested)) return;
      preset[typeKey] = suggested;
    });
    return preset;
  }

  function computeLatestSuggestionsPreset(){
    const perfByType = buildGlobalPerfForSuggestions();
    const suggestions = computeTypeSuggestions(perfByType);
    lastSuggestions = suggestions || {};
    return buildThresholdPresetFromSuggestions(lastSuggestions);
  }

  async function applyRecommendedThresholdsFromLastSuggestions(){
    const preset = computeLatestSuggestionsPreset();
    if (!Object.keys(preset).length){
      applyThresholdPresetByType(THRESHOLD_PRESETS.default, { markTouched: false });
      updateAdvancedThresholdRates();
      return false;
    }

    applyThresholdPresetByType(preset, { markTouched: false });
    suggestionsAppliedOnce = true;
    syncAdvancedToggleUI();
    await filterAndRender();
    return true;
  }

  function getModeHintForConfig(mode, config) {
    if (mode === "performance") return withOptimizationModeHint(t.mode_hint_performance);
    if (mode === "high") {
      const leagueCount = Array.isArray(config?.leagues) ? config.leagues.length : 0;
      return withOptimizationModeHint(
        leagueCount ? t.mode_hint_high(leagueCount) : t.mode_hint_high_fallback
      );
    }
    if (mode === "ultra") {
      const leagueCount = Array.isArray(config?.leagues) ? config.leagues.length : 0;
      return withOptimizationModeHint(
        leagueCount ? t.mode_hint_ultra(leagueCount) : t.mode_hint_ultra_fallback
      );
    }
    return t.mode_hint_all;
  }

  function applyBuiltInModeThresholdConfig(mode, config, options = {}) {
    const preset = config?.source === "service"
      ? normalizeThresholdPreset(config?.thresholds, mode === "all" ? THRESHOLD_PRESETS.all : THRESHOLD_PRESETS.default)
      : applyBuiltInTotalsFloor(config?.thresholds, mode);
    const preferredDate = String(options.preferredDate || "").trim() || selectedDate;
    suggestionsAppliedOnce = true;
    applyThresholdPresetByType(preset, { markTouched: false });
    saveComputedModeThresholds(mode, preset);

    if (mode === "performance" || !(config?.leagues || []).length) {
      selectAllLeagues();
    } else {
      setLeagueSelection(config.leagues);
    }

    syncCurrentWindowMatchesFromSelection();
    renderDatePills(preferredDate);

    setModeHint(getModeHintForConfig(mode, config));
    automaticModeBaseline = captureAutomaticControls();
    automaticModeBaseline.markets = automaticModeBaseline.markets.map(() => true);
    syncAdvancedToggleUI();
  }

  async function applyPerformanceModeState(preferredDate = null, options = {}){
    const shouldRender = options.render !== false;
    await ensureAllLeaguesSource();
    const configs = getBuiltInModeDailyConfigs();
    if (!configs?.performance) {
      suggestionsAppliedOnce = true;
      applyThresholdPresetByType(
        applyBuiltInTotalsFloor(THRESHOLD_PRESETS.default, "performance"),
        { markTouched: false }
      );
      setModeHint(withOptimizationModeHint(t.mode_hint_performance));
      renderDatePills(preferredDate || selectedDate);
      if (shouldRender) await filterAndRender({ reason: "mode" });
      return;
    }

    applyBuiltInModeThresholdConfig("performance", configs.performance, { preferredDate });
    if (shouldRender) await filterAndRender({ reason: "mode" });
  }

  function setLeagueSelection(codes){
    const wanted = new Set(withForcedVisibleLeagues(codes));
    document.querySelectorAll(".league-button").forEach((btn) => {
      const code = String(btn.dataset.leagueCode || "").toUpperCase();
      btn.classList.toggle("selected", wanted.has(code));
    });
    syncLeagueSelectionLockUI();
  }

  function selectAllLeagues(){
    setLeagueSelection(LEAGUES.map((L) => L.code));
  }

  async function applyNewLeaguesPromptSelection(codes){
    setLeagueSelection(codes);
    syncCurrentWindowMatchesFromSelection();
    renderDatePills(selectedDate);
    await filterAndRender();
  }

  function captureCurrentProfileConfig(){
    return {
      baseMode: activeDisplayMode,
      range: elRange ? String(elRange.value || "all") : "all",
      group: elGroup ? String(elGroup.value || "match") : "match",
      sort: elSort ? String(elSort.value || "time") : "time",
      hidePast: !!(chkHidePast && chkHidePast.checked),
      expert: !!(elExpertMode && elExpertMode.checked),
      compact: !!(elCompactMode && elCompactMode.checked),
      advancedOpen: !!(elAdvanced && !elAdvanced.classList.contains("collapsed")),
      markets: {
        dc: !!(chkDC && chkDC.checked),
        dnb: !!(chkDNB && chkDNB.checked),
        x12: !!(chk1X2 && chk1X2.checked),
        under25: !!(chkUnder25 && chkUnder25.checked),
        over25: !!(chkOver25 && chkOver25.checked),
        over15: !!(chkOver15 && chkOver15.checked),
        under35: !!(chkUnder35 && chkUnder35.checked),
        btts: !!(chkBTTS && chkBTTS.checked),
      },
      thresholds: {
        DC: parseInt(elMinDC?.value || DEFAULT_THRESHOLD, 10),
        DNB: parseInt(elMinDNB?.value || DEFAULT_THRESHOLD, 10),
        "1X2": normalize1X2ControlValue(elMin1X2?.value || DEFAULT_THRESHOLD),
        U25: parseInt(elMinU25?.value || DEFAULT_THRESHOLD, 10),
        O25: parseInt(elMinO25?.value || DEFAULT_THRESHOLD, 10),
        O15: Math.max(75, parseInt(elMinO15?.value || 75, 10)),
        U35: Math.max(70, parseInt(elMinU35?.value || 70, 10)),
        BTTS: parseInt(elMinBTTS?.value || DEFAULT_THRESHOLD, 10),
      },
      minConfidence: parseInt(document.getElementById("pp-min-confidence")?.value ?? activeProfileMinConfidence, 10),
      stabilityFilter: document.getElementById("pp-stability-filter")?.value || activeProfileStabilityFilter,
      leagues: selectedLeagues()
    };
  }

  async function applyProfileConfig(rawProfile, options = {}){
    if (!rawProfile) return false;
    const profile = profilesApi?.normalizeProfile
      ? profilesApi.normalizeProfile(rawProfile)
      : rawProfile;
    if (!profile) return false;
    appliedProfileSignature = JSON.stringify(profile);

    activeProfileMinConfidence = Math.max(0, Math.min(100, Math.round(Number(profile.minConfidence) || 0)));
    activeProfileStabilityFilter = ["all", "correct_plus", "stable_only", "ultra_only", "risk_only"].includes(profile.stabilityFilter)
      ? profile.stabilityFilter
      : "all";

    // Les profils personnalisés doivent rester 100% fidèles aux seuils sauvegardés :
    // aucun offset automatique, aucun reorder, aucun cache journalier des built-in.
    setActiveModeSelection(`profile:${profile.id}`, { persist: options.persist !== false });
    await applyDisplayMode(profile.baseMode || "performance", { render: false });

    if (elRange && profile.range) elRange.value = profile.range;
    if (elGroup && profile.group) elGroup.value = profile.group;
    if (elSort && profile.sort) elSort.value = profile.sort;

    if (chkHidePast) chkHidePast.checked = !!profile.hidePast;
    if (elExpertMode) elExpertMode.checked = !!profile.expert;
    if (elCompactMode) elCompactMode.checked = !!profile.compact;

    if (chkDC) chkDC.checked = profile.markets?.dc !== false;
    if (chkDNB) chkDNB.checked = profile.markets?.dnb !== false;
    if (chk1X2) chk1X2.checked = profile.markets?.x12 !== false;
    if (chkUnder25) chkUnder25.checked = profile.markets?.under25 !== false;
    if (chkOver25) chkOver25.checked = profile.markets?.over25 !== false;
    if (chkOver15) chkOver15.checked = profile.markets?.over15 !== false;
    if (chkUnder35) chkUnder35.checked = profile.markets?.under35 !== false;
    if (chkBTTS) chkBTTS.checked = profile.markets?.btts !== false;

    applyThresholdPresetByType(profile.thresholds || THRESHOLD_PRESETS.default, { markTouched: true });

    const ppMinConf = document.getElementById("pp-min-confidence");
    const ppStabFilter = document.getElementById("pp-stability-filter");
    if (ppMinConf) ppMinConf.value = String(activeProfileMinConfidence);
    if (ppStabFilter) ppStabFilter.value = activeProfileStabilityFilter;
    activeWizardX12Custom = normalizeTopX12Custom(profile.x12Custom);

    if (profile.leagues?.length) setLeagueSelection(profile.leagues);
    else selectAllLeagues();

    if (elAdvanced){
      elAdvanced.classList.toggle("collapsed", !profile.advancedOpen);
      syncAdvancedToggleUI();
    }

    profileControlsBaseline = captureAutomaticControls();
    setModeHint(profile.description || t.mode_profile_hint(profile.name));
    if (windowMatchesFullRaw && windowMatchesFullRaw.length) {
      syncCurrentWindowMatchesFromSelection();
      renderDatePills(selectedDate);
      await filterAndRender({ reason: "profile" });
    } else {
      await reloadWindow({ reason: "profile" });
    }
    applyExpertModeToCards(!!profile.expert);
    applyCompactModeToCards(!!profile.compact);
    syncInlineModeButtons();
    if (typeof window.gtag === "function") {
      window.gtag("event", "tp_profile_loaded", {
        profile_id: profile.id || "",
        profile_name: profile.name || "",
        base_mode: profile.baseMode || "performance",
        min_confidence: profile.minConfidence || 0,
        stability_filter: profile.stabilityFilter || "all"
      });
    }
    return true;
  }

  async function applyBuiltInMode(mode, options = {}){
    if (options.preserveRelaxation !== true) {
      markTopModeUserInteraction();
    }
    const normalized = (mode === "all" || mode === "high" || mode === "ultra")
      ? mode
      : "performance";
    setActiveModeSelection(`builtin:${normalized}`, { persist: options.persist !== false });
    await applyDisplayMode(normalized);
    return true;
  }

  function candidatePassesProfileFilters(
    candidate,
    minConfidence = activeProfileMinConfidence,
    stabilityFilter = activeProfileStabilityFilter
  ) {
    const normalizedMinConfidence = Math.max(0, Math.min(100, Math.round(Number(minConfidence) || 0)));
    if ((candidate?._conf_display ?? candidate?._conf ?? 0) < normalizedMinConfidence) return false;

    if (stabilityFilter === "all") return true;
    const badge = get1X2StabilityBadge(candidate);
    if (stabilityFilter === "ultra_only") return badge.key === "ultra_stable";
    if (stabilityFilter === "stable_only") return badge.key === "ultra_stable" || badge.key === "stable";
    if (stabilityFilter === "correct_plus") {
      return badge.key === "ultra_stable" || badge.key === "stable" || badge.key === "correct";
    }
    return true;
  }

  function setBuilderThreshold(typeKey, value, options = {}){
    if (options.preserveRelaxation !== true) {
      markTopModeUserInteraction();
    }
    setTypeSliderValue(typeKey, value, { markTouched: options.markTouched !== false });
    updateAdvancedThresholdRates();
    syncAdvancedToggleUI();
    if (options.render) {
      filterAndRender();
    }
    return true;
  }

  function setBuilderMarketEnabled(marketKey, enabled, options = {}){
    if (options.preserveRelaxation !== true) {
      markTopModeUserInteraction();
    }
    const key = String(marketKey || "").toLowerCase();
    const toggleMap = {
      dc: chkDC,
      dnb: chkDNB,
      x12: chk1X2,
      under25: chkUnder25,
      over25: chkOver25,
      over15: chkOver15,
      under35: chkUnder35,
      btts: chkBTTS
    };
    const checkbox = toggleMap[key];
    if (!checkbox) return false;
    checkbox.checked = !!enabled;
    if (options.render) {
      filterAndRender();
    }
    return true;
  }

  async function ensureAllLeaguesSource(){
    selectAllLeagues();
    if (!(windowMatchesFullRaw && windowMatchesFullRaw.length)){
      await ensureWindowDataLoaded();
    }

    syncCurrentWindowMatchesFromSelection();
    renderDatePills(selectedDate);
    return (windowMatchesFullRaw && windowMatchesFullRaw.length) ? windowMatchesFullRaw : windowMatchesFull;
  }

  function candidateTypeKey(c){
    if (!c) return null;
    if (c.type === "DC") return "DC";
    if (c.type === "DNB") return "DNB";
    if (c.type === "1X2") return "1X2";
    if (c.type === "TOT"){
      if (c.sub === "U2.5") return "U25";
      if (c.sub === "O2.5") return "O25";
      if (c.sub === "O1.5") return "O15";
      if (c.sub === "U3.5") return "U35";
      if (c.sub === "BTTS") return "BTTS";
    }
    return null;
  }

  const NATIONAL_TOP_PRONOSTICS_COMPETITIONS = new Set([
    "INT_FRIENDLIES", "UEFA_NATIONS_LEAGUE", "AFCON_QUALIFICATION",
    "CONCACAF_NATIONS_LEAGUE", "WORLD_CUP_2026",
  ]);

  function isNationalTopPronosticsCompetition(league){
    return NATIONAL_TOP_PRONOSTICS_COMPETITIONS.has(String(league || "").trim().toUpperCase());
  }

  function resolveNationalCandidateRule(match, payload){
    const competition = String(match?.league || "").trim().toUpperCase();
    if (!isNationalTopPronosticsCompetition(competition)) return null;
    const market = candidateTypeKey(payload);
    const competitionConfig = topPronosticsPerformanceIndex?.national_team_mode_config;
    const modeConfig = competitionConfig?.modes?.[activeDisplayMode];
    const rawThreshold = modeConfig?.thresholds?.[market];
    const threshold = Number(rawThreshold);
    const enabled = competitionConfig?.status === "available"
      && competitionConfig?.history_sufficient === true
      && competitionConfig?.thresholds_available === true
      && ["performance", "high", "ultra"].includes(activeDisplayMode)
      && Array.isArray(modeConfig?.enabled_markets)
      && modeConfig.enabled_markets.includes(market)
      && rawThreshold != null
      && Number.isFinite(threshold);
    return { enabled, threshold, competition, market };
  }

  function resolveCandidateThreshold(match, payload, clubThreshold){
    const national = resolveNationalCandidateRule(match, payload);
    if (!national) return { enabled: true, threshold: clubThreshold, national: false };
    return { enabled: national.enabled, threshold: national.threshold, national: true };
  }

  function candidateMarketFamilyLabel(c){
    if (!c) return t.details_na;
    if (c.type === "DC") return lang === "es" ? "Doble oportunidad" : lang === "en" ? "Double Chance" : "Double chance";
    if (c.type === "DNB") return "DNB";
    if (c.type === "1X2") return "1X2";
    if (c.type === "TOT") return lang === "es" ? "Goles" : lang === "en" ? "Goals" : "Buts";
    return c.type || t.details_na;
  }

  function buildPerfByTypeFromMatches(matches, minProbPerf = 30){
    const source = Array.isArray(matches) ? matches : [];
    const perfByType = {
      DC: { total: 0, wins: 0, voids: 0, buckets: {} },
      DNB: { total: 0, wins: 0, voids: 0, buckets: {} },
      "1X2": { total: 0, wins: 0, voids: 0, buckets: {} },
      U25: { total: 0, wins: 0, voids: 0, buckets: {} },
      O25: { total: 0, wins: 0, voids: 0, buckets: {} },
      O15: { total: 0, wins: 0, voids: 0, buckets: {} },
      U35: { total: 0, wins: 0, voids: 0, buckets: {} },
      BTTS: { total: 0, wins: 0, voids: 0, buckets: {} },
    };

    for (const m of source){
      const cands = buildCandidatesForPerfBase(m, minProbPerf);
      for (const c of cands){
        const key = candidateTypeKey(c);
        if (!key || !perfByType[key]) continue;

        const o = outcomeForCandidate(c);
        if (!o) continue;

        const grp = perfByType[key];
        if (o === "void") grp.voids++;
        else {
          grp.total++;
          if (o === "win") grp.wins++;
        }

        const p = getCandidateFilterScore(c);
        const bucketKey = Math.floor(p / 5) * 5;
        const buckets = grp.buckets;
        const b = buckets[bucketKey] || (buckets[bucketKey] = { prob: bucketKey, total: 0, wins: 0, voids: 0 });
        if (o === "void") b.voids++;
        else {
          b.total++;
          if (o === "win") b.wins++;
        }
      }
    }

    return perfByType;
  }

  function buildHighPerformanceThresholds(matches){
    const source = getModeOptimizationSource(matches);
    const perfByType = buildPerfByTypeFromMatches(source, 30);
    const out = { ...THRESHOLD_PRESETS.all };
    const thresholdLadder = [85, 80, 75, 70, 65, 60, 55, 50, 45, 40, 35, 33];

    Object.keys(sliderByTypeKey).forEach((typeKey) => {
      const group = perfByType?.[typeKey];
      if (!group) return;
      const minThreshold = getTypeMinThresholdForBuiltInMode(typeKey, "high");

      const minVolume = typeKey === "BTTS"
        ? Math.max(4, HIGH_PERF_MIN_TYPE_VOLUME - 2)
        : HIGH_PERF_MIN_TYPE_VOLUME;

      const samples = [];
      for (const thr of thresholdLadder){
        const stats = thresholdHitRate(group, thr);
        if (!stats || stats.total < minVolume) continue;
        samples.push({ thr, ...stats });
      }
      if (!samples.length) {
        out[typeKey] = clampModeThreshold(Math.max(out[typeKey] || MIN_THRESHOLD, minThreshold));
        return;
      }

      const overTarget = samples
        .filter((x) => x.rate >= HIGH_PERF_TARGET_RATE)
        .sort((a, b) => (b.rate - a.rate) || (b.thr - a.thr) || (b.total - a.total));

      if (overTarget.length){
        out[typeKey] = clampModeThreshold(Math.max(overTarget[0].thr, minThreshold));
        return;
      }

      const fallback = samples
        .slice()
        .sort((a, b) => {
          const scoreA = a.rate + (a.thr * 0.04) + Math.min(a.total, 40) * 0.2;
          const scoreB = b.rate + (b.thr * 0.04) + Math.min(b.total, 40) * 0.2;
          return scoreB - scoreA;
        })[0];

      if (fallback) {
        out[typeKey] = clampModeThreshold(Math.max(fallback.thr, minThreshold));
      }
    });

    return applyBuiltInTotalsFloor(out, "high");
  }

  function buildLeagueStatsForPreset(matches, preset){
    const byLeague = new Map();
    const source = Array.isArray(matches) ? matches : [];

    for (const m of source){
      const cands = buildCandidatesForPerfBase(m, 0);
      for (const c of cands){
        const typeKey = candidateTypeKey(c);
        if (!typeKey || typeKey === "1X2") continue;

        const thr = Number(preset?.[typeKey] ?? ALL_MATCHES_THRESHOLD);
        if (getCandidateFilterScore(c) < thr) continue;

        const outcome = outcomeForCandidate(c);
        if (!outcome || outcome === "void") continue;

        const league = String(c.league || "").toUpperCase();
        if (!league) continue;

        if (!byLeague.has(league)){
          byLeague.set(league, { league, wins: 0, total: 0 });
        }

        const row = byLeague.get(league);
        row.total += 1;
        if (outcome === "win") row.wins += 1;
      }
    }

    return Array.from(byLeague.values()).map((x) => ({
      ...x,
      rate: x.total ? (x.wins / x.total) * 100 : 0,
    }));
  }

  function selectHighPerformanceLeagues(matches, preset){
    const source = getModeOptimizationSource(matches);
    const leagueStats = buildLeagueStatsForPreset(source, preset);
    if (!leagueStats.length) return [];

    const strict = leagueStats
      .filter((x) => x.total >= HIGH_PERF_MIN_LEAGUE_VOLUME && x.rate >= HIGH_PERF_TARGET_RATE)
      .sort((a, b) => (b.rate - a.rate) || (b.total - a.total))
      .slice(0, HIGH_PERF_MAX_LEAGUES)
      .map((x) => x.league);

    if (strict.length) return strict;

    const fallback = leagueStats
      .filter((x) => x.total >= 4)
      .sort((a, b) => {
        const scoreA = xScore(a);
        const scoreB = xScore(b);
        return scoreB - scoreA;
      })
      .slice(0, Math.min(8, leagueStats.length))
      .map((x) => x.league);

    return fallback;

    function xScore(x){
      return x.rate + Math.min(x.total, 30) * 0.7;
    }
  }

  async function applyUltraHighPerformanceMode(source, preferredDate = null, options = {}){
    const shouldRender = options.render !== false;
    const configs = getBuiltInModeDailyConfigs();
    if (configs?.ultra) {
      applyBuiltInModeThresholdConfig("ultra", configs.ultra, { preferredDate });
      if (shouldRender) await filterAndRender({ reason: "mode" });
      return;
    }

    const highThresholds = buildHighPerformanceThresholds(source);
    suggestionsAppliedOnce = true;
    applyThresholdPresetByType(highThresholds, { markTouched: false });
    saveComputedModeThresholds("ultra", highThresholds);
    renderDatePills(preferredDate || selectedDate);
    setModeHint(withOptimizationModeHint(t.mode_hint_ultra_fallback));
    if (shouldRender) await filterAndRender({ reason: "mode" });
  }

  async function applyDisplayMode(mode, options = {}){
    pendingDisplayMode = {
      mode: String(mode || "performance"),
      render: options.render !== false
    };
    if (isApplyingDisplayMode) return displayModeTask;

    displayModeTask = (async () => {
      isApplyingDisplayMode = true;
      try {
        while (pendingDisplayMode != null){
          const pending = pendingDisplayMode;
          pendingDisplayMode = null;
          const requestedMode = String(pending?.mode || "performance");
          const shouldRender = pending?.render !== false;

          const previousMode = activeDisplayMode;
          if (Object.prototype.hasOwnProperty.call(modeSelectedDateMemory, previousMode) && selectedDate) {
            modeSelectedDateMemory[previousMode] = selectedDate;
          }

          activeDisplayMode = (requestedMode === "all" || requestedMode === "high" || requestedMode === "ultra")
            ? requestedMode
            : "performance";
          const preferredDateForMode =
            modeSelectedDateMemory[activeDisplayMode] || selectedDate || null;

          if (isBuiltInAutomaticSelection()){
            activeModeSelection = `builtin:${activeDisplayMode}`;
          }

          syncLeagueSelectionLockUI();
          syncInlineModeButtons();
          if (elDisplayMode && elDisplayMode.value !== activeDisplayMode){
            elDisplayMode.value = activeDisplayMode;
          }

          // A saved profile owns its controls; never run an automatic fallback
          // or overwrite its fixed thresholds while loading/refreshing it.
          if (isCustomProfileSelection()) continue;
          if (!getRemoteBuiltInModeConfigs()?.[activeDisplayMode]) {
            automaticModeBaseline = null;
            updateSelectionState();
            if (shouldRender) await filterAndRender({ reason: "mode" });
            continue;
          }

          if (activeDisplayMode === "all"){
            await ensureAllLeaguesSource();
            const configs = getBuiltInModeDailyConfigs();
            if (configs?.all) {
              applyBuiltInModeThresholdConfig("all", configs.all, { preferredDate: preferredDateForMode });
            } else {
              suggestionsAppliedOnce = true;
              applyThresholdPresetByType(THRESHOLD_PRESETS.all, { markTouched: false });
              saveComputedModeThresholds("all", THRESHOLD_PRESETS.all);
              setModeHint(t.mode_hint_all);
              renderDatePills(preferredDateForMode);
            }
            if (shouldRender) await filterAndRender({ reason: "mode" });
            continue;
          }

          if (activeDisplayMode === "performance"){
            await applyPerformanceModeState(preferredDateForMode, { render: shouldRender });
            continue;
          }

          const source = await ensureAllLeaguesSource();
          const configs = getBuiltInModeDailyConfigs();

          if (activeDisplayMode === "ultra"){
            if (configs?.ultra) {
              applyBuiltInModeThresholdConfig("ultra", configs.ultra, { preferredDate: preferredDateForMode });
              if (shouldRender) await filterAndRender({ reason: "mode" });
            } else {
              await applyUltraHighPerformanceMode(source, preferredDateForMode, { render: shouldRender });
            }
            continue;
          }

          if (configs?.high) {
            applyBuiltInModeThresholdConfig("high", configs.high, { preferredDate: preferredDateForMode });
            if (shouldRender) await filterAndRender({ reason: "mode" });
          } else {
            const highThresholds = buildHighPerformanceThresholds(source);
            applyThresholdPresetByType(highThresholds, { markTouched: false });
            saveComputedModeThresholds("high", highThresholds);
            renderDatePills(preferredDateForMode);
            setModeHint(withOptimizationModeHint(t.mode_hint_high_fallback));
            if (shouldRender) await filterAndRender({ reason: "mode" });
          }
        }
      } finally {
        isApplyingDisplayMode = false;
      }
    })();

    return displayModeTask;
  }

  function getModeRelaxationChain(mode) {
    if (mode === "ultra") return ["high", "performance"];
    if (mode === "high") return ["performance"];
    return [];
  }

  async function applyInitialModeRelaxationIfNeeded() {
    initialModeRelaxationPending = false;
  }

  // API
  function normalizeLeagueMarketsMatch(m, league){
    return {
      ...m,
      league: String(m?.league || league || "").toUpperCase(),
      p_home: m?.probabilities?.home ?? null,
      p_draw: m?.probabilities?.draw ?? null,
      p_away: m?.probabilities?.away ?? null,
      btts: m?.markets?.btts ?? null,
      over25: m?.markets?.over25 ?? null,
      under25: m?.markets?.under25 ?? null,
      over15: m?.markets?.over15 ?? null,
      under35: m?.markets?.under35 ?? null,
      dnb_home: m?.markets?.dnb_home ?? null,
      dnb_away: m?.markets?.dnb_away ?? null,
      double_chance_1x: m?.markets?.double_chance_1x ?? null,
      double_chance_x2: m?.markets?.double_chance_x2 ?? null,
      double_chance_12: m?.markets?.double_chance_12 ?? null,
      entropy_raw:
        m?.entropy ??
        m?._confidence_raw?.entropy ??
        m?._confidence_raw?.conf_entropy ??
        null,
      confidence_raw:
        m?.confidence?.conf_final ??
        m?._confidence ??
        m?.confidence ??
        m?.confidence_index ??
        m?.confidence_score ??
        null,
      confidence_ml_raw: m?.confidence?.conf_ml ?? null,
      confidence_hist_raw: m?.confidence?.conf_hist ?? null,
      confidence_final_raw: m?.confidence?.conf_final ?? null,
      confidence_hist_matches: m?.confidence?.conf_hist_matches ?? null,
      elo_home: m?.elo?.home ?? m?.elo_home ?? null,
      elo_away: m?.elo?.away ?? m?.elo_away ?? null,
      rank_home: m?.rank_home ?? m?.ranks?.home ?? m?.home_rank ?? null,
      rank_away: m?.rank_away ?? m?.ranks?.away ?? m?.away_rank ?? null,
      _stability_badge: normalizeApi1X2StabilityBadgeKey(
        m?.stability_badge ??
        m?.stabilityBadge ??
        m?.stability_1x2
      ) || "",
      stability_badge: normalizeApi1X2StabilityBadgeKey(
        m?.stability_badge ??
        m?.stabilityBadge ??
        m?.stability_1x2
      ) || "",
      stability_1x2: m?.stability_1x2 ?? null,
      stability_version: m?.stability_version ?? null,
    };
  }

  function contextWatchPayloadFromMatch(match) {
    const payload = {
      stability_context: (
        match?.stability_context && typeof match.stability_context === "object"
      ) ? { ...match.stability_context } : {}
    };
    CONTEXT_WATCH_FIELDS.forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(match || {}, key)) {
        payload[key] = match[key];
      }
    });
    return payload;
  }

  async function mapLimit(items, limit, mapper) {
    const list = Array.isArray(items) ? items : [];
    const safeLimit = Math.max(1, Number(limit) || 1);
    const results = new Array(list.length);
    let cursor = 0;

    async function worker() {
      while (cursor < list.length) {
        const idx = cursor;
        cursor += 1;
        results[idx] = await mapper(list[idx], idx);
      }
    }

    const workers = Array.from(
      { length: Math.min(safeLimit, list.length) },
      () => worker()
    );
    await Promise.all(workers);
    return results;
  }

  async function fetchLeagueFeed(league, start, days){
    const url = `${API_LEAGUE_MARKETS}?league=${encodeURIComponent(league)}&start=${encodeURIComponent(start)}&days=${days}&include=all`;
    try {
      const r = await fetch(url, { cache: refreshingSources ? "no-cache" : "default", headers: { Accept: "application/json" } });
      if (!r.ok) return [];
      const j = await r.json();
      const arr = (Array.isArray(j.matches) ? j.matches : [])
        .filter((m) => !m || m.prediction_quality !== "shadow_insufficient_data");
      return arr.map((m) => normalizeLeagueMarketsMatch(m, league));
    } catch (e) {
      console.warn("league_markets fetch failed", league, e);
      return [];
    }
  }

  async function fetchLeagueFeedWindow(league, start, days){
    const totalDays = Math.max(1, Number(days) || 1);
    const chunks = [];
    let cursor = String(start || todayISO());
    let remaining = totalDays;

    while (remaining > 0) {
      const chunkDays = Math.min(remaining, MAX_LEAGUE_MARKETS_DAYS_PER_REQUEST);
      chunks.push({ start: cursor, days: chunkDays });
      cursor = addDays(cursor, chunkDays);
      remaining -= chunkDays;
    }

    const results = [];
    for (const chunk of chunks) {
      results.push(await fetchLeagueFeed(league, chunk.start, chunk.days));
    }

    const merged = [];
    const seen = new Set();
    results.flat().forEach((match) => {
      const key = [
        String(match?.league || "").toUpperCase(),
        String(match?.utc || ""),
        String(match?.home || ""),
        String(match?.away || ""),
      ].join("|");
      if (seen.has(key)) return;
      seen.add(key);
      merged.push(match);
    });

    return merged;
  }

  async function fetchLeagueMarketsBulk(leagues, start, days, include = "all") {
    const leagueCodes = (Array.isArray(leagues) ? leagues : [])
      .map((league) => String(league?.code || league || "").toUpperCase())
      .filter(Boolean);

    const params = new URLSearchParams({
      start: String(start || ""),
      days: String(Math.max(1, Number(days) || 1)),
      include: String(include || "all"),
    });

    if (leagueCodes.length) {
      params.set("leagues", leagueCodes.join(","));
    }

    const url = `${API_LEAGUE_MARKETS_BULK}?${params.toString()}`;
    const cacheKey = [
      String(start || ""),
      String(Math.max(1, Number(days) || 1)),
      String(include || "all"),
      leagueCodes.join(",") || "__ALL__",
    ].join("|");

    if (leagueMarketsBulkCache.has(cacheKey)) {
      return leagueMarketsBulkCache.get(cacheKey);
    }
    if (leagueMarketsBulkInFlight.has(cacheKey)) {
      return leagueMarketsBulkInFlight.get(cacheKey);
    }

    const task = (async () => {
      const response = await fetch(url, { cache: refreshingSources ? "no-cache" : "default", headers: { Accept: "application/json" } });
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }
      if (refreshingSources && response.headers?.get("X-Foresportia-Cache") === "STALE") throw new Error("stale market response");
      const payload = await response.json();
      if (!payload || typeof payload !== "object" || !payload.leagues || typeof payload.leagues !== "object") {
        throw new Error("bad_bulk_payload");
      }
      if (payload.ok === false) {
        throw new Error("bulk_not_ok");
      }
      leagueMarketsBulkCache.set(cacheKey, payload);
      return payload;
    })();

    leagueMarketsBulkInFlight.set(cacheKey, task);
    try {
      return await task;
    } finally {
      leagueMarketsBulkInFlight.delete(cacheKey);
    }
  }

  function matchesFromLeagueMarketsBulkPayload(payload, requestedLeagues) {
    const leagueBlocks = payload?.leagues || {};
    if (refreshingSources && (Object.keys(payload?.errors || {}).length || requestedLeagues.some(league => leagueBlocks[String(league?.code || league).toUpperCase()]?.ok !== true))) throw new Error("partial market refresh");
    const rows = [];

    requestedLeagues.forEach((league) => {
      const leagueCode = String(league?.code || league || "").toUpperCase();
      if (!leagueCode) return;

      const entry = leagueBlocks[leagueCode];
      if (!entry) {
        console.warn("league_markets_bulk missing league", leagueCode);
        return;
      }
      if (entry.ok !== true) {
        console.warn("league_markets_bulk league error", leagueCode, entry);
        return;
      }

      const data = (Array.isArray(entry.data)
        ? entry.data
        : (Array.isArray(entry.matches) ? entry.matches : []))
        .filter((m) => !m || m.prediction_quality !== "shadow_insufficient_data");
      data.forEach((match) => {
        rows.push(normalizeLeagueMarketsMatch(match, leagueCode));
      });
    });

    if (payload?.errors && typeof payload.errors === "object" && Object.keys(payload.errors).length) {
      console.warn("league_markets_bulk errors", payload.errors);
    }

    return rows;
  }

  async function fetchLeagueFeedBulkWindow(leagues, start, days) {
    const totalDays = Math.max(1, Number(days) || 1);
    const chunks = [];
    let cursor = String(start || todayISO());
    let remaining = totalDays;

    while (remaining > 0) {
      const chunkDays = Math.min(remaining, MAX_LEAGUE_MARKETS_DAYS_PER_REQUEST);
      chunks.push({ start: cursor, days: chunkDays });
      cursor = addDays(cursor, chunkDays);
      remaining -= chunkDays;
    }

    const payloads = await Promise.all(
      chunks.map((chunk) => fetchLeagueMarketsBulk(leagues, chunk.start, chunk.days, "all"))
    );

    const merged = [];
    const seen = new Set();
    payloads.forEach((payload) => {
      matchesFromLeagueMarketsBulkPayload(payload, leagues).forEach((match) => {
        const key = [
          String(match?.league || "").toUpperCase(),
          String(match?.utc || ""),
          String(match?.home || ""),
          String(match?.away || ""),
        ].join("|");
        if (seen.has(key)) return;
        seen.add(key);
        merged.push(match);
      });
    });

    return merged;
  }

  async function fetchLeagueFeedWindowFallback(leagues, start, days, onProgress) {
    const totalLeagues = leagues.length;
    let loadedLeagues = 0;
    const perLeague = await mapLimit(leagues, 4, async (leagueMeta) => {
      const leagueCode = String(leagueMeta?.code || leagueMeta || "").toUpperCase();
      const rows = await fetchLeagueFeedWindow(leagueCode, start, days);
      loadedLeagues += 1;
      if (typeof onProgress === "function") {
        onProgress(loadedLeagues, totalLeagues);
      }
      return rows;
    });

    return perLeague.flat();
  }

  // Thresholds per type
  function getTypeThreshold(type, sub){
    const defaultThr = 30;
    if (type === "DC") return elMinDC ? parseInt(elMinDC.value || defaultThr, 10) : defaultThr;
    if (type === "DNB") return elMinDNB ? parseInt(elMinDNB.value || defaultThr, 10) : defaultThr;
    if (type === "1X2") return normalize1X2ControlValue(elMin1X2 ? elMin1X2.value : defaultThr);

    if (type === "TOT"){
      if (sub === "U2.5") return elMinU25 ? parseInt(elMinU25.value || defaultThr, 10) : defaultThr;
      if (sub === "O2.5") return elMinO25 ? parseInt(elMinO25.value || defaultThr, 10) : defaultThr;
      if (sub === "O1.5") return elMinO15 ? parseInt(elMinO15.value || 75, 10) : 75;
      if (sub === "U3.5") return elMinU35 ? parseInt(elMinU35.value || 70, 10) : 70;
      if (sub === "BTTS") return elMinBTTS ? parseInt(elMinBTTS.value || defaultThr, 10) : defaultThr;
    }
    return defaultThr;
  }

  // Per-mode market gating — mirror of the backend performance_index.py, which
  // disables whole markets whose observed rate is below the mode floor (e.g.
  // Under 2.5 at 22% < 65% in performance mode). The decision is precomputed by
  // the backend and shipped in top_pronostics_performance_index.modes[mode]
  // (disabled_markets / enabled_markets). Custom profiles opt out — they drive
  // markets through their own checkboxes, not mode gating.
  function getActiveModeDisabledMarketSet(){
    if (!isBuiltInAutomaticSelection()) return null;
    const mode = activeDisplayMode;
    if (mode === "all") return null;
    const modeCfg = topPronosticsPerformanceIndex?.modes?.[mode];
    if (!modeCfg || typeof modeCfg !== "object") return null;

    const disabled = new Set();
    const disabledMap = modeCfg.disabled_markets;
    if (disabledMap && typeof disabledMap === "object"){
      Object.keys(disabledMap).forEach((key) => disabled.add(key));
    }
    const enabled = Array.isArray(modeCfg.enabled_markets) ? modeCfg.enabled_markets : null;
    if (enabled){
      CHIP_TYPE_KEYS.forEach((typeKey) => {
        if (!enabled.includes(typeKey)) disabled.add(typeKey);
      });
    }
    return disabled.size ? disabled : null;
  }
  // Business publication kill switches — single source of truth serialized by the
  // backend (top_pronostics_performance_index.market_publication.publication_enabled).
  // Applies in EVERY mode (all/performance/high/ultra) and to custom profiles: a
  // globally-disabled market (e.g. Under 2.5) is never published anywhere.
  function getBusinessDisabledMarketSet(){
    const pub = topPronosticsPerformanceIndex?.market_publication?.publication_enabled;
    const policy = pub && typeof pub === "object" ? pub : FAIL_SAFE_PUBLICATION_ENABLED;
    const disabled = new Set();
    ANALYTICAL_TYPE_KEYS.forEach((typeKey) => { if (policy[typeKey] !== true) disabled.add(typeKey); });
    return disabled.size ? disabled : null;
  }
  function getActiveModeMarketScope(typeKey){
    if (!isBuiltInAutomaticSelection()) return null;
    const mode = activeDisplayMode;
    if (!mode || mode === "all") return null;
    const rawScope = topPronosticsPerformanceIndex?.modes?.[mode]?.leagues_by_market?.[typeKey];
    if (!Array.isArray(rawScope)) return null;
    const scope = new Set(
      rawScope.map((league) => String(league || "").trim().toUpperCase()).filter(Boolean)
    );
    return scope;
  }
  function isCandidateAllowedByActiveModeMarketScope(candidate, typeKey){
    const scope = getActiveModeMarketScope(typeKey);
    if (!scope) return true;
    const league = String(candidate?.league || "").trim().toUpperCase();
    return !!league && scope.has(league);
  }
  function filterDisabledMarketCandidates(cands){
    const modeDisabled = getActiveModeDisabledMarketSet();
    const businessDisabled = getBusinessDisabledMarketSet();
    return cands.filter((c) => {
      const key = candidateTypeKey(c);
      if (!key) return true;
      if (businessDisabled && businessDisabled.has(key)) return false;
      if (isNationalTopPronosticsCompetition(c.league)) {
        const national = resolveNationalCandidateRule(c, c);
        return !!national?.enabled;
      }
      if (modeDisabled && modeDisabled.has(key)) return false;
      if (!isCandidateAllowedByActiveModeMarketScope(c, key)) return false;
      return true;
    });
  }

  function nonPlayableCandidatePassesActiveSelection(candidate){
    if (!fixtureStatus.classify(candidate).disabled) return true;
    const typeKey = candidateTypeKey(candidate);
    if (!typeKey) return false;

    const thresholdRule = resolveCandidateThreshold(
      candidate,
      candidate,
      getTypeThreshold(candidate.type, candidate.sub)
    );
    if (!thresholdRule.enabled) return false;
    if (candidate.type === "1X2") {
      return matches1X2BadgeLevel(
        candidate._x12Badge || get1X2StabilityBadge(candidate).key,
        get1X2LevelForActiveMode(thresholdRule.threshold)
      );
    }
    if (!isNum(candidate.prob) || Number(candidate.prob) < Number(thresholdRule.threshold)) return false;
    return filterDisabledMarketCandidates([candidate]).length === 1;
  }

  // Single Double Chance per match — strict mirror of the backend
  // _select_best_double_chance (performance_index.py). 1X / X2 are mechanically
  // correlated (two of three DC win for any result), so keeping both doubles the
  // DC observations and drags the aggregate rate toward the ~66.7% mechanical
  // mean. Keep only the highest predicted probability (pre-match only, never the
  // score); deterministic tie-break 1X < X2 < 12.
  const DC_TIE_ORDER = { "1X": 0, "X2": 1, "12": 2 };
  function selectBestDoubleChance(cands){
    const dc = cands.filter((c) => c.type === "DC");
    if (dc.length <= 1) return cands;
    let best = dc[0];
    for (const c of dc){
      const cp = isNum(c.prob) ? Number(c.prob) : -Infinity;
      const bp = isNum(best.prob) ? Number(best.prob) : -Infinity;
      if (cp !== bp){ if (cp > bp) best = c; continue; }
      if ((DC_TIE_ORDER[c.sub] ?? 9) < (DC_TIE_ORDER[best.sub] ?? 9)) best = c;
    }
    return cands.filter((c) => c.type !== "DC" || c === best);
  }

  // Over/Under 2.5 mutual exclusion — strict mirror of the backend
  // apply_goals_25_exclusion (performance_index.py). Two rules, scoped to the
  // goals_25 family (Over 2.5 / Under 2.5) only:
  //   1. Product floor: drop any side whose probability is < 50%.
  //   2. Mutual exclusion: keep at most one side, ranked by
  //      edge = prob - threshold, then higher probability, then Over 2.5.
  // BTTS and every other market pass through untouched.
  function isGoals25Candidate(c){
    return !!c && c.type === "TOT" && (c.sub === "O2.5" || c.sub === "U2.5");
  }
  function goals25Edge(c){
    const prob = isNum(c.prob) ? Number(c.prob) : 0;
    const thr = isNum(c._thr) ? Number(c._thr) : 0;
    return prob - thr;
  }
  function applyGoals25Exclusion(cands){
    const goalsAll = cands.filter(isGoals25Candidate);
    if (!goalsAll.length) return cands;
    const others = cands.filter((c) => !isGoals25Candidate(c));
    // Cluster policy gate — strict mirror of backend is_goal_pick_allowed
    // (currently Under 2.5 only). A cluster-forbidden U2.5 (high-scoring / UEFA
    // clusters, or outside the [min,max] band) is dropped here so it is never
    // published even when the market is globally enabled by the backend index.
    const goals = goalsAll.filter((c) => isGoalPickAllowed(candidateTypeKey(c), c.league, c.prob));
    if (!goals.length) return others;
    const eligible = goals.filter((c) => isNum(c.prob) && Number(c.prob) >= GOALS_25_MIN_PROBABILITY);
    if (!eligible.length) return others;

    let best = eligible[0];
    for (const c of eligible){
      const cEdge = goals25Edge(c);
      const bEdge = goals25Edge(best);
      if (cEdge !== bEdge){ if (cEdge > bEdge) best = c; continue; }
      const cProb = isNum(c.prob) ? Number(c.prob) : 0;
      const bProb = isNum(best.prob) ? Number(best.prob) : 0;
      if (cProb !== bProb){ if (cProb > bProb) best = c; continue; }
      if (c.sub === "O2.5" && best.sub !== "O2.5") best = c;
    }
    // Preserve original ordering; the winning goals_25 pick keeps its slot.
    return cands.filter((c) => !isGoals25Candidate(c) || c === best);
  }

  // Candidates builder
  function buildCandidates(m, options = {}){
    const fixtureLifecycle = fixtureStatus.classify(m);
    // Non-playable fixtures remain visible for traceability. They are tagged
    // below and excluded from active counters/statistics, but still reuse the
    // historical prediction to build a disabled card with an explicit status.
    if (!fixtureStatus.countsAsAvailable(m) && !fixtureLifecycle.disabled) return [];
    const out = [];
    const leagueSelected = isMatchInLeagueSelection(m, options.selectedLeagueSet);
    const ph = pct(m.p_home), pd = pct(m.p_draw), pa = pct(m.p_away);
    const btts = pct(m.btts), over25 = pct(m.over25), under25 = pct(m.under25);
    const over15 = pct(m.over15), under35 = pct(m.under35);

    let dc1x = pct(m.double_chance_1x), dcx2 = pct(m.double_chance_x2);
    if (!isNum(dc1x) && isNum(ph) && isNum(pd)) dc1x = ph + pd;
    if (!isNum(dcx2) && isNum(pa) && isNum(pd)) dcx2 = pa + pd;

    const dnbH = pct(m.dnb_home), dnbA = pct(m.dnb_away);
    const primary1X2 = chk1X2.checked ? buildPrimary1X2Candidate(m) : null;
    const allowLinkedStableDc = !leagueSelected && options.includeGlobal1X2 && ["ultra_stable", "stable"].includes(primary1X2?._x12Badge);

    const add = (ok, payload) => {
      const resolved = resolveCandidateThreshold(m, payload, getTypeThreshold(payload.type, payload.sub));
      if (!resolved.enabled) return;
      const thr = resolved.threshold;
      if (payload.type === "1X2") {
        if (resolved.national) {
          if (isNum(ok) && ok >= thr) out.push({ ...payload, _thr: thr, _nationalCalibration: true });
          return;
        }
        if (matches1X2BadgeLevel(payload._x12Badge, get1X2LevelForActiveMode(thr))) {
          out.push({ ...payload, _thr: thr });
        }
        return;
      }
      if (!isNum(ok)) return;
      if (ok >= thr) out.push({ ...payload, _thr: thr, _nationalCalibration: resolved.national });
    };

    if (chkDC.checked && (leagueSelected || allowLinkedStableDc)){
      if (leagueSelected) {
        add(dc1x, { type:"DC", sub:"1X", label: t.label_dc1x(localizeTeamLabel(m.home, m?.league)), prob: dc1x });
        add(dcx2, { type:"DC", sub:"X2", label: t.label_dcx2(localizeTeamLabel(m.away, m?.league)), prob: dcx2 });
      } else {
        buildLinkedDoubleChanceCandidates(m, primary1X2).forEach((candidate) => {
          add(candidate.prob, candidate);
        });
      }
    }

    if (leagueSelected && chkDNB.checked){
      add(dnbH, { type:"DNB", sub:"H", label: t.label_dnb_home(localizeTeamLabel(m.home, m?.league)), prob: dnbH });
      add(dnbA, { type:"DNB", sub:"A", label: t.label_dnb_away(localizeTeamLabel(m.away, m?.league)), prob: dnbA });
    }

    if ((options.includeGlobal1X2 || leagueSelected) && chk1X2.checked){
      if (primary1X2) add(primary1X2.prob, primary1X2);
    }

    if (leagueSelected && chkUnder25.checked) add(under25, { type:"TOT", sub:"U2.5", label: t.label_u25, prob: under25 });
    if (leagueSelected && chkOver25.checked) add(over25, { type:"TOT", sub:"O2.5", label: t.label_o25, prob: over25 });
    if (leagueSelected && chkOver15.checked) add(over15, { type:"TOT", sub:"O1.5", label: t.label_o15, prob: over15 });
    if (leagueSelected && chkUnder35.checked) add(under35, { type:"TOT", sub:"U3.5", label: t.label_u35, prob: under35 });
    if (leagueSelected && chkBTTS.checked) add(btts, { type:"TOT", sub:"BTTS", label: t.label_btts, prob: btts });

    out.forEach((x) => Object.assign(x, {
      league: m.league,
      utc: m.utc,
      kickoff_iso: m.kickoff_iso,
      home: m.home,
      match_id: m.match_id ?? null,
      fixture_id: m.fixture_id ?? m.fixture ?? null,
      match_url: m.match_url ?? null,
      match_page_state: m.match_page_state ?? m.page_state ?? null,
      pick_ids: Array.isArray(m.pick_ids) ? m.pick_ids : [],
      follow_locked_at: typeof m.follow_locked_at === "string" ? m.follow_locked_at : null,
      away: m.away,
      p_home: m.p_home ?? null,
      p_draw: m.p_draw ?? null,
      p_away: m.p_away ?? null,
      entropy_raw: m.entropy_raw ?? null,
      confidence_raw: m.confidence_raw ?? null,
      confidence_ml_raw: m.confidence_ml_raw ?? null,
      confidence_hist_raw: m.confidence_hist_raw ?? null,
      confidence_final_raw: m.confidence_final_raw ?? null,
      confidence_hist_matches: m.confidence_hist_matches ?? null,
      elo_home: m.elo_home,
      elo_away: m.elo_away,
      rank_home: m.rank_home ?? null,
      rank_away: m.rank_away ?? null,
      form_index_home: m.form_index_home ?? null,
      form_index_away: m.form_index_away ?? null,
      current_win_streak_home: m.current_win_streak_home ?? null,
      current_win_streak_away: m.current_win_streak_away ?? null,
      current_unbeaten_streak_home: m.current_unbeaten_streak_home ?? null,
      current_unbeaten_streak_away: m.current_unbeaten_streak_away ?? null,
      current_loss_streak_home: m.current_loss_streak_home ?? null,
      current_loss_streak_away: m.current_loss_streak_away ?? null,
      last_results_home: m.last_results_home ?? "",
      last_results_away: m.last_results_away ?? "",
      recent_points_per_match_home: m.recent_points_per_match_home ?? null,
      recent_points_per_match_away: m.recent_points_per_match_away ?? null,
      recent_matches_home: m.recent_matches_home ?? null,
      recent_matches_away: m.recent_matches_away ?? null,
      matches_played_home: m.matches_played_home ?? null,
      matches_played_away: m.matches_played_away ?? null,
      goals_for_home: m.goals_for_home ?? null,
      goals_for_away: m.goals_for_away ?? null,
      goals_against_home: m.goals_against_home ?? null,
      goals_against_away: m.goals_against_away ?? null,
      avg_goals_for_home: m.avg_goals_for_home ?? null,
      avg_goals_for_away: m.avg_goals_for_away ?? null,
      avg_goals_against_home: m.avg_goals_against_home ?? null,
      avg_goals_against_away: m.avg_goals_against_away ?? null,
      top_scores: m.top_scores || null,
      score: m.score || null,
      status: m.status || null,
      provider_status: m.provider_status || null,
      fixture_state: m.fixture_state || null,
      prediction_active: m.prediction_active,
      counts_as_available: m.counts_as_available,
      counts_in_performance: m.counts_in_performance,
      ...contextWatchPayloadFromMatch(m)
    }));

    return applyGoals25Exclusion(filterDisabledMarketCandidates(selectBestDoubleChance(out)));
  }

  // Balanced top (same)
  function buildBalancedTop(cands, topN){
    cands = filterDisabledMarketCandidates(cands);
    const active = {
      DC: chkDC.checked,
      DNB: chkDNB.checked,
      "1X2": chk1X2.checked,
      TOT: chkUnder25.checked || chkOver25.checked || chkOver15.checked || chkUnder35.checked || chkBTTS.checked,
    };

    const q = {
      DC: active.DC ? Math.max(2, Math.floor(topN * 0.4)) : 0,
      DNB: active.DNB ? Math.max(1, Math.floor(topN * 0.2)) : 0,
      "1X2": active["1X2"] ? Math.max(2, Math.floor(topN * 0.25)) : 0,
      TOT: active.TOT ? topN : 0,
    };

    cands.sort((a,b) => b.prob - a.prob);

    const used = { DC:0, DNB:0, "1X2":0, TOT:0 };
    const seen = new Set();
    const out = [];

    for (const c of cands){
      const key = `${c.utc}|${c.home}|${c.away}|${c.type}|${c.sub || ""}`;
      if (seen.has(key)) continue;
      if (q[c.type] === 0) continue;

      if (used[c.type] < q[c.type] || out.length < topN){
        out.push(c);
        used[c.type]++;
        seen.add(key);
        if (out.length === topN) break;
      }
    }
    return out.slice(0, topN);
  }

  function outcomeForCandidate(c){
    const overlay = window.ForesportiaLiveScoreOverlay;
    const score = overlay?.performanceScoreFor ? overlay.performanceScoreFor(c) : null;
    if (overlay?.performanceScoreFor && !score) return null;
    if (!score && !fixtureStatus.countsInPerformance(c)) return null;
    if (!score && (!c.score || !/^\d+-\d+$/.test(c.score))) return null;
    const [sh, se] = score ? [score.home, score.away] : c.score.split("-").map((n) => parseInt(n,10));
    if (!Number.isFinite(sh) || !Number.isFinite(se)) return null;

    const real = sh > se ? "home" : sh < se ? "away" : "draw";
    const total = sh + se;

    switch (c.type){
      case "1X2":
        if (c.sub === "1") return real === "home" ? "win" : "lose";
        if (c.sub === "2") return real === "away" ? "win" : "lose";
        if (c.sub === "N") return real === "draw" ? "win" : "lose";
        return null;

      case "DC":
        if (c.sub === "1X") return (real === "home" || real === "draw") ? "win" : "lose";
        if (c.sub === "X2") return (real === "away" || real === "draw") ? "win" : "lose";
        return null;

      case "DNB":
        if (real === "draw") return "void";
        if (c.sub === "H") return real === "home" ? "win" : "lose";
        if (c.sub === "A") return real === "away" ? "win" : "lose";
        return null;

      case "TOT":
        if (c.sub === "O2.5") return total >= 3 ? "win" : "lose";
        if (c.sub === "U2.5") return total <= 2 ? "win" : "lose";
        if (c.sub === "O1.5") return total >= 2 ? "win" : "lose";
        if (c.sub === "U3.5") return total <= 3 ? "win" : "lose";
        if (c.sub === "BTTS") return (sh > 0 && se > 0) ? "win" : "lose";
        return null;

      default:
        return null;
    }
  }

  function compactPickLabel(c) {
    if (!c) return "";
    if (c.type === "DC") return c.sub || "DC";
    if (c.type === "DNB") return `DNB ${c.sub === "A" ? "2" : "1"}`;
    if (c.type === "1X2") {
      const badge = get1X2BadgePresentation(String(c._x12Badge || ""));
      return badge?.value ? `${c.sub || "1X2"} (${badge.value})` : (c.sub || "1X2");
    }
    if (c.type === "TOT") return c.sub || "TOT";
    return c.type || "";
  }

  function compactOutcomeLabel(outcomeKey) {
    if (outcomeKey === "win") return t.compact_result_win;
    if (outcomeKey === "lose") return t.compact_result_lose;
    if (outcomeKey === "void") return t.compact_result_void;
    return t.compact_result_pending;
  }

  function compactPickFamily(c) {
    if (!c) return { label: "Pick", tone: "neutral", shortLabel: "" };
    if (c.type === "DC") return { label: "DC", tone: "dc", shortLabel: c.sub || "DC" };
    if (c.type === "DNB") return { label: "DNB", tone: "dnb", shortLabel: c.sub === "A" ? "2" : "1" };
    if (c.type === "1X2") {
      const badge = get1X2BadgePresentation(String(c._x12Badge || ""));
      return { label: "1X2", tone: "1x2", shortLabel: badge?.value || c.sub || "1X2" };
    }
    if (c.type === "TOT" && c.sub === "BTTS") {
      return { label: "BTTS", tone: "btts", shortLabel: lang === "es" ? "Sí" : lang === "en" ? "Yes" : "Oui" };
    }
    if (c.type === "TOT") return { label: lang === "es" ? "Goles" : lang === "en" ? "Goals" : "Buts", tone: "goals", shortLabel: c.sub || "TOT" };
    return { label: c.type || "Pick", tone: "neutral", shortLabel: compactPickLabel(c) };
  }

  function renderCompactPickRow(c, shareUrl) {
    if (!c) return "";
    const lifecycle = fixtureStatus.classify(c);
    const outcomeKey = outcomeForCandidate(c) || "pending";
    const prob = Number(c.prob || 0);
    const family = compactPickFamily(c);
    return `
      <span class="tp-compact-pick-row tp-compact-pick-row--${outcomeKey} tp-compact-pick-row--${family.tone}${lifecycle.disabled ? " fs-fixture-pick-disabled" : ""}">
        <span class="tp-compact-pick-row__type">${family.label}</span>
        <span class="tp-compact-pick-row__label">${c.label || family.shortLabel}</span>
        <strong class="tp-compact-pick-row__prob">${prob.toFixed(0)}%</strong>
        <span class="tp-compact-pick-row__result">${lifecycle.disabled ? fixtureStatus.labelFor(lifecycle.state, lang) : compactOutcomeLabel(outcomeKey)}</span>
        ${renderPickOverflowMenu(c, shareUrl)}
      </span>
    `.trim();
  }

  function renderCompactSummary(kickoff, home, away, picks, bodyId, expanded, shareUrl, leagueName, leagueFlagHtml) {
    const compactKickoff = fmtCompactKickoffLocal(picks?.[0]) || kickoff;
    const compactPicks = Array.isArray(picks) ? picks : [];
    const c0 = compactPicks[0] || {};
    const homeLabel = escapeHtml(localizeTeamLabel(home, c0.league));
    const awayLabel = escapeHtml(localizeTeamLabel(away, c0.league));
    const picksHtml = compactPicks.map((pick) => renderCompactPickRow(pick, shareUrl)).join("");
    const countHtml = compactPicks.length
      ? `<span class="tp-match-summary__count">${t.compact_pick_count(compactPicks.length)}</span>`
      : "";

    const compactCw = (window.FSContextWatch && typeof window.FSContextWatch.renderCompactContextWarningBadge === "function")
      ? window.FSContextWatch.renderCompactContextWarningBadge(c0, { lang })
      : "";

    const rankText = (value) => {
      const n = Number(value);
      if (!Number.isFinite(n) || n <= 0) return "";
      return lang === "en" ? `#${Math.round(n)}` : `${Math.round(n)}e`;
    };
    const homeRank = rankText(c0.rank_home);
    const awayRank = rankText(c0.rank_away);

    // La liste des picks reste visible dans la vue de scan : le match sert de
    // conteneur, le pick reste l'information principale.
    return `
      <div class="tp-match-summary-shell">
        <button
          type="button"
          class="tp-match-summary"
          data-tp-compact-toggle
          aria-expanded="${expanded ? "true" : "false"}"
          aria-controls="${bodyId}"
          aria-label="${expanded ? t.compact_hide : t.compact_show}">
          <span class="tp-match-summary__time">${compactKickoff}</span>
          <span class="tp-match-summary__league">
            ${leagueFlagHtml || ""}
            <span>${leagueName || ""}</span>
          </span>
          <span class="tp-match-summary__teams">
            <span class="tp-match-summary__team" title="${homeLabel}">
              <img class="tp-compact-team-logo" alt=""/>
              <span class="tp-match-summary__team-copy"><strong>${homeLabel}</strong>${homeRank ? `<small>${homeRank}</small>` : ""}</span>
            </span>
            <span class="tp-match-summary__sep">VS</span>
            <span class="tp-match-summary__team" title="${awayLabel}">
              <img class="tp-compact-team-logo" alt=""/>
              <span class="tp-match-summary__team-copy"><strong>${awayLabel}</strong>${awayRank ? `<small>${awayRank}</small>` : ""}</span>
            </span>
          </span>
          <span class="tp-match-summary__meta">${compactCw}${countHtml}</span>
          <span class="tp-match-summary__caret" aria-hidden="true">⌄</span>
        </button>
        ${picksHtml ? `<span class="tp-match-summary__list">${picksHtml}</span>` : ""}
      </div>
    `.trim();
  }

  const PICK_ID_RE = /^fsp:v1:[a-f0-9]{64}$/;

  function candidatePickCoordinates(candidate) {
    if (!candidate) return null;
    if (candidate.type === "1X2") {
      return { market: "1x2", selection: candidate.sub === "1" ? "home" : candidate.sub === "N" ? "draw" : candidate.sub === "2" ? "away" : "" };
    }
    if (candidate.type === "DC") {
      return { market: "double_chance", selection: candidate.sub === "1X" ? "home_or_draw" : candidate.sub === "X2" ? "draw_or_away" : candidate.sub === "12" ? "home_or_away" : "" };
    }
    if (candidate.type === "DNB") {
      return { market: "dnb", selection: candidate.sub === "H" ? "home" : candidate.sub === "A" ? "away" : "" };
    }
    if (candidate.type === "TOT" && candidate.sub === "O2.5") return { market: "over_2_5", selection: "over" };
    if (candidate.type === "TOT" && candidate.sub === "U2.5") return { market: "under_2_5", selection: "under" };
    if (candidate.type === "TOT" && candidate.sub === "O1.5") return { market: "over_1_5", selection: "over" };
    if (candidate.type === "TOT" && candidate.sub === "U3.5") return { market: "under_3_5", selection: "under" };
    if (candidate.type === "TOT" && candidate.sub === "BTTS") return { market: "btts", selection: "yes" };
    return null;
  }

  function resolveCandidatePickId(candidate) {
    const coordinates = candidatePickCoordinates(candidate);
    if (!coordinates || !Array.isArray(candidate?.pick_ids)) return null;
    const entry = candidate.pick_ids.find((item) => {
      return item && item.market === coordinates.market && item.selection === coordinates.selection;
    });
    const pickId = typeof entry?.pick_id === "string" ? entry.pick_id : "";
    return PICK_ID_RE.test(pickId) ? pickId : null;
  }

  function renderFollowAction(candidate, options) {
    if (!followActionEnabled) return "";
    // Carte démo du tour : icône visuelle uniquement (sans data-tp-follow,
    // le contrôleur follow l'ignore et un clic ne déclenche rien).
    const isTourDemo = candidate && candidate._tour_demo === true;
    const pickId = isTourDemo ? null : resolveCandidatePickId(candidate);
    if (!isTourDemo && !pickId) return "";
    const aria = lang === "es" ? "Añadir a Mis pronósticos" : lang === "en" ? "Add to My predictions" : "Ajouter à Mes pronostics";
    // Server-computed follow deadline (UX only — the API re-checks at POST time).
    const lockedAtRaw = typeof candidate?.follow_locked_at === "string" ? candidate.follow_locked_at : "";
    const lockedAttr = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/.test(lockedAtRaw) ? ' data-locked-at="' + lockedAtRaw + '"' : "";
    const hookAttrs = isTourDemo ? 'data-tp-follow-demo' : 'data-tp-follow data-pick-id="' + pickId + '"' + lockedAttr;
    // Variante compacte : bouton en flux (grille de la pick row), pas en absolu.
    const buttonClass = options && options.compact === true ? "tp-follow-button tp-follow-button--compact" : "tp-follow-button";
    // Icône SVG inline (pas d'emoji) : rendu identique sur mobile, Windows et macOS.
    return [
      '<button type="button" class="' + buttonClass + '" ' + hookAttrs + ' aria-label="' + aria + '" title="' + aria + '" aria-pressed="false">',
      '<svg class="tp-follow-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">',
      '<path d="M7 4.75h10a.75.75 0 0 1 .75.75v14.1a.4.4 0 0 1-.64.32L12 16.1l-5.11 3.82a.4.4 0 0 1-.64-.32V5.5A.75.75 0 0 1 7 4.75Z"/>',
      '</svg>',
      '</button>'
    ].join("");
  }

  function buildPickShareText(candidate) {
    const homeLabel = localizeTeamLabel(candidate?.home || "", candidate?.league);
    const awayLabel = localizeTeamLabel(candidate?.away || "", candidate?.league);
    const lines = [
      `${homeLabel} vs ${awayLabel}`,
      `${lang === "es" ? "Pronóstico" : lang === "en" ? "Pick" : "Pronostic"} : ${candidate?.label || compactPickLabel(candidate) || ""}`
    ];
    const probability = Number(candidate?.prob);
    if (Number.isFinite(probability)) {
      lines.push(`${lang === "es" ? "Probabilidad" : lang === "en" ? "Probability" : "Probabilité"} : ${probability.toFixed(1)}%`);
    }
    return lines.filter(Boolean).join("\n");
  }

  function renderPickOverflowMenu(candidate, shareUrl) {
    if (!followActionEnabled) return "";
    const isTourDemo = candidate && candidate._tour_demo === true;
    const shareOnly = fixtureStatus.classify(candidate).state === fixtureStatus.STATES.FINISHED;
    const pickId = isTourDemo ? null : resolveCandidatePickId(candidate);
    if (!isTourDemo && !pickId && !shareOnly) return "";
    const lockedAtRaw = typeof candidate?.follow_locked_at === "string" ? candidate.follow_locked_at : "";
    const lockedAttr = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/.test(lockedAtRaw) ? ` data-locked-at="${lockedAtRaw}"` : "";
    const followAttrs = isTourDemo ? "data-tp-follow-demo" : `data-tp-follow data-pick-id="${pickId}"${lockedAttr}`;
    const coordinates = candidatePickCoordinates(candidate);
    const market = escapeHtml(coordinates?.market || candidate?.type || "");
    const league = escapeHtml(candidate?.league || "");
    const menuLabel = lang === "es" ? "Acciones del pronóstico" : lang === "en" ? "Prediction actions" : "Actions du pronostic";
    const followedMenuLabel = lang === "es" ? "Acciones del pronóstico — pronóstico seguido" : lang === "en" ? "Prediction actions — prediction followed" : "Actions du pronostic — pronostic suivi";
    const addLabel = lang === "es" ? "Hacer mi pronóstico" : lang === "en" ? "Make my prediction" : "Faire mon prono";
    const removeLabel = lang === "es" ? "Quitar mi pronóstico" : lang === "en" ? "Remove my prediction" : "Retirer mon prono";
    const alertsLabel = lang === "es" ? "Activar alertas" : lang === "en" ? "Turn on alerts" : "Activer les alertes";
    const shareLabel = lang === "es" ? "Compartir el pronóstico" : lang === "en" ? "Share prediction" : "Partager le pronostic";
    const triggerMenuLabel = shareOnly ? shareLabel : menuLabel;
    const triggerFollowedMenuLabel = shareOnly ? shareLabel : followedMenuLabel;
    const shareText = buildPickShareText(candidate);
    const shareTitle = `${localizeTeamLabel(candidate?.home || "", candidate?.league)} vs ${localizeTeamLabel(candidate?.away || "", candidate?.league)}`.trim() || "Foresportia";
    const safeUrl = escapeHtml(shareUrl || "");
    return `
      <span class="tp-pick-overflow" data-tp-pick-overflow${shareOnly ? " data-share-only=\"true\"" : ""} data-market="${market}" data-league="${league}">
        <button type="button" class="tp-pick-overflow__trigger" data-tp-pick-menu-trigger data-menu-label="${triggerMenuLabel}" data-followed-menu-label="${triggerFollowedMenuLabel}" aria-label="${triggerMenuLabel}" aria-haspopup="menu" aria-expanded="false"><span class="tp-pick-overflow__dots" aria-hidden="true"></span></button>
        <span class="tp-pick-overflow__menu" role="menu" hidden>
          ${shareOnly ? "" : `<button type="button" class="tp-pick-overflow__item tp-pick-overflow__favorite" role="menuitem" ${followAttrs} data-market="${market}" data-league="${league}" aria-pressed="false">
            <span class="tpv6-overflow-icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M7 4.75h10a.75.75 0 0 1 .75.75v14.1a.4.4 0 0 1-.64.32L12 16.1l-5.11 3.82a.4.4 0 0 1-.64-.32V5.5A.75.75 0 0 1 7 4.75Z"/></svg></span>
            <span class="tp-pick-overflow__add">${addLabel}</span><span class="tp-pick-overflow__remove">${removeLabel}</span>
          </button>
          <button type="button" class="tp-pick-overflow__item" role="menuitem" data-tp-notify data-pick-id="${pickId || ""}" data-market="${market}" data-league="${league}" data-selection="${escapeHtml(coordinates?.selection || "")}" data-surface="top_predictions"${isTourDemo ? " disabled" : ""}>
            <span class="tpv6-overflow-icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4"/></svg></span>
            <span>${alertsLabel}</span>
          </button>`}
          <button type="button" class="tp-pick-overflow__item" role="menuitem" data-tp-pick-share data-share-title="${escapeHtml(shareTitle)}" data-share-text="${escapeHtml(shareText)}" data-share-url="${safeUrl}"${safeUrl ? "" : " disabled"}>
            <span class="tpv6-overflow-icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M8 12v6.25A1.75 1.75 0 0 0 9.75 20h8.5A1.75 1.75 0 0 0 20 18.25v-8.5A1.75 1.75 0 0 0 18.25 8H12M15 5l-3-3-3 3M12 2v11"/></svg></span>
            <span>${shareLabel}</span>
          </button>
        </span>
      </span>
    `.trim();
  }

  // Render
  function renderPickRow(c){
    const lifecycle = fixtureStatus.classify(c);
    const prob = Number(c.prob || 0);
    function confLevel(conf){
      if (!Number.isFinite(conf)) return "conf-mid";
      // Color bands tuned for calibrated confidence without strict min-volume guard:
      // keep 50% as neutral (yellow), not low (red).
      if (conf < 48) return "conf-low";
      if (conf < 60) return "conf-mid";
      return "conf-high";
    }
    const conf = sortablePickConfidenceForCandidate(c);
    const confCls = confLevel(conf);
    const clampPct = (v) => (Number.isFinite(v) ? Math.max(0, Math.min(100, v)) : null);
    const probPct = clampPct(prob);
    const confPct = clampPct(conf);
    
    const o = outcomeForCandidate(c); // "win" | "lose" | "void" | null
    const outcomeClass =
      o === "win"  ? "tp-pick-row--win"  :
      o === "lose" ? "tp-pick-row--lose" :
      o === "void" ? "tp-pick-row--void" :
                    "tp-pick-row--pending";

    const baseLabel = c.label || "";
    const x12Badge = c.type === "1X2"
      ? get1X2BadgePresentation(String(c._x12Badge || ""))
      : null;
    const label = x12Badge?.value
      ? `${baseLabel}${baseLabel ? " · " : ""}${x12Badge.value}`
      : baseLabel;
    // Dans une ligne de pick, le badge identifie le code du marché. Le libellé
    // complet reste porté par le pronostic adjacent et ne doit pas comprimer
    // celui-ci sur les petits écrans.
    const marketFamily = c.type === "DC" ? "DC" : candidateMarketFamilyLabel(c);
    const resultLabel = lang === "es" ? "Resultado" : lang === "en" ? "Result" : "Résultat";

    const followActionHtml = renderPickOverflowMenu(c, c._canonicalShareUrl || "");

    const outcomeLabel =
      o === "win"  ? `${t.outcome_win} <small>(${c.score})</small>` :
      o === "lose" ? `${t.outcome_lose} <small>(${c.score})</small>` :
      o === "void" ? `${t.outcome_void} <small>(${c.score})</small>` :
                    lifecycle.disabled ? fixtureStatus.labelFor(lifecycle.state, lang) : t.outcome_pending;

    function renderMetricChip({ chipClass, metricLabel, metricValue, pct = null }) {
      const style = Number.isFinite(pct) ? ` style="--tp-chip-pct:${pct.toFixed(1)}%;"` : "";
      const meter = Number.isFinite(pct)
        ? '<span class="tp-chip__meter" aria-hidden="true"><span class="tp-chip__fill"></span></span>'
        : "";
      return `
        <span class="tp-chip tp-chip--metric ${chipClass}"${style}>
          <span class="tp-chip__k">${metricLabel}</span>
          <strong class="tp-chip__v">${metricValue}</strong>
          ${meter}
        </span>
      `.trim();
    }

    return `
      <div class="tp-pick-row ${outcomeClass}${lifecycle.disabled ? " fs-fixture-pick-disabled" : ""}">
        <div class="tp-pick-left">
          <div class="tp-pick-sub">${marketFamily}</div>
          <div class="tp-pick-label">${label}</div>
        </div>

        <div class="tp-pick-metrics">
          ${renderMetricChip({
            chipClass: "tp-chip--prob",
            metricLabel: t.prob_label,
            metricValue: `${prob.toFixed(1)}%`,
            pct: probPct
          })}
          ${renderMetricChip({
            chipClass: `tp-chip--conf ${confCls}`,
            metricLabel: t.confidence_label,
            metricValue: `${conf.toFixed(1)}%`,
            pct: confPct
          })}
          <span class="tp-chip tp-chip--outcome tp-outcome-${o || "pending"}">
            <span class="tp-chip__k">${resultLabel}</span>
            <strong class="tp-chip__v">${outcomeLabel}</strong>
          </span>
        </div>
        ${followActionHtml}
      </div>
    `;
  }

  function normalizeCanonicalMatchHref(value) {
    const href = String(value || "").trim();
    if (!href) return "";
    const validPublicPath = window.fsMatchPageLinks?.validPublicPath;
    return typeof validPublicPath === "function" && validPublicPath(href, lang) ? href : "";
  }

  function renderMatchFooterLinks({ matchHref, homeHref, awayHref, leagueHref, home, away, league, leagueName }) {
    const links = [];
    const labelMatch = lang === "en" ? "Match page" : lang === "es" ? "Página del partido" : "Page match";
    const labelLeague = lang === "en" ? "League" : lang === "es" ? "Liga" : "Ligue";

    if (matchHref) {
      links.push(`<a class="tpv18-card-link tpv18-card-link--match" href="${escapeHtml(matchHref)}">${labelMatch}<span aria-hidden="true">↗</span></a>`);
    }
    if (homeHref) {
      links.push(`<a class="tpv18-card-link" href="${escapeHtml(homeHref)}">${escapeHtml(localizeTeamLabel(home, league))}<span aria-hidden="true">↗</span></a>`);
    }
    if (awayHref) {
      links.push(`<a class="tpv18-card-link" href="${escapeHtml(awayHref)}">${escapeHtml(localizeTeamLabel(away, league))}<span aria-hidden="true">↗</span></a>`);
    }
    if (leagueHref) {
      links.push(`<a class="tpv18-card-link" href="${escapeHtml(leagueHref)}">${labelLeague} · ${escapeHtml(leagueName)}<span aria-hidden="true">↗</span></a>`);
    }

    if (!links.length) return "";
    return `
      <nav class="tpv18-card-links" aria-label="${lang === "en" ? "Explore match" : lang === "es" ? "Explorar el partido" : "Approfondir le match"}">
        <span class="tpv18-card-links__label">${lang === "en" ? "Useful links" : lang === "es" ? "Enlaces útiles" : "Voir aussi"}</span>
        <div class="tpv18-card-links__items">${links.join("")}</div>
      </nav>
    `.trim();
  }

  function renderMatchCard(matchKey, picks){
    // picks = [{...candidate}]
    const c0 = picks[0];
    const lifecycle = fixtureStatus.classify(c0);
    const lifecycleLabel = fixtureStatus.labelFor(lifecycle.state, lang);
    const league = c0.league;
    const leagueName = formatLeagueName(league);
    const leagueHref = getLeaguePredictionHref(league);
    const home = c0.home;
    const away = c0.away;
    const homeLabel = escapeHtml(localizeTeamLabel(home, league));
    const awayLabel = escapeHtml(localizeTeamLabel(away, league));
    const homeTeamHtml = renderLinkedTeamName(home, league);
    const awayTeamHtml = renderLinkedTeamName(away, league);
    const matchLinkOptions = {
            locale: lang,
            surface: "top-predictions",
            extraClass: "fs-match-analysis-link--block",
            league,
            leagueSlug: LEAGUE_RESULTS_SLUG[league] || "",
            fixtureId: c0.fixture_id || "",
            date: localDayKeyFromUTC(c0),
            home,
            away,
            matchUrl: c0.match_url,
            matchPageState: c0.match_page_state,
          };
    const directMatchHref = normalizeCanonicalMatchHref(c0.match_url);
    const canonicalShareUrl = (() => {
      if (!directMatchHref) return "";
      try { return new URL(directMatchHref, window.location.origin).href; }
      catch (_) { return ""; }
    })();
    picks.forEach((pick) => { pick._canonicalShareUrl = canonicalShareUrl; });

    const matchHref = directMatchHref;
    const homeHref = typeof window.fsTeamLinks?.getTeamLinkByName === "function"
      ? (window.fsTeamLinks.getTeamLinkByName(home, league) || "")
      : "";
    const awayHref = typeof window.fsTeamLinks?.getTeamLinkByName === "function"
      ? (window.fsTeamLinks.getTeamLinkByName(away, league) || "")
      : "";
    const footerLinksHtml = renderMatchFooterLinks({
      matchHref,
      homeHref,
      awayHref,
      leagueHref,
      home,
      away,
      league,
      leagueName
    });

    const kickoff = fmtKickoffLocal(c0);
    const eloHome = Number(c0.elo_home);
    const eloAway = Number(c0.elo_away);
    const eloHomeTxt = Number.isFinite(eloHome) ? eloHome.toFixed(0) : t.details_na;
    const eloAwayTxt = Number.isFinite(eloAway) ? eloAway.toFixed(0) : t.details_na;
    const eloDiff =
      Number.isFinite(eloHome) && Number.isFinite(eloAway) ? eloHome - eloAway : null;

    const formatRank = (value) => {
      const n = Number(value);
      if (Number.isFinite(n) && n > 0) return String(Math.round(n));
      const raw = String(value ?? "").trim();
      return raw || t.rank_empty;
    };
    const rankHomeTxt = formatRank(c0.rank_home);
    const rankAwayTxt = formatRank(c0.rank_away);

    const compactReading = buildCompactMatchReading(c0);
    const x12Badge = getPrimary1X2BadgeFromPicks(picks);
    const hideStabilityBadge = isCustomProfileSelection();
    const forceValue = compactReading?.forceValue || t.details_na;
    const forceTone = compactReading?.forceTone || "neutral";

    const stabilityValue = hideStabilityBadge
      ? null
      : (x12Badge?.value || compactReading?.stabilityValue || t.details_na);

    const stabilityTone = hideStabilityBadge
      ? null
      : (x12Badge?.tone || compactReading?.stabilityTone || "neutral");
    const confidencePct = resolveConfidencePercent(c0);
    const confidenceObservedPct = displayedPickConfidenceForCandidate(c0);
    const confidenceHistPct = toPercentValue(c0.confidence_hist_raw);
    const confidenceMlPct = toPercentValue(c0.confidence_ml_raw);
    const confidenceFinalPct = toPercentValue(c0.confidence_final_raw);
    const confidenceHistSample = Number(c0.confidence_hist_matches);
    const probaMetrics = computeMatchProbabilityMetrics(c0);
    const homeFormContext = formatTeamFormDetails(c0, "home");
    const awayFormContext = formatTeamFormDetails(c0, "away");
    const homeGoalContext = formatTeamGoalDetails(c0, "home");
    const awayGoalContext = formatTeamGoalDetails(c0, "away");
    const contextLeader = detectContextLeader(c0, probaMetrics, eloDiff);
    const probaRibbonHtml = buildProbaRibbonHtml(probaMetrics);
    const histVolumeItems = picks
      .map((candidate) => {
        const n = Number(candidate._hist_n);
        const label = (candidate.label || candidate.type || "").trim();
        return {
          label: label || t.details_hist_volume,
          n: Number.isFinite(n) ? Math.round(n) : null
        };
      });
    const maxHistVolume = histVolumeItems.reduce((m, item) => {
      return Number.isFinite(item.n) ? Math.max(m, item.n) : m;
    }, 0);
    const histVolumeHtml = histVolumeItems.length
      ? histVolumeItems.map((item) => {
          const pct = Number.isFinite(item.n) && maxHistVolume > 0 ? (item.n / maxHistVolume) * 100 : null;
          const nTxt = Number.isFinite(item.n) ? String(item.n) : t.details_na;
          return renderReadingStat(item.label, nTxt, {
            percent: pct,
            classes: "tp-reading-stat--volume"
          });
        }).join("")
      : renderReadingStat(t.details_hist_volume, t.details_na, { classes: "tp-reading-stat--volume" });
    const marketDetailsHtml = picks.map((candidate) => {
      const family = compactPickFamily(candidate);
      const outcomeKey = outcomeForCandidate(candidate) || "pending";
      const probability = Number(candidate?.prob || 0);
      return `
        <div class="tp-market-detail-row tp-market-detail-row--${outcomeKey}">
          <span class="tp-market-detail-row__type">${family.label}</span>
          <strong class="tp-market-detail-row__label">${candidate?.label || family.shortLabel}</strong>
          <span class="tp-market-detail-row__prob">${probability.toFixed(0)}%</span>
          <span class="tp-market-detail-row__status">${compactOutcomeLabel(outcomeKey)}</span>
        </div>
      `.trim();
    }).join("");
    const topGoalsLabel = lang === "es" ? "Top 5 marcadores" : lang === "en" ? "Top 5 goals" : "Top 5 buts";
    const topGoalsValue = (() => {
      const fromFirst = String(c0.top_scores || "").trim();
      if (fromFirst) return fromFirst;
      const fromAny = picks
        .map((candidate) => String(candidate.top_scores || "").trim())
        .find((txt) => !!txt);
      return fromAny || "";
    })();
    const goalsScoreCardsHtml = topGoalsValue
      ? renderTopGoalsCard(topGoalsLabel, topGoalsValue)
      : "";
    const contextWatchHtml = (window.FSContextWatch && typeof window.FSContextWatch.renderContextWatch === "function")
      ? window.FSContextWatch.renderContextWatch(c0, { lang, extraClass: "fs-context-watch--dense tpv6-context-block" })
      : "";
    const eloTotal = Number.isFinite(eloHome) && Number.isFinite(eloAway) ? (eloHome + eloAway) : null;
    const eloHomePct = Number.isFinite(eloTotal) && eloTotal > 0 ? (eloHome / eloTotal) * 100 : null;
    const eloAwayPct = Number.isFinite(eloTotal) && eloTotal > 0 ? (eloAway / eloTotal) * 100 : null;
    const eloDiffStrengthPct = Number.isFinite(eloDiff)
      ? Math.min(100, (Math.abs(eloDiff) / 300) * 100)
      : null;

    const compactBodyId = nextDetailsId();
    const quickPanelId = nextDetailsId();
    const scorePanelId = nextDetailsId();
    const detailId = nextDetailsId();
    const detailsOpen = expertModeEnabled;
    const compactExpanded = !compactModeEnabled;

    const el = document.createElement("div");
    el.className = `tp-match-card${lifecycle.disabled ? " fs-fixture-disabled" : ""}${detailsOpen ? " is-full-analysis" : ""}`;
    el.dataset.tpv6Depth = detailsOpen ? "full" : "quick";
    const liveFixtureId = String(c0.fixture_id || "");
    if (/^[1-9][0-9]{0,11}$/.test(liveFixtureId) && c0.kickoff_iso) {
      el.dataset.liveFixtureId = liveFixtureId;
      el.dataset.liveKickoff = String(c0.kickoff_iso);
      const canonicalStatus = String(c0.status || "").toLowerCase();
      if (["played", "termine", "terminé", "finished", "ft", "aet", "pen"].includes(canonicalStatus)) {
        el.dataset.liveCanonicalFinal = "1";
      }
    }
    el.__tpMatchKey = matchKey;
    el.__tpPicks = picks;
    el.__tpMatchLinkOptions = matchLinkOptions;

    el.innerHTML = `
      ${renderCompactSummary(
        kickoff,
        home,
        away,
        picks,
        compactBodyId,
        compactExpanded,
        canonicalShareUrl,
        leagueName,
        renderLeagueCountryFlag(league, "tp-match-summary__flag")
      )}
      <div class="fs-live-score-slot" data-live-score-slot hidden></div>
      ${lifecycle.disabled ? `<div class="fs-fixture-status-banner" role="status">${escapeHtml(lifecycleLabel)}</div>` : ""}

      <div
        id="${compactBodyId}"
        class="tp-match-card__body"
        data-tp-card-body
        ${compactExpanded ? "" : "hidden"}>
      <div class="tp-match-meta">
        <div class="tp-kickoff" title="${c0.kickoff_iso || ""}">${kickoff}</div>
        <a class="tp-league-badge" href="${leagueHref}" style="text-decoration:none;color:inherit" aria-label="${lang === "es" ? `Ver predicciones de ${leagueName}` : lang === "en" ? `View ${leagueName} predictions` : `Voir les pronostics ${leagueName}`}">
          <span>${leagueName}</span>
          ${renderLeagueCountryFlag(league)}
          ${renderExperimentalBadge(league)}
        </a>
        <span class="tp-open-pick-count">${t.compact_pick_count(picks.length)}</span>
      </div>

      <div class="tp-team-confrontation">
        <div class="tp-team tp-team--home">
          <div class="tp-team-side tp-team-side--home">${t.home_side}</div>
          <div class="tp-team-logo"><img class="tp-team-logo-img" alt="${homeLabel}"/></div>
          ${homeTeamHtml}
          <div class="tp-elo-row">
            <span class="tp-elo-pill tp-elo-pill--home">${t.elo_home} ${eloHomeTxt}</span>
          </div>
          <div class="tp-team-rank">${t.rank_home} ${rankHomeTxt}</div>
        </div>

        <div class="tp-vs">VS</div>

        <div class="tp-team tp-team--away">
          <div class="tp-team-side tp-team-side--away">${t.away_side}</div>
          <div class="tp-team-logo"><img class="tp-team-logo-img" alt="${awayLabel}"/></div>
          ${awayTeamHtml}
          <div class="tp-elo-row">
            <span class="tp-elo-pill tp-elo-pill--away">${t.elo_away} ${eloAwayTxt}</span>
          </div>
          <div class="tp-team-rank">${t.rank_away} ${rankAwayTxt}</div>
        </div>
      </div>

      <div class="tp-picks">
        ${picks.map(renderPickRow).join("")}
      </div>

      ${contextWatchHtml}

      <div class="tp-reading-compact tpv4-reading-shell">
        <div class="tpv4-depth-switch ${detailsOpen ? "is-full" : ""}" data-tpv4-depth-switch role="group" aria-label="Niveau de détail">
          <span class="tpv4-depth-switch__thumb" aria-hidden="true"></span>
          <button
            type="button"
            class="tpv4-depth-switch__option tpv4-depth-switch__option--quick ${detailsOpen ? "" : "is-active"}"
            data-tpv2-quick-reset
            aria-pressed="${detailsOpen ? "false" : "true"}"
            aria-controls="${quickPanelId}">
            ${lang === "es" ? "Lectura rápida" : lang === "en" ? "Quick read" : "Lecture rapide"}
          </button>
          <button
            type="button"
            class="tpv4-depth-switch__option tpv4-depth-switch__option--score"
            data-tpv6-score
            aria-pressed="false"
            aria-controls="${scorePanelId}">
            ${lang === "es" ? "Marcador exacto" : lang === "en" ? "Exact score" : "Score exact"}
          </button>
          <button
            type="button"
            class="tp-reading-toggle tpv4-depth-switch__option tpv4-depth-switch__option--full ${detailsOpen ? "is-active" : ""}"
            data-tp-details-toggle
            aria-expanded="${detailsOpen ? "true" : "false"}"
            aria-pressed="${detailsOpen ? "true" : "false"}"
            aria-controls="${detailId}"
            aria-label="${detailsOpen ? t.details_hide : t.details_show}">
            ${lang === "es" ? "Análisis detallado" : lang === "en" ? "Detailed analysis" : "Analyse détaillée"}
          </button>
        </div>

        <div id="${quickPanelId}" class="tpv4-quick-panel" data-tpv6-quick-panel ${detailsOpen ? "hidden" : ""}>
          <div class="tpv4-quick-head">
            <span class="tpv4-reading-kicker">${lang === "es" ? "Lectura rápida" : lang === "en" ? "Quick read" : "Lecture rapide"}</span>
            <div class="tpv4-quick-badges">
              <span class="tpv4-quick-badge tpv4-quick-badge--force">${forceValue}</span>
              ${hideStabilityBadge ? "" : `<span class="tpv4-quick-badge tpv4-quick-badge--stability">${stabilityValue}</span>`}
            </div>
          </div>
          <div class="tpv4-quick-metrics">
            <span class="tpv4-quick-metric tpv4-quick-metric--team">
              <span class="tpv4-quick-metric__k">ELO ${homeLabel}</span>
              <strong class="tpv4-quick-metric__v">${eloHomeTxt}</strong>
            </span>
            <span class="tpv4-quick-metric tpv4-quick-metric--team">
              <span class="tpv4-quick-metric__k">ELO ${awayLabel}</span>
              <strong class="tpv4-quick-metric__v">${eloAwayTxt}</strong>
            </span>
            <span class="tpv4-quick-metric tpv4-quick-metric--elo-diff">
              <span class="tpv4-quick-metric__k">${t.details_elo_diff}</span>
              <strong class="tpv4-quick-metric__v">${Number.isFinite(eloDiff) ? (eloDiff > 0 ? "+" : "") + fmtNumber(eloDiff, 0) : t.details_na}</strong>
            </span>
            <span class="tpv4-quick-metric tpv4-quick-metric--draw">
              <span class="tpv4-quick-metric__k">${t.details_pdraw}</span>
              <strong class="tpv4-quick-metric__v">${fmtPercent(probaMetrics?.draw)}</strong>
            </span>
            <span class="tpv4-quick-metric tpv4-quick-metric--principal">
              <span class="tpv4-quick-metric__k">${lang === "es" ? "Principal" : lang === "en" ? "Main" : "Principal"}</span>
              <strong class="tpv4-quick-metric__v">${compactPickLabel(c0)} · ${Number(c0.prob || 0).toFixed(0)}%</strong>
            </span>
            <span class="tpv4-quick-metric tpv4-quick-metric--confidence">
              <span class="tpv4-quick-metric__k">${t.confidence_label}</span>
              <strong class="tpv4-quick-metric__v">${fmtPercent(confidenceObservedPct)}</strong>
            </span>
          </div>
          <div class="tpv5-quick-form" aria-label="${t.details_last_results}">
            <div class="tpv5-quick-form__row" data-tp-team-form-quick="home">
              <span class="tpv5-quick-form__team">${homeLabel}</span>
              ${renderRecentResultsChips(c0.last_results_home, { compact: true })}
            </div>
            <div class="tpv5-quick-form__row" data-tp-team-form-quick="away">
              <span class="tpv5-quick-form__team">${awayLabel}</span>
              ${renderRecentResultsChips(c0.last_results_away, { compact: true })}
            </div>
          </div>
        </div>
      </div>

      <div
        id="${scorePanelId}"
        class="tpv6-score-panel"
        data-tpv6-score-panel
        hidden>
        <div class="tpv6-score-panel__head">
          <span>${lang === "es" ? "Marcador exacto" : lang === "en" ? "Exact score" : "Score exact"}</span>
          <strong>${lang === "es" ? "Top 5 marcadores más probables" : lang === "en" ? "Top 5 most likely scores" : "Top 5 scores les plus probables"}</strong>
          <a
            class="tpv6-score-panel__history-link"
            href="${lang === "es" ? "/es/marcador-exacto-futbol-ia.html" : lang === "en" ? "/en/exact-score-football-ai.html" : "/score-exact-foot-ia.html"}">
            ${lang === "es" ? "Consultar el historial" : lang === "en" ? "View history" : "Consulter l’historique"}&nbsp;→
          </a>
        </div>
        ${topGoalsValue
          ? renderV4TopScores(topGoalsValue)
          : `<div class="tpv6-score-panel__empty">${t.details_na}</div>`}
      </div>

      <div
        id="${detailId}"
        class="tpv4-full-analysis"
        data-tp-details-panel
        ${detailsOpen ? "" : "hidden"}>
        <div class="tpv4-analysis-grid">
          <section class="tpv4-analysis-section tpv4-analysis-section--proba">
            <div class="tpv4-section-title"><span>01</span><h3>${t.details_block_proba}</h3></div>
            <div class="tpv4-proba-values">
              <div><span>1</span><strong>${fmtPercent(probaMetrics?.home)}</strong></div>
              <div><span>X</span><strong>${fmtPercent(probaMetrics?.draw)}</strong></div>
              <div><span>2</span><strong>${fmtPercent(probaMetrics?.away)}</strong></div>
            </div>
            <div class="tpv4-proba-bar" aria-hidden="true">
              <i class="is-home" style="width:${Number(probaMetrics?.home || 0).toFixed(2)}%"></i>
              <i class="is-draw" style="width:${Number(probaMetrics?.draw || 0).toFixed(2)}%"></i>
              <i class="is-away" style="width:${Number(probaMetrics?.away || 0).toFixed(2)}%"></i>
            </div>
            <div class="tpv4-proba-foot"><span>${t.details_margin}</span><strong>${fmtPercent(probaMetrics?.margin)}</strong></div>
          </section>

          <section class="tpv4-analysis-section tpv4-analysis-section--strength">
            <div class="tpv4-section-title"><span>02</span><h3>${lang === "es" ? "Relación de fuerzas" : lang === "en" ? "Strength comparison" : "Rapport de force"}</h3></div>
            <div class="tpv4-strength-teams">
              <div><span>${homeLabel}</span><strong>${eloHomeTxt}</strong><small>${t.rank_home} ${rankHomeTxt}</small></div>
              <b>${Number.isFinite(eloDiff) ? (eloDiff > 0 ? "+" : "") + fmtNumber(eloDiff, 0) : t.details_na}</b>
              <div><span>${awayLabel}</span><strong>${eloAwayTxt}</strong><small>${t.rank_away} ${rankAwayTxt}</small></div>
            </div>
            <div class="tpv4-strength-bar"><i style="width:${Number.isFinite(eloHomePct) ? eloHomePct.toFixed(1) : 50}%"></i></div>
          </section>

          <section class="tpv4-analysis-section tpv4-analysis-section--form">
            <div class="tpv4-section-title"><span>03</span><h3>${t.details_form_block}</h3></div>
            <div class="tpv4-duel-block">
              <div data-tp-team-form-details="home"><strong>${homeLabel}</strong>${renderV4MetricRows(homeFormContext)}</div>
              <div data-tp-team-form-details="away"><strong>${awayLabel}</strong>${renderV4MetricRows(awayFormContext)}</div>
            </div>
          </section>

          <section class="tpv4-analysis-section tpv4-analysis-section--goals">
            <div class="tpv4-section-title"><span>04</span><h3>${t.details_goals_block}</h3></div>
            <div class="tpv4-duel-block">
              <div data-tp-team-goals-details="home"><strong>${homeLabel}</strong>${renderV4MetricRows(homeGoalContext)}</div>
              <div data-tp-team-goals-details="away"><strong>${awayLabel}</strong>${renderV4MetricRows(awayGoalContext)}</div>
            </div>
          </section>

          <section class="tpv4-analysis-section tpv4-analysis-section--volumes">
            <div class="tpv4-section-title"><span>05</span><h3>${t.details_block_volumes}</h3></div>
            <div class="tpv4-volume-list">${renderV4VolumeRows(histVolumeItems)}</div>
          </section>

          <section class="tpv4-analysis-section tpv4-analysis-section--context">
            <div class="tpv4-section-title"><span>06</span><h3>${t.details_block_context}</h3></div>
            <div class="tpv4-context-grid">
              <div><span>${t.details_league}</span><strong>${formatLeagueName(league)}</strong></div>
              <div><span>${t.details_kickoff}</span><strong>${kickoff}</strong></div>
              <div><span>${t.details_elo_diff}</span><strong>${Number.isFinite(eloDiff) ? (eloDiff > 0 ? "+" : "") + fmtNumber(eloDiff, 0) : t.details_na}</strong></div>
              <div><span>${t.confidence_label}</span><strong>${fmtPercent(confidenceObservedPct)}</strong></div>
            </div>
          </section>
        </div>
      </div>

      <div data-tp-footer-links>${footerLinksHtml}</div>
      </div>
    `;
    // Keep action generation independent from fixture-status rendering. A
    // cancelled card loses the interactive menu but retains its exact grid
    // footprint, preventing the pick rows from shifting sideways.
    if (lifecycle.disabled) {
      const preserveCancelledActionSpace = lifecycle.state === fixtureStatus.STATES.CANCELLED;
      el.querySelectorAll("[data-tp-pick-overflow]").forEach((menu) => {
        if (!preserveCancelledActionSpace) {
          menu.remove();
          return;
        }
        const placeholder = document.createElement("span");
        placeholder.className = "tp-pick-overflow tp-pick-overflow--placeholder";
        placeholder.setAttribute("aria-hidden", "true");
        menu.replaceWith(placeholder);
      });
    }
    const imgs = el.querySelectorAll("img.tp-team-logo-img");
    setLogoWithFallback(imgs[0], home, league);
    setLogoWithFallback(imgs[1], away, league);
    const compactImgs = el.querySelectorAll("img.tp-compact-team-logo");
    setLogoWithFallback(compactImgs[0], home, league);
    setLogoWithFallback(compactImgs[1], away, league);

    return el;
  }

  const TEAM_FORM_CARD_FIELDS = [
    "form_index_home", "form_index_away",
    "current_win_streak_home", "current_win_streak_away",
    "current_unbeaten_streak_home", "current_unbeaten_streak_away",
    "current_loss_streak_home", "current_loss_streak_away",
    "last_results_home", "last_results_away",
    "recent_points_per_match_home", "recent_points_per_match_away",
    "recent_matches_home", "recent_matches_away",
    "matches_played_home", "matches_played_away",
    "goals_for_home", "goals_for_away",
    "goals_against_home", "goals_against_away",
    "avg_goals_for_home", "avg_goals_for_away",
    "avg_goals_against_home", "avg_goals_against_away"
  ];

  function updateRenderedCardTeamForm(card, sourceMatch) {
    const picks = card?.__tpPicks;
    if (!Array.isArray(picks) || !picks.length || !sourceMatch) return;
    picks.forEach((pick) => {
      TEAM_FORM_CARD_FIELDS.forEach((field) => { pick[field] = sourceMatch[field]; });
    });
    const c0 = picks[0];
    const names = { home: c0.home, away: c0.away };
    ["home", "away"].forEach((side) => {
      const safeName = escapeHtml(names[side]);
      const quick = card.querySelector(`[data-tp-team-form-quick="${side}"]`);
      if (quick) {
        quick.innerHTML = `<span class="tpv5-quick-form__team">${safeName}</span>${renderRecentResultsChips(c0[`last_results_${side}`], { compact: true })}`;
      }
      const form = card.querySelector(`[data-tp-team-form-details="${side}"]`);
      if (form) form.innerHTML = `<strong>${safeName}</strong>${renderV4MetricRows(formatTeamFormDetails(c0, side))}`;
      const goals = card.querySelector(`[data-tp-team-goals-details="${side}"]`);
      if (goals) goals.innerHTML = `<strong>${safeName}</strong>${renderV4MetricRows(formatTeamGoalDetails(c0, side))}`;
    });
  }

  function refreshRenderedTeamForms(matches) {
    const byKey = new Map((Array.isArray(matches) ? matches : []).map((match) => [
      `${match.league}|${match.utc}|${match.home}|${match.away}`,
      match
    ]));
    elGrid?.querySelectorAll(".tp-match-card").forEach((card) => {
      updateRenderedCardTeamForm(card, byKey.get(card.__tpMatchKey));
    });
  }

  function refreshRenderedTeamLinks() {
    elGrid?.querySelectorAll("[data-tp-team-link]").forEach((node) => {
      const team = node.getAttribute("data-team-name") || "";
      const league = node.getAttribute("data-league") || "";
      const holder = document.createElement("template");
      holder.innerHTML = renderLinkedTeamName(team, league);
      const replacement = holder.content.firstElementChild;
      if (replacement) node.replaceWith(replacement);
    });
    elGrid?.querySelectorAll(".tp-match-card").forEach((card) => refreshCardFooterLinks(card));
  }

  function refreshCardFooterLinks(card, matchHrefOverride = null) {
    const c0 = card?.__tpPicks?.[0];
    const target = card?.querySelector?.("[data-tp-footer-links]");
    if (!c0 || !target) return;
    const league = c0.league;
    const matchHrefCandidate = matchHrefOverride == null
      ? (card.__tpResolvedMatchHref || c0.match_url || "")
      : matchHrefOverride;
    const matchHref = normalizeCanonicalMatchHref(matchHrefCandidate);
    target.innerHTML = renderMatchFooterLinks({
      matchHref,
      homeHref: window.fsTeamLinks?.getTeamLinkByName?.(c0.home, league) || "",
      awayHref: window.fsTeamLinks?.getTeamLinkByName?.(c0.away, league) || "",
      leagueHref: getLeaguePredictionHref(league),
      home: c0.home,
      away: c0.away,
      leagueName: formatLeagueName(league)
    });
  }

  async function resolveDeferredMatchLink(card) {
    if (!card || typeof window.fsMatchPageLinks?.resolveMatch !== "function") return;
    try {
      const record = await window.fsMatchPageLinks.resolveMatch(card.__tpMatchLinkOptions || {});
      if (!record?.url) return;
      card.__tpResolvedMatchHref = record.url;
      const shareUrl = new URL(record.url, window.location.origin).href;
      card.__tpPicks?.forEach((pick) => { pick._canonicalShareUrl = shareUrl; });
      card.querySelectorAll("[data-tp-pick-share]").forEach((button) => {
        button.setAttribute("data-share-url", shareUrl);
        button.disabled = false;
      });
      refreshCardFooterLinks(card, record.url);
    } catch (error) {
      if (topPerfDebugEnabled) console.debug("[top-pronostics] optional match link unavailable", error);
    }
  }

  function queueDeferredMatchLink(card) {
    if (!card) return;
    pendingMatchLinkCards.add(card);
    if (!deferredEnrichmentsStarted) return;
    pendingMatchLinkCards.delete(card);
    Promise.resolve().then(() => resolveDeferredMatchLink(card));
  }

  function startDeferredCardEnrichments() {
    if (deferredEnrichmentsStarted) return;
    deferredEnrichmentsStarted = true;

    ensureTeamLinksLoaded()
      .then(() => refreshRenderedTeamLinks())
      .catch(() => null)
      .finally(() => markTopPerf("team_links_ready"));

    if (deferredTeamFormMatches && !deferredTeamFormPromise) {
      const matches = deferredTeamFormMatches;
      deferredTeamFormPromise = hydrateMatchesWithTeamForm(matches)
        .then(() => refreshRenderedTeamForms(matches))
        .catch((error) => console.warn("team form deferred enrichment failed", error))
        .finally(() => markTopPerf("team_form_ready"));
    } else if (!deferredTeamFormMatches) {
      markTopPerf("team_form_ready");
    }

    Array.from(pendingMatchLinkCards).forEach((card) => {
      pendingMatchLinkCards.delete(card);
      Promise.resolve().then(() => resolveDeferredMatchLink(card));
    });
  }


  function updatePerfBanner(wins, total, voids, rate){
    const el = document.getElementById("bb-perf");
    if (!el) return;

    const renderPerfMain = (value) => {
      if (typeof value !== "number" || !Number.isFinite(value)){
        return `<span class="bb-perf-main bb-perf-main--pending">${t.perf_wait}</span>`;
      }

      const fixed = value.toFixed(1);
      const [whole, decimal = "0"] = fixed.split(".");
      return `
        <span class="bb-perf-main" aria-label="${fixed}%">
          <span class="bb-perf-main__value">${whole}</span>
          <span class="bb-perf-main__decimal">.${decimal}</span>
          <span class="bb-perf-main__suffix">%</span>
        </span>
      `;
    };

    const renderPerfMeter = (value) => {
      if (typeof value !== "number" || !Number.isFinite(value)) return "";
      const clamped = Math.max(0, Math.min(100, value));
      return `
        <div class="bb-perf-meter" aria-hidden="true">
          <span class="bb-perf-meter__fill" style="width:${clamped.toFixed(1)}%"></span>
        </div>
      `;
    };

    if (!total && !voids){
      el.innerHTML = `
        <div class="bb-perf-head">
          <span class="bb-perf-head__eyebrow">${t.perf_kpi_title}</span>
          <span class="bb-perf-head__sub">${t.perf_kpi_subtitle}</span>
        </div>
        <div class="bb-perf-grid">
          <article class="bb-perf-card bb-perf-card--hero bb-perf-card--pending">
            <span class="bb-perf-card__label">${t.perf_label_wait}</span>
            ${renderPerfMain(null)}
            <span class="bb-perf-card__meta">${t.perf_kpi_wait_hint}</span>
          </article>
        </div>
      `;
      return;
    }

    const toneClass =
      rate == null
        ? "bb-perf-card--pending"
        : rate >= 70
          ? "bb-perf-card--hot"
          : rate >= 55
            ? "bb-perf-card--warm"
            : "bb-perf-card--cool";

    el.innerHTML = `
      <div class="bb-perf-head">
        <span class="bb-perf-head__eyebrow">${t.perf_kpi_title}</span>
        <span class="bb-perf-head__sub">${t.perf_kpi_subtitle}</span>
      </div>
      <div class="bb-perf-grid">
        <article class="bb-perf-card bb-perf-card--hero ${toneClass}">
          <span class="bb-perf-card__label">${t.perf_kpi_rate}</span>
          ${renderPerfMain(rate)}
          ${renderPerfMeter(rate)}
          <span class="bb-perf-card__meta">${t.perf_kpi_rate_meta(total)}</span>
        </article>
        <article class="bb-perf-card">
          <span class="bb-perf-card__label">${t.perf_kpi_record}</span>
          <span class="bb-perf-card__value">${wins}/${total}</span>
          <span class="bb-perf-card__meta">${t.perf_kpi_record_meta(wins, total)}</span>
        </article>
      </div>
      ${voids ? `<div class="bb-perf-foot">${t.perf_kpi_voids_inline(voids)}</div>` : ""}
    `;
  }

  function renderDatePills(preferredDate){
    elDates.innerHTML = "";
    const dates = Array.from(dateCounts.keys()).sort();
    const effectiveSelected = resolveSelectableDate(dates, preferredDate);

    if (!effectiveSelected){
      selectedDate = null;
      return;
    }

    const renderDates = dates.slice();

    renderDates.forEach((d) => {
      const parts = getDatePartsForRail(d);
      const btn = document.createElement("button");
      btn.type = 'button';
      btn.className = "date-button";
      btn.setAttribute('aria-pressed', d === effectiveSelected ? 'true' : 'false');
      btn.setAttribute('aria-label', `${parts.weekday} ${parts.day} — ${dateCounts.get(d) || 0} ${t.date_match_count}`);
      if (d === effectiveSelected) btn.classList.add("selected");
      if (parts.isToday) btn.classList.add('is-today');
      btn.dataset.date = d;
      const count = dateCounts.get(d) || 0;
      btn.innerHTML = `
        <span class="tp-date-item__marker">${parts.isToday ? t.date_today : '&nbsp;'}</span>
        <span class="tp-date-item__weekday">${parts.weekday}</span>
        <span class="tp-date-item__day">${parts.day}</span>
        <span class="tp-date-item__count" data-count="${count}">
          <span class="tp-date-item__count-pill">${count} ${t.date_match_count}</span>
        </span>
      `;
      btn.addEventListener("click", async () => {
        elDates.querySelectorAll(".date-button").forEach((b) => {
          b.classList.remove("selected");
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add("selected");
        btn.setAttribute('aria-pressed', 'true');
        selectedDate = d;
        requestAnimationFrame(() => centerSelectedDateInScroller("smooth"));
        if (Object.prototype.hasOwnProperty.call(modeSelectedDateMemory, activeDisplayMode)) {
          modeSelectedDateMemory[activeDisplayMode] = d;
        }

        // Thresholds/mode are fixed for the current day. Changing date only
        // re-filters the already loaded window: no mode reset and no API call.
        await filterAndRender({ reason: "date" });
      });
      elDates.appendChild(btn);
    });

    selectedDate = effectiveSelected;
    if (Object.prototype.hasOwnProperty.call(modeSelectedDateMemory, activeDisplayMode)) {
      modeSelectedDateMemory[activeDisplayMode] = effectiveSelected;
    }
    syncDateRailNavState();
    requestAnimationFrame(() => requestAnimationFrame(() => centerSelectedDateInScroller("auto")));

  }

  // Window config
  const WINDOW_PAST_DAYS = 8;
  const WINDOW_FUTURE_DAYS = 8;

  let dateCenterRaf = null;
  window.addEventListener("resize", () => {
    if (dateCenterRaf) cancelAnimationFrame(dateCenterRaf);
    dateCenterRaf = requestAnimationFrame(() => centerSelectedDateInScroller("auto"));
  });

  function isPastCandidateForDisplay(c, nowTs = Date.now()){
    if (!c) return false;

    // Match avec score final => passé.
    if (isSettledCandidate(c)) return true;

    // Tolérance de 2h après le coup d'envoi: si pas de score final, on garde en "à venir".
    const kickoffTs = parseUtcTime(c);
    if (!Number.isFinite(kickoffTs) || kickoffTs <= 0) return false;
    const elapsed = nowTs - kickoffTs;
    if (elapsed <= PAST_MATCH_GRACE_MS) return false;

    // Même au-delà de 2h, sans score final on le laisse visible comme "à venir".
    return false;
  }

  async function ensureWindowDataLoaded(){
    if (windowMatchesFullRaw && windowMatchesFullRaw.length) {
      return windowMatchesFullRaw;
    }
    if (windowDataLoadPromise) return windowDataLoadPromise;

    const revision = sourceRevision;
    windowDataLoadPromise = (async () => {
      const today = todayISO();
      const startISO = addDays(today, -WINDOW_PAST_DAYS);
      const days = WINDOW_PAST_DAYS + WINDOW_FUTURE_DAYS + 1;
      let allMatches = [];

      try {
        allMatches = await fetchLeagueFeedBulkWindow(LEAGUES, startISO, days);
      } catch (bulkError) {
        console.warn("league_markets_bulk failed, falling back to per-league fetch", bulkError);
        allMatches = await fetchLeagueFeedWindowFallback(LEAGUES, startISO, days);
      }

      if (revision !== sourceRevision) return windowMatchesFullRaw;
      windowMatchesFullRaw = allMatches.filter((m) => m.kickoff_iso);
      windowMatchesFull = [...windowMatchesFullRaw];
      syncCurrentWindowMatchesFromSelection();
      deferredTeamFormMatches = windowMatchesFullRaw;
      markTopPerf("market_data_ready", { matches: windowMatchesFullRaw.length });
      return windowMatchesFullRaw;
    })();

    try {
      return await windowDataLoadPromise;
    } finally {
      windowDataLoadPromise = null;
    }
  }

  async function reloadWindow(options = {}){
    const generation = beginListingUpdate(options.reason || "api");
    const previousSelectedDate = selectedDate;

    try {
      await ensureWindowDataLoaded();
      if (!isListingGenerationCurrent(generation)) return windowMatchesFullRaw;

      syncCurrentWindowMatchesFromSelection();
      renderDatePills(previousSelectedDate);

      if (options.render !== false) {
        await filterAndRender({
          generation,
          reason: options.reason || "api"
        });
      }
      return windowMatchesFullRaw;
    } catch(e){
      console.error(e);
      if (isListingGenerationCurrent(generation) && elGrid) {
        const errorCard = document.createElement("div");
        errorCard.className = "bestbet-card";
        errorCard.textContent = t.error_loading;
        elGrid.replaceChildren(errorCard);
      }
      return [];
    } finally {
      endListingUpdate(generation);
    }
  }

  // Perf candidates helpers (repris, inchangés dans l’esprit)

  // --- Canonical logos (same method as results_by_date) ------------------------
  function canon(s) {
    return String(s || "")
      .toLowerCase()
      .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]/g, "");
  }

  const withTeamLogoVersion = window.withTeamLogoVersion || (path => path);
  const TEAM_PLACEHOLDER_LOGO = withTeamLogoVersion("/logos/placeholder_team.webp");

  function getTeamLogoUrl(team){
    return withTeamLogoVersion(`/logos/teams/${canon(team)}.webp`);
  }
  function getLeagueLogoUrl(league){
    const leagueCode = String(league || "").toUpperCase();
    return `/logos/${leagueCode}/${canon(leagueCode)}.webp`;
  }

  // Applique un src + fallback (sans imageExists / ping)
  function setLogoWithFallback(imgEl, team, league){
    if (!imgEl) return;

    const primary = getTeamLogoUrl(team);
    const fallbackLeague = getLeagueLogoUrl(league);

    imgEl.decoding = "async";
    imgEl.loading = "lazy";
    imgEl.dataset.logoPrimary = primary;
    imgEl.dataset.logoFallback = fallbackLeague;

    imgEl.src = primary;
    imgEl.onerror = () => {
      const cur = imgEl.getAttribute("src") || "";
      if (cur === imgEl.dataset.logoPrimary) {
        imgEl.src = imgEl.dataset.logoFallback;
        return;
      }
      imgEl.onerror = null;
      imgEl.src = TEAM_PLACEHOLDER_LOGO;
    };
  }

  function fmtKickoffLocal(match){
    try{
      const d = parseFrenchDateTime(match);
      if (d){
        const ddmm = `${pad2(d.getDate())}/${pad2(d.getMonth() + 1)}`;
        const hhmm = `${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
        return `${ddmm} ${hhmm}`;
      }
      return "";
    } catch(e){
      return "";
    }
  }

  function fmtCompactKickoffLocal(match){
    try{
      const d = parseFrenchDateTime(match);
      const timeHHMM = d ? `${pad2(d.getHours())}:${pad2(d.getMinutes())}` : "";
      const ddmm = d
        ? `${pad2(d.getDate())}/${pad2(d.getMonth() + 1)}`
        : "";
      const localDay = localDayKeyFromUTC(match);
      if (selectedDate && localDay && localDay === selectedDate) {
        return timeHHMM || "";
      }
      if (ddmm && timeHHMM) return `${ddmm} ${timeHHMM}`;
      if (timeHHMM) return timeHHMM;
      if (ddmm) return ddmm;
      return "";
    } catch(e){
      return "";
    }
  }

  function buildCandidatesForPerf(m, options = {}){
    if (!fixtureStatus.countsAsAvailable(m)) return [];
    const out = [];
    const leagueSelected = isMatchInLeagueSelection(m, options.selectedLeagueSet);
    const ph = pct(m.p_home), pd = pct(m.p_draw), pa = pct(m.p_away);
    const btts = pct(m.btts), over25 = pct(m.over25), under25 = pct(m.under25);
    const over15 = pct(m.over15), under35 = pct(m.under35);

    let dc1x = pct(m.double_chance_1x), dcx2 = pct(m.double_chance_x2);
    if (!isNum(dc1x) && isNum(ph) && isNum(pd)) dc1x = ph + pd;
    if (!isNum(dcx2) && isNum(pa) && isNum(pd)) dcx2 = pa + pd;

    const dnbH = pct(m.dnb_home), dnbA = pct(m.dnb_away);
    const PERF_MIN = 30;
    const primary1X2 = chk1X2.checked ? buildPrimary1X2Candidate(m) : null;
    const allowLinkedStableDc = !leagueSelected && options.includeGlobal1X2 && ["ultra_stable", "stable"].includes(primary1X2?._x12Badge);

    const add = (ok, payload) => {
      const resolved = resolveCandidateThreshold(m, payload, Math.max(PERF_MIN, getTypeThreshold(payload.type, payload.sub)));
      if (!resolved.enabled) return;
      const thr = resolved.threshold;
      if (payload.type === "1X2") {
        if (resolved.national) {
          if (isNum(ok) && ok >= thr) out.push({ ...payload, _thr: thr, _nationalCalibration: true });
          return;
        }
        if (matches1X2BadgeLevel(payload._x12Badge, get1X2LevelForActiveMode(thr))) {
          out.push({ ...payload, _thr: thr });
        }
        return;
      }
      if (!isNum(ok)) return;
      if (ok >= thr) out.push({ ...payload, _thr: thr, _nationalCalibration: resolved.national });
    };

    if (chkDC.checked && (leagueSelected || allowLinkedStableDc)){
      if (leagueSelected) {
        add(dc1x, { type:"DC", sub:"1X", label:t.label_dc1x(localizeTeamLabel(m.home, m?.league)), prob:dc1x });
        add(dcx2, { type:"DC", sub:"X2", label:t.label_dcx2(localizeTeamLabel(m.away, m?.league)), prob:dcx2 });
      } else {
        buildLinkedDoubleChanceCandidates(m, primary1X2).forEach((candidate) => {
          add(candidate.prob, candidate);
        });
      }
    }
    if (leagueSelected && chkDNB.checked){
      add(dnbH, { type:"DNB", sub:"H", label:t.label_dnb_home(localizeTeamLabel(m.home, m?.league)), prob:dnbH });
      add(dnbA, { type:"DNB", sub:"A", label:t.label_dnb_away(localizeTeamLabel(m.away, m?.league)), prob:dnbA });
    }
    if ((options.includeGlobal1X2 || leagueSelected) && chk1X2.checked){
      if (primary1X2) add(primary1X2.prob, primary1X2);
    }
    if (leagueSelected && chkUnder25.checked) add(under25, { type:"TOT", sub:"U2.5", label:t.label_u25, prob:under25 });
    if (leagueSelected && chkOver25.checked) add(over25, { type:"TOT", sub:"O2.5", label:t.label_o25, prob:over25 });
    if (leagueSelected && chkOver15.checked) add(over15, { type:"TOT", sub:"O1.5", label:t.label_o15, prob:over15 });
    if (leagueSelected && chkUnder35.checked) add(under35, { type:"TOT", sub:"U3.5", label:t.label_u35, prob:under35 });
    if (leagueSelected && chkBTTS.checked) add(btts, { type:"TOT", sub:"BTTS", label:t.label_btts, prob:btts });

    out.forEach((x) => Object.assign(x, {
      league: m.league,
      utc: m.utc,
      kickoff_iso: m.kickoff_iso,
      home: m.home,
      match_id: m.match_id ?? null,
      fixture_id: m.fixture_id ?? m.fixture ?? null,
      match_url: m.match_url ?? null,
      match_page_state: m.match_page_state ?? m.page_state ?? null,
      pick_ids: Array.isArray(m.pick_ids) ? m.pick_ids : [],
      follow_locked_at: typeof m.follow_locked_at === "string" ? m.follow_locked_at : null,
      away: m.away,
      p_home: m.p_home ?? null,
      p_draw: m.p_draw ?? null,
      p_away: m.p_away ?? null,
      entropy_raw: m.entropy_raw ?? null,
      confidence_raw: m.confidence_raw ?? null,
      confidence_ml_raw: m.confidence_ml_raw ?? null,
      confidence_hist_raw: m.confidence_hist_raw ?? null,
      confidence_final_raw: m.confidence_final_raw ?? null,
      confidence_hist_matches: m.confidence_hist_matches ?? null,
      rank_home: m.rank_home ?? null,
      rank_away: m.rank_away ?? null,
      form_index_home: m.form_index_home ?? null,
      form_index_away: m.form_index_away ?? null,
      current_win_streak_home: m.current_win_streak_home ?? null,
      current_win_streak_away: m.current_win_streak_away ?? null,
      current_unbeaten_streak_home: m.current_unbeaten_streak_home ?? null,
      current_unbeaten_streak_away: m.current_unbeaten_streak_away ?? null,
      current_loss_streak_home: m.current_loss_streak_home ?? null,
      current_loss_streak_away: m.current_loss_streak_away ?? null,
      last_results_home: m.last_results_home ?? "",
      last_results_away: m.last_results_away ?? "",
      recent_points_per_match_home: m.recent_points_per_match_home ?? null,
      recent_points_per_match_away: m.recent_points_per_match_away ?? null,
      recent_matches_home: m.recent_matches_home ?? null,
      recent_matches_away: m.recent_matches_away ?? null,
      matches_played_home: m.matches_played_home ?? null,
      matches_played_away: m.matches_played_away ?? null,
      goals_for_home: m.goals_for_home ?? null,
      goals_for_away: m.goals_for_away ?? null,
      goals_against_home: m.goals_against_home ?? null,
      goals_against_away: m.goals_against_away ?? null,
      avg_goals_for_home: m.avg_goals_for_home ?? null,
      avg_goals_for_away: m.avg_goals_for_away ?? null,
      avg_goals_against_home: m.avg_goals_against_home ?? null,
      avg_goals_against_away: m.avg_goals_against_away ?? null,
      top_scores: m.top_scores || null,
      score: m.score || null,
      status: m.status || null,
      ...contextWatchPayloadFromMatch(m)
    }));

    return applyGoals25Exclusion(filterDisabledMarketCandidates(selectBestDoubleChance(out)));
  }

  function buildCandidatesForPerfBase(m, minProbPerf, options = {}){
    if (!fixtureStatus.countsAsAvailable(m)) return [];
    const out = [];
    const leagueSelected = isMatchInLeagueSelection(m, options.selectedLeagueSet);
    const ph = pct(m.p_home), pd = pct(m.p_draw), pa = pct(m.p_away);
    const btts = pct(m.btts), over25 = pct(m.over25), under25 = pct(m.under25);
    const over15 = pct(m.over15), under35 = pct(m.under35);

    let dc1x = pct(m.double_chance_1x), dcx2 = pct(m.double_chance_x2);
    if (!isNum(dc1x) && isNum(ph) && isNum(pd)) dc1x = ph + pd;
    if (!isNum(dcx2) && isNum(pa) && isNum(pd)) dcx2 = pa + pd;

    const dnbH = pct(m.dnb_home), dnbA = pct(m.dnb_away);
    const primary1X2 = chk1X2.checked ? buildPrimary1X2Candidate(m) : null;
    const allowLinkedStableDc = !leagueSelected && options.includeGlobal1X2 && ["ultra_stable", "stable"].includes(primary1X2?._x12Badge);

    const add = (ok, payload) => {
      const resolved = resolveCandidateThreshold(m, payload, minProbPerf);
      if (!resolved.enabled) return;
      const threshold = resolved.threshold;
      if (payload.type === "1X2") {
        if (resolved.national) {
          if (isNum(ok) && ok >= threshold) out.push({ ...payload, _thr: threshold, _nationalCalibration: true });
          return;
        }
        const level = get1X2LevelForActiveMode(minProbPerf);
        if (matches1X2BadgeLevel(payload._x12Badge, level)) {
          out.push({ ...payload, _thr: get1X2ThresholdForLevel(level) });
        }
        return;
      }
      if (!isNum(ok)) return;
      if (ok >= threshold) out.push({ ...payload, _thr: threshold, _nationalCalibration: resolved.national });
    };

    if (chkDC.checked && (leagueSelected || allowLinkedStableDc)){
      if (leagueSelected) {
        add(dc1x, { type:"DC", sub:"1X", label:t.label_dc1x(localizeTeamLabel(m.home, m?.league)), prob:dc1x });
        add(dcx2, { type:"DC", sub:"X2", label:t.label_dcx2(localizeTeamLabel(m.away, m?.league)), prob:dcx2 });
      } else {
        buildLinkedDoubleChanceCandidates(m, primary1X2).forEach((candidate) => {
          add(candidate.prob, candidate);
        });
      }
    }
    if (leagueSelected && chkDNB.checked){
      add(dnbH, { type:"DNB", sub:"H", label:t.label_dnb_home(localizeTeamLabel(m.home, m?.league)), prob:dnbH });
      add(dnbA, { type:"DNB", sub:"A", label:t.label_dnb_away(localizeTeamLabel(m.away, m?.league)), prob:dnbA });
    }
    if ((options.includeGlobal1X2 || leagueSelected) && chk1X2.checked){
      if (primary1X2) add(primary1X2.prob, primary1X2);
    }
    if (leagueSelected && chkUnder25.checked) add(under25, { type:"TOT", sub:"U2.5", label:t.label_u25, prob:under25 });
    if (leagueSelected && chkOver25.checked) add(over25, { type:"TOT", sub:"O2.5", label:t.label_o25, prob:over25 });
    if (leagueSelected && chkOver15.checked) add(over15, { type:"TOT", sub:"O1.5", label:t.label_o15, prob:over15 });
    if (leagueSelected && chkUnder35.checked) add(under35, { type:"TOT", sub:"U3.5", label:t.label_u35, prob:under35 });
    if (leagueSelected && chkBTTS.checked) add(btts, { type:"TOT", sub:"BTTS", label:t.label_btts, prob:btts });

    out.forEach((x) => Object.assign(x, {
      league: m.league,
      utc: m.utc,
      kickoff_iso: m.kickoff_iso,
      home: m.home,
      match_id: m.match_id ?? null,
      fixture_id: m.fixture_id ?? m.fixture ?? null,
      match_url: m.match_url ?? null,
      match_page_state: m.match_page_state ?? m.page_state ?? null,
      pick_ids: Array.isArray(m.pick_ids) ? m.pick_ids : [],
      follow_locked_at: typeof m.follow_locked_at === "string" ? m.follow_locked_at : null,
      away: m.away,
      p_home: m.p_home ?? null,
      p_draw: m.p_draw ?? null,
      p_away: m.p_away ?? null,
      entropy_raw: m.entropy_raw ?? null,
      confidence_raw: m.confidence_raw ?? null,
      confidence_ml_raw: m.confidence_ml_raw ?? null,
      confidence_hist_raw: m.confidence_hist_raw ?? null,
      confidence_final_raw: m.confidence_final_raw ?? null,
      confidence_hist_matches: m.confidence_hist_matches ?? null,
      rank_home: m.rank_home ?? null,
      rank_away: m.rank_away ?? null,
      form_index_home: m.form_index_home ?? null,
      form_index_away: m.form_index_away ?? null,
      current_win_streak_home: m.current_win_streak_home ?? null,
      current_win_streak_away: m.current_win_streak_away ?? null,
      current_unbeaten_streak_home: m.current_unbeaten_streak_home ?? null,
      current_unbeaten_streak_away: m.current_unbeaten_streak_away ?? null,
      current_loss_streak_home: m.current_loss_streak_home ?? null,
      current_loss_streak_away: m.current_loss_streak_away ?? null,
      last_results_home: m.last_results_home ?? "",
      last_results_away: m.last_results_away ?? "",
      recent_points_per_match_home: m.recent_points_per_match_home ?? null,
      recent_points_per_match_away: m.recent_points_per_match_away ?? null,
      recent_matches_home: m.recent_matches_home ?? null,
      recent_matches_away: m.recent_matches_away ?? null,
      matches_played_home: m.matches_played_home ?? null,
      matches_played_away: m.matches_played_away ?? null,
      goals_for_home: m.goals_for_home ?? null,
      goals_for_away: m.goals_for_away ?? null,
      goals_against_home: m.goals_against_home ?? null,
      goals_against_away: m.goals_against_away ?? null,
      avg_goals_for_home: m.avg_goals_for_home ?? null,
      avg_goals_for_away: m.avg_goals_for_away ?? null,
      avg_goals_against_home: m.avg_goals_against_home ?? null,
      avg_goals_against_away: m.avg_goals_against_away ?? null,
      top_scores: m.top_scores || null,
      score: m.score || null,
      status: m.status || null,
      ...contextWatchPayloadFromMatch(m)
    }));

    return applyGoals25Exclusion(filterDisabledMarketCandidates(selectBestDoubleChance(out)));
  }

  function computeGlobalPerf(){
    const selectedLeagueSet = getSelectedLeagueSet();
    const base = (windowMatchesFullRaw && windowMatchesFullRaw.length)
      ? windowMatchesFullRaw
      : ((windowMatchesRaw && windowMatchesRaw.length) ? windowMatchesRaw : windowMatches);

    let winsCur = 0, totalCur = 0, voidsCur = 0;

    for (const m of base){
      const candsCur = buildCandidates(m, {
        selectedLeagueSet,
        includeGlobal1X2: true,
      });
      for (const c of candsCur){
        const o = outcomeForCandidate(c);
        if (!o) continue;
        if (o === "void") voidsCur++;
        else { totalCur++; if (o === "win") winsCur++; }
      }
    }

    const rateCur = totalCur ? (winsCur / totalCur) * 100 : null;
    updatePerfBanner(winsCur, totalCur, voidsCur, rateCur);

    const perfByType = {
      DC: { label: t.perf_type_labels.DC, total: 0, wins: 0, voids: 0, buckets: {} },
      DNB: { label: t.perf_type_labels.DNB, total: 0, wins: 0, voids: 0, buckets: {} },
      "1X2": { label: t.perf_type_labels["1X2"], total: 0, wins: 0, voids: 0, buckets: {} },
      U25: { label: t.perf_type_labels.U25, total: 0, wins: 0, voids: 0, buckets: {} },
      O25: { label: t.perf_type_labels.O25, total: 0, wins: 0, voids: 0, buckets: {} },
      O15: { label: t.perf_type_labels.O15, total: 0, wins: 0, voids: 0, buckets: {} },
      U35: { label: t.perf_type_labels.U35, total: 0, wins: 0, voids: 0, buckets: {} },
      BTTS: { label: t.perf_type_labels.BTTS, total: 0, wins: 0, voids: 0, buckets: {} },
    };

    for (const m of base){
      const candList = buildCandidatesForPerf(m, {
        selectedLeagueSet,
        includeGlobal1X2: true,
      });
      for (const c of candList){
        const o = outcomeForCandidate(c);
        if (!o) continue;

        let key = null;
        if (c.type === "DC") key = "DC";
        else if (c.type === "DNB") key = "DNB";
        else if (c.type === "1X2") key = "1X2";
        else if (c.type === "TOT"){
          if (c.sub === "U2.5") key = "U25";
          else if (c.sub === "O2.5") key = "O25";
          else if (c.sub === "O1.5") key = "O15";
          else if (c.sub === "U3.5") key = "U35";
          else if (c.sub === "BTTS") key = "BTTS";
        }
        if (!key || !perfByType[key]) continue;

        const grp = perfByType[key];
        if (o === "void") grp.voids++;
        else { grp.total++; if (o === "win") grp.wins++; }

        const p = getCandidateFilterScore(c);
        const bucketKey = Math.floor(p / 5) * 5;
        const buckets = grp.buckets;
        const b = buckets[bucketKey] || (buckets[bucketKey] = { prob: bucketKey, total: 0, wins: 0, voids: 0 });

        if (o === "void") b.voids++;
        else { b.total++; if (o === "win") b.wins++; }
      }
    }

    renderTypePerf(perfByType);
    renderTypeTrend7d();
  }

  function buildGlobalPerfForSuggestions(matches){
    const base = getModeOptimizationSource(matches);
    const PERF_MIN = 30;
    const selectedLeagueSet = getSelectedLeagueSet();

    const perfByType = {
      DC: { label: t.perf_type_labels.DC, total: 0, wins: 0, voids: 0, buckets: {} },
      DNB: { label: t.perf_type_labels.DNB, total: 0, wins: 0, voids: 0, buckets: {} },
      "1X2": { label: t.perf_type_labels["1X2"], total: 0, wins: 0, voids: 0, buckets: {} },
      U25: { label: t.perf_type_labels.U25, total: 0, wins: 0, voids: 0, buckets: {} },
      O25: { label: t.perf_type_labels.O25, total: 0, wins: 0, voids: 0, buckets: {} },
      O15: { label: t.perf_type_labels.O15, total: 0, wins: 0, voids: 0, buckets: {} },
      U35: { label: t.perf_type_labels.U35, total: 0, wins: 0, voids: 0, buckets: {} },
      BTTS: { label: t.perf_type_labels.BTTS, total: 0, wins: 0, voids: 0, buckets: {} },
    };

    for (const m of base){
      const candList = buildCandidatesForPerfBase(m, PERF_MIN, {
        selectedLeagueSet,
        includeGlobal1X2: true,
      });
      for (const c of candList){
        const o = outcomeForCandidate(c);
        if (!o) continue;

        let key = null;
        if (c.type === "DC") key = "DC";
        else if (c.type === "DNB") key = "DNB";
        else if (c.type === "1X2") key = "1X2";
        else if (c.type === "TOT"){
          if (c.sub === "U2.5") key = "U25";
          else if (c.sub === "O2.5") key = "O25";
          else if (c.sub === "O1.5") key = "O15";
          else if (c.sub === "U3.5") key = "U35";
          else if (c.sub === "BTTS") key = "BTTS";
        }
        if (!key || !perfByType[key]) continue;

        const grp = perfByType[key];
        if (o === "void") grp.voids++;
        else { grp.total++; if (o === "win") grp.wins++; }

        const p = getCandidateFilterScore(c);
        const bucketKey = Math.floor(p / 5) * 5;
        const buckets = grp.buckets;
        const b = buckets[bucketKey] || (buckets[bucketKey] = { prob: bucketKey, total: 0, wins: 0, voids: 0 });

        if (o === "void") b.voids++;
        else { b.total++; if (o === "win") b.wins++; }
      }
    }

    return perfByType;
  }

  function computeTypeSuggestions(perfByType){
    const suggestions = {};

    for (const [key, g] of Object.entries(perfByType)){
      const thresholds = key === "1X2"
        ? [X12_FILTER_SCORE_CORRECT, X12_FILTER_SCORE_STABLE]
        : [30,35,40,45,50,55,60,65,70,75,80,85,90];
      const buckets = Object.values(g.buckets || {});
      if (!buckets.length) continue;

      let best = null;

      for (const thr of thresholds){
        let wins = 0, total = 0, voids = 0;
        for (const b of buckets){
          if (b.prob >= thr){
            wins += b.wins;
            total += b.total;
            voids += b.voids;
          }
        }

        let minVolume = 10;
        if (key === "BTTS") minVolume = 3;
        if (total < minVolume) continue;

        const rate = total ? (wins / total) * 100 : 0;
        const volumeWeight = REACTIVATED_TOTAL_MARKETS.has(key) ? 0.5 : 0.2;
        const score = rate + Math.min(total, 60) * volumeWeight;

        if (!best || score > best.score){
          best = { thr, rate, volume: total, voids, score };
        }
      }

      if (best) suggestions[key] = best;
    }

    return suggestions;
  }

  function thresholdHitRate(group, threshold){
    if (!group || !group.buckets) return null;
    const thr = Number(threshold);
    if (!Number.isFinite(thr)) return null;

    let wins = 0;
    let total = 0;
    for (const b of Object.values(group.buckets)){
      if ((Number(b.prob) || 0) >= thr){
        wins += Number(b.wins) || 0;
        total += Number(b.total) || 0;
      }
    }
    if (total <= 0) return null;
    return { rate: (wins / total) * 100, wins, total };
  }

  function updateAdvancedThresholdRates(perfByType){
    const src = perfByType || latestPerfByType;

    for (const [typeKey, rateEl] of Object.entries(rateElByTypeKey)){
      if (!rateEl) continue;
      const slider = sliderByTypeKey[typeKey]?.el;
      const thr = slider ? Number(slider.value) : NaN;
      const stats = thresholdHitRate(src?.[typeKey], thr);

      if (!stats){
        rateEl.textContent = t.threshold_rate_unavailable;
        continue;
      }
      rateEl.innerHTML = ` · ${stats.rate.toFixed(1)}%<span class="bb-type-volume">${stats.wins}/${stats.total}</span>`;
    }
  }

  function renderTypeSuggestions(suggWrap, suggestions, labelByKey){
    if (!suggWrap) return;
    suggWrap.innerHTML = "";

    if (!suggestions || !Object.keys(suggestions).length){
      suggWrap.innerHTML = `<p class="tp-type-suggestions__empty">${t.perf_type_empty_suggestions}</p>`;
      return;
    }

    const lead = document.createElement("p");
    lead.className = "tp-type-suggestions__lead";
    lead.textContent = t.perf_type_suggestion_lead;
    suggWrap.appendChild(lead);

    const list = document.createElement("div");
    list.className = "tp-type-suggestion-list";

    Object.entries(suggestions)
      .sort((a, b) => (b[1]?.rate || 0) - (a[1]?.rate || 0))
      .forEach(([key, suggestion]) => {
        const chip = document.createElement("div");
        chip.className = "tp-type-suggestion";
        chip.innerHTML = `
          <span class="tp-type-suggestion__label">${labelByKey[key] || key}</span>
          <span class="tp-type-suggestion__meta">${t.perf_type_recommended_chip(suggestion.thr, suggestion.rate, suggestion.volume)}</span>
        `;
        list.appendChild(chip);
      });

    suggWrap.appendChild(list);
  }

  function renderTypePerf(perfByType){
    const wrap = document.getElementById("bb-type-chart");
    const suggWrap = document.getElementById("bb-type-suggestions");
    if (!wrap) return;

    wrap.innerHTML = "";
    const globalPerfForSug = buildGlobalPerfForSuggestions();
    const suggestions = computeTypeSuggestions(globalPerfForSug);
    lastSuggestions = suggestions || {};
    const labelByKey = Object.fromEntries(
      Object.entries(globalPerfForSug).map(([k, group]) => [k, group.label])
    );

    const rows = Object.entries(perfByType)
      .map(([key, group]) => ({
        key,
        ...group,
        _rate: group.total ? (group.wins / group.total) * 100 : null,
      }))
      .sort((a, b) => (b._rate ?? -1) - (a._rate ?? -1));

    const hasSettledData = rows.some((group) => Number(group.total) > 0);

    if (!rows.length || !hasSettledData){
      wrap.innerHTML = `
        <article class="bb-type-empty-card">
          <strong>${t.perf_type_no_data}</strong>
          <span>${t.perf_type_empty}</span>
        </article>
      `;
      latestPerfByType = perfByType;
      updateAdvancedThresholdRates(perfByType);
      renderTypeSuggestions(suggWrap, suggestions, labelByKey);
      return;
    }

    rows.forEach((group, idx) => {
      const rate = group._rate ?? 0;
      const suggestion = suggestions?.[group.key] || null;
      const width = Math.max(Math.min(rate, 100), 6);
      const toneClass =
        rate >= 70 ? "bb-type-row--hot" :
        rate >= 55 ? "bb-type-row--warm" :
        "bb-type-row--cool";

      const row = document.createElement("article");
      row.className = `bb-type-row ${toneClass}`;
      if (idx === 0 && rate > 0) row.classList.add("bb-type-row--best");

      row.innerHTML = `
        <div class="bb-type-rank">${idx + 1}</div>
        <div class="bb-type-card">
          <div class="bb-type-head">
            <div class="bb-type-head__main">
              <div class="bb-type-label-wrap">
                <div class="bb-type-label">${group.label || group.key}</div>
                ${idx === 0 && rate > 0 ? `<span class="bb-type-badge">${t.perf_type_best}</span>` : ""}
              </div>
              <div class="bb-type-value">${rate.toFixed(1)}%</div>
            </div>
            <div class="bb-type-meta">
              <span class="bb-type-stat"><strong>${group.wins}/${group.total}</strong> ${t.perf_type_volume_short}</span>
              ${group.voids ? `<span class="bb-type-stat">${group.voids} ${t.perf_type_voids_short}</span>` : ""}
              ${suggestion ? `<span class="bb-type-stat bb-type-stat--accent">${t.perf_type_recommended} ${suggestion.thr}%</span>` : ""}
            </div>
          </div>
          <div class="bb-type-bar-wrap">
            <div class="bb-type-bar" style="width:${width}%"></div>
          </div>
          <div class="bb-type-foot">
            <span class="bb-type-foot__text">
              ${suggestion
                ? t.perf_type_recommended_chip(suggestion.thr, suggestion.rate, suggestion.volume)
                : t.perf_type_no_data_hint}
            </span>
          </div>
        </div>
      `;
      wrap.appendChild(row);
    });

    renderTypeSuggestions(suggWrap, suggestions, labelByKey);

    if (!suggestionsAppliedOnce && suggestions && Object.keys(suggestions).length){
      for (const [key, s] of Object.entries(suggestions)){
        const slot = sliderByTypeKey[key];
        if (!slot || !slot.el) continue;

        if (!touchedTypes.has(key)){
          slot.el.value = s.thr;
          if (slot.valEl) slot.valEl.textContent = s.thr;
        }
      }
      suggestionsAppliedOnce = true;
      filterAndRender();
    }

    latestPerfByType = perfByType;
    updateAdvancedThresholdRates(perfByType);
  }

  function formatTrendDayLabel(dayKey){
    if (!dayKey) return lang === "es" ? "Fecha no disponible" : lang === "en" ? "Date unavailable" : "Date indisponible";
    const d = new Date(`${dayKey}T00:00:00`);
    if (Number.isNaN(d.getTime())) return dayKey;
    return new Intl.DateTimeFormat(lang === "en" ? "en-GB" : lang === "es" ? "es-ES" : "fr-FR", {
      day: "2-digit",
      month: "short",
    }).format(d);
  }

  function buildTypeTrendRows(){
    const selectedLeagueSet = getSelectedLeagueSet();
    const base = (windowMatchesFullRaw && windowMatchesFullRaw.length)
      ? windowMatchesFullRaw
      : ((windowMatchesRaw && windowMatchesRaw.length) ? windowMatchesRaw : windowMatches);
    const byType = new Map();
    const dayKeys = new Set();
    const knownTypes = ["DC", "DNB", "1X2", "U25", "O25", "O15", "U35", "BTTS"];

    for (const m of base){
      const dayKey = localDayKeyFromUTC(m);
      if (!dayKey) continue;
      dayKeys.add(dayKey);

      const candList = buildCandidatesForPerf(m, {
        selectedLeagueSet,
        includeGlobal1X2: true,
      });
      for (const c of candList){
        const typeKey = candidateTypeKey(c);
        if (!typeKey) continue;

        if (!byType.has(typeKey)){
          byType.set(typeKey, {
            key: typeKey,
            label: t.perf_type_labels?.[typeKey] || typeKey,
            days: new Map(),
          });
        }

        const row = byType.get(typeKey);
        if (!row.days.has(dayKey)){
          row.days.set(dayKey, { wins: 0, total: 0, voids: 0, pending: 0, shown: 0 });
        }

        const slot = row.days.get(dayKey);
        slot.shown += 1;

        const outcome = outcomeForCandidate(c);
        if (!outcome) {
          slot.pending += 1;
        } else if (outcome === "void") {
          slot.voids += 1;
        } else {
          slot.total += 1;
          if (outcome === "win") slot.wins += 1;
        }
      }
    }

    const last7Days = Array.from(dayKeys).sort().slice(-7);
    knownTypes.forEach((typeKey) => {
      if (!byType.has(typeKey)){
        byType.set(typeKey, {
          key: typeKey,
          label: t.perf_type_labels?.[typeKey] || typeKey,
          days: new Map(),
        });
      }
    });

    return Array.from(byType.values())
      .map((row) => {
        const days = last7Days.map((dayKey) => {
          const slot = row.days.get(dayKey) || { wins: 0, total: 0, voids: 0, pending: 0, shown: 0 };
          const rate = slot.total ? (slot.wins / slot.total) * 100 : null;
          return { dayKey, ...slot, rate };
        });

        const total = days.reduce((sum, day) => sum + day.total, 0);
        const wins = days.reduce((sum, day) => sum + day.wins, 0);
        const voids = days.reduce((sum, day) => sum + day.voids, 0);
        const pending = days.reduce((sum, day) => sum + day.pending, 0);
        const shown = days.reduce((sum, day) => sum + day.shown, 0);
        return {
          ...row,
          days,
          total,
          wins,
          voids,
          pending,
          shown,
          rate: total ? (wins / total) * 100 : null,
        };
      })
      .filter((row) => row.days.some((day) => day.shown > 0))
      .sort((a, b) => (b.rate ?? -1) - (a.rate ?? -1));
  }

  function renderTypeTrend7d(){
    const wrap = document.getElementById("pp-trend-grid");
    if (!wrap) return;

    const rows = buildTypeTrendRows();
    if (!rows.length){
      wrap.innerHTML = `<p class="pp-trend-empty">${t.trend_empty}</p>`;
      return;
    }

    wrap.innerHTML = "";
    rows.forEach((row) => {
      const card = document.createElement("article");
      card.className = "pp-trend-card";

      const dayBars = row.days.map((day) => {
        const height = Number.isFinite(day.rate)
          ? Math.max(12, Math.min(100, day.rate))
          : day.shown > 0
            ? Math.max(10, Math.min(36, day.shown * 6))
            : 8;
        const toneClass = !day.shown
          ? "is-empty"
          : !day.total
            ? "is-pending"
          : day.rate >= 70
            ? "is-hot"
            : day.rate >= 55
              ? "is-warm"
              : "is-cool";
        const volumeLabel = day.total
          ? t.trend_day_sample(day.total, day.voids)
          : day.pending
            ? t.trend_day_pending(day.pending)
            : "—";

        return `
          <div class="pp-trend-day ${toneClass}">
            <div class="pp-trend-day__bar-shell">
              <span class="pp-trend-day__bar" style="height:${height}%;"></span>
            </div>
            <strong class="pp-trend-day__rate">${Number.isFinite(day.rate) ? `${day.rate.toFixed(0)}%` : (day.shown ? "…" : "—")}</strong>
            <span class="pp-trend-day__volume">${volumeLabel}</span>
            <span class="pp-trend-day__label">${formatTrendDayLabel(day.dayKey)}</span>
          </div>
        `;
      }).join("");

      card.innerHTML = `
        <div class="pp-trend-card__head">
          <div>
            <h3 class="pp-trend-card__title">${row.label}</h3>
          <p class="pp-trend-card__meta">${t.trend_volume}: ${row.shown}${row.pending ? ` · ${row.pending} ${lang === "es" ? "pendientes" : lang === "en" ? "upcoming" : "à venir"}` : ""}${row.voids ? ` · ${row.voids} ${lang === "es" ? "anulados" : lang === "en" ? "void" : "remb."}` : ""}</p>
          </div>
          <div class="pp-trend-card__score">${Number.isFinite(row.rate) ? `${row.rate.toFixed(1)}%` : (row.shown ? (lang === "es" ? "Pendiente" : lang === "en" ? "Pending" : "En cours") : t.details_na)}</div>
        </div>
        <div class="pp-trend-days">${dayBars}</div>
      `;

      wrap.appendChild(card);
    });
  }

  function resetAdvancedToSuggestions(){
    if (isBuiltInAutomaticSelection()) {
      applyBuiltInMode(activeDisplayMode);
      return;
    }
    if (profilesApi?.getProfile(activeModeSelection.slice(8))) {
      applyProfileConfig(profilesApi.getProfile(activeModeSelection.slice(8)));
      return;
    }
    if (!lastSuggestions || !Object.keys(lastSuggestions).length) return;

    for (const [key, slot] of Object.entries(sliderByTypeKey)){
      if (!slot || !slot.el) continue;
      const s = lastSuggestions[key];
      if (!s) continue;

      setTypeSliderValue(key, s.thr, { markTouched: false });
      touchedTypes.delete(key);
    }
    syncAdvancedToggleUI();
    filterAndRender();
  }

  function attachTypeSlider(el, labelEl, typeKey){
    if (!el) return;
    if (typeKey === "1X2") {
      el.min = String(X12_FILTER_SCORE_CORRECT);
      el.max = String(X12_FILTER_SCORE_STABLE);
      el.step = String(X12_FILTER_SCORE_STABLE - X12_FILTER_SCORE_CORRECT);
      el.value = String(normalize1X2ControlValue(el.value));
    }
    el.addEventListener("input", () => {
      markTopModeUserInteraction();
      touchedTypes.add(typeKey);
      if (typeKey === "1X2") {
        const normalized = normalize1X2ControlValue(el.value);
        el.value = String(normalized);
        if (labelEl) labelEl.textContent = get1X2LevelLabel(get1X2LevelFromThreshold(normalized));
      } else if (labelEl) {
        labelEl.textContent = el.value;
      }
      updateAdvancedThresholdRates();
      syncAdvancedToggleUI();
    });
    if (typeKey === "1X2" && labelEl) {
      labelEl.textContent = get1X2LevelLabel(get1X2LevelFromThreshold(el.value));
    }
    el.addEventListener("change", () => {
      markTopModeUserInteraction();
      filterAndRender();
    });
  }

  /* ────────────── Carte démo du tutoriel (fs_tour_engine demoCard) ──────────────
   * Montée quand l'utilisateur accepte la visite guidée, démontée à la fin
   * (skip inclus). Insérée en tête de grille après chaque rendu ; jamais
   * comptée dans les stats du jour. Ses picks ignorent modes et filtres. */

  const TOUR_DEMO_BADGE_LABEL = lang === "en" ? "Example" : lang === "es" ? "Ejemplo" : "Exemple";
  let tourDemoActive = false;

  function buildTourDemoMatch() {
    const utc = `${todayISO()} 19:00`;
    const demoDate = todayISO();
    const preset = lang === "en"
      ? {
        league: "PREMIER_LEAGUE", home: "Arsenal FC", away: "Liverpool FC",
        derbyFr: "Choc au sommet", derbyEn: "Top-of-the-table clash", derbyEs: "Duelo en la cumbre",
        pHome: 48, pDraw: 26, pAway: 26, eloHome: 1901, eloAway: 1912, rankHome: 2, rankAway: 1
      }
      : lang === "es"
        ? {
          league: "LIGA", home: "FC Barcelona", away: "Real Madrid",
          derbyFr: "El Clásico", derbyEn: "El Clásico", derbyEs: "El Clásico",
          pHome: 55, pDraw: 24, pAway: 21, eloHome: 1958, eloAway: 1949, rankHome: 1, rankAway: 2
        }
        : {
          league: "LIGUE_1", home: "Paris Saint Germain", away: "Olympique de Marseille",
          derbyFr: "Le Classique", derbyEn: "Le Classique", derbyEs: "Le Classique",
          pHome: 62, pDraw: 21, pAway: 17, eloHome: 1885, eloAway: 1832, rankHome: 1, rankAway: 3
        };
    const matchUrl = lang === "en"
      ? `/en/prediction/premier-league/arsenal-fc-liverpool-fc-${demoDate}/`
      : lang === "es"
        ? `/es/pronostico/liga/fc-barcelona-real-madrid-${demoDate}/`
        : `/pronostic/ligue-1/paris-saint-germain-olympique-de-marseille-${demoDate}/`;
    return {
      league: preset.league,
      utc,
      home: preset.home,
      away: preset.away,
      match_url: matchUrl,
      match_page_state: "prediction_available",
      p_home: preset.pHome, p_draw: preset.pDraw, p_away: preset.pAway,
      btts: 56, over25: 58, under25: 42,
      double_chance_1x: Math.min(96, preset.pHome + preset.pDraw),
      double_chance_x2: preset.pAway + preset.pDraw,
      dnb_home: 74, dnb_away: 26,
      stability_badge: "stable",
      entropy_raw: 1.2,
      confidence_raw: 0.71, confidence_ml_raw: 0.70, confidence_hist_raw: 0.72,
      confidence_final_raw: 0.71, confidence_hist_matches: 124,
      elo_home: preset.eloHome, elo_away: preset.eloAway,
      rank_home: preset.rankHome, rank_away: preset.rankAway,
      form_index_home: 82, form_index_away: 74,
      current_win_streak_home: 3, current_win_streak_away: 1,
      current_unbeaten_streak_home: 6, current_unbeaten_streak_away: 4,
      current_loss_streak_home: 0, current_loss_streak_away: 0,
      last_results_home: "WWDWW", last_results_away: "WDWLW",
      recent_points_per_match_home: 2.4, recent_points_per_match_away: 1.8,
      recent_matches_home: 5, recent_matches_away: 5,
      matches_played_home: 30, matches_played_away: 30,
      goals_for_home: 68, goals_for_away: 52,
      goals_against_home: 27, goals_against_away: 35,
      avg_goals_for_home: 2.3, avg_goals_for_away: 1.7,
      avg_goals_against_home: 0.9, avg_goals_against_away: 1.2,
      top_scores: "2-1 (16%), 2-0 (13%), 1-0 (11%), 3-1 (9%), 1-1 (8%)",
      score: null,
      status: "scheduled",
      derby_flag: true,
      derby_context_reliable: true,
      derby_display_level: "warning",
      derby_label_fr: preset.derbyFr,
      derby_label_en: preset.derbyEn,
      derby_label_es: preset.derbyEs,
      home_european_fixture_nearby_flag: true
    };
  }

  function buildTourDemoCandidates() {
    const m = buildTourDemoMatch();
    const cands = [];
    const primary = buildPrimary1X2Candidate(m);
    if (primary) cands.push({ ...primary, _thr: 0 });
    cands.push({ type: "DC", sub: "1X", label: t.label_dc1x(localizeTeamLabel(m.home, m.league)), prob: pct(m.double_chance_1x), _thr: 0 });
    cands.push({ type: "DNB", sub: "H", label: t.label_dnb_home(localizeTeamLabel(m.home, m.league)), prob: pct(m.dnb_home), _thr: 0 });
    cands.forEach((x) => {
      const own = { ...x };
      Object.assign(x, m, own);
      x._conf = 71;
      x._hist_n = 124;
      x._conf_display = 71;
      x._tour_demo = true;
    });
    return cands;
  }

  async function renderTourDemoCardInto() {
    if (!tourDemoActive || !elGrid) return;
    if (elGrid.querySelector("[data-fs-tour-demo]")) return;
    try {
      const picks = buildTourDemoCandidates();
      if (!picks.length) return;
      const el = await renderMatchCard("fs|tour|demo|match", picks);
      el.setAttribute("data-fs-tour-demo", "1");
      el.setAttribute("data-tour-demo-label", TOUR_DEMO_BADGE_LABEL);
      elGrid.insertBefore(el, elGrid.firstChild);
      applyExpertModeToCards(expertModeEnabled);
      applyCompactModeToCards(compactModeEnabled);
      // La carte arrive après le rendu de l'étape du tour : le moteur
      // repositionne son spotlight sur resize, on le déclenche manuellement.
      window.dispatchEvent(new Event("resize"));
    } catch (error) {
      console.warn("[top_pronostics_ia] tour demo card failed:", error);
    }
  }

  window.__fsTourDemoCard = {
    mount: function () {
      tourDemoActive = true;
      renderTourDemoCardInto();
    },
    unmount: function () {
      tourDemoActive = false;
      const el = elGrid ? elGrid.querySelector("[data-fs-tour-demo]") : null;
      if (el) el.remove();
    }
  };

  async function filterAndRender(options = {}){
    const ownsGeneration = !Number.isFinite(Number(options.generation));
    const generation = ownsGeneration
      ? beginListingUpdate(options.reason || "filter")
      : Number(options.generation);

    hasDaySummarySnapshot = false;

    try {
      updateSelectionState();
      if (isBuiltInAutomaticSelection() && !getRemoteBuiltInModeConfigs()?.[activeDisplayMode]) {
        elGrid.textContent = selectionCopy.unavailable;
        lastCandidatesForDay = [];
        lastTopPronosticsRenderCount = 0;
        hasDaySummarySnapshot = true;
        return 0;
      }
      // Give the browser one frame to paint the lightweight loading state
      // before candidate calculation / card generation starts.
      await yieldToBrowser();
      if (!isListingGenerationCurrent(generation)) return lastTopPronosticsRenderCount;

      const sortMode = elSort ? String(elSort.value) : "time";
      const groupMode = elGroup ? String(elGroup.value) : "match";
      const rangeMode = elRange ? String(elRange.value) : "all";
      const selectedLeagueSet = getSelectedLeagueSet();

      const source = (windowMatchesFullRaw && windowMatchesFullRaw.length)
        ? windowMatchesFullRaw
        : windowMatches;
      const inDay = source.filter((m) => localDayKeyFromUTC(m) === selectedDate);

      let candidates = [];
      for (const m of inDay){
        candidates = candidates.concat(buildCandidates(m, {
          selectedLeagueSet,
          includeGlobal1X2: true,
        }) || []);
      }

      if (!candidates.length){
        if (!isListingGenerationCurrent(generation)) return 0;

        const emptyCard = document.createElement("div");
        emptyCard.className = "bestbet-card";
        emptyCard.style.textAlign = "center";
        emptyCard.innerHTML = `${t.no_bet_title}<br/><small>${t.no_bet_hint}</small>`;

        lastCandidatesForDay = [];
        lastTopPronosticsRenderCount = 0;
        hasDaySummarySnapshot = true;
        elGrid.replaceChildren(emptyCard);
        markTopPerf("personalized_candidates_ready", { picks: 0 });
        markTopPerf("first_batch_rendered", { cards: 0 });
        markTopPerf("full_grid_rendered", { cards: 0 });
        initialProgressiveRenderPending = false;
        startDeferredCardEnrichments();

        await renderTourDemoCardInto();
        if (isListingGenerationCurrent(generation)) {
          schedulePostRenderTasks();
          schedulePersistTopFiltersState();
        }
        return 0;
      }

      const enriched = candidates.map((c) => {
        const confidenceMetrics = confidenceMetricsForCandidate(c);
        const sr = confidenceMetrics?.sr ?? reliabilityForCandidate(c);
        const conf = normalizeConfidence(sr);
        const histN = confidenceMetrics?.total ?? histSampleForCandidate(c);
        const confSource = confidenceMetrics?.source ?? null;
        const candidateWithConfidence = {
          ...c,
          _conf: conf,
          _hist_n: histN,
          _conf_source: confSource
        };
        const confDisplay = displayedPickConfidenceForCandidate(candidateWithConfidence);
        return { ...candidateWithConfidence, _conf_display: confDisplay };
      });

      const now = new Date();
      const maxDt = (() => {
        if (rangeMode === "24h") return 24 * 3600 * 1000;
        if (rangeMode === "48h") return 48 * 3600 * 1000;
        if (rangeMode === "7d")  return 7 * 24 * 3600 * 1000;
        return null;
      })();

      let filtered = enriched.filter((c) => {
        if (!c.kickoff_iso) return true;
        const dt = parseFrenchDateTime(c);
        if (!dt) return true;
        if (rangeMode === "upcoming") return dt >= now;
        if (maxDt != null) return (dt >= now) && (dt - now <= maxDt);
        return true;
      });

      if (chkHidePast?.checked){
        const nowTs = Date.now();
        filtered = filtered.filter((c) => !isPastCandidateForDisplay(c, nowTs));
      }

      filtered = filtered.filter((candidate) => candidatePassesProfileFilters(candidate));
      filtered = filtered.filter((candidate) => nonPlayableCandidatePassesActiveSelection(candidate));
      if (activeWizardX12Custom) {
        filtered = filtered.filter((c) => matchesWizardX12Custom(c, activeWizardX12Custom));
      }

      let worldCupCandidates = [];
      const useDedicatedWorldCupSection = WC2026_CROSS_PAGE && sortMode !== "time";
      if (useDedicatedWorldCupSection) {
        worldCupCandidates = filtered.filter((c) => isWorldCup2026League(c && c.league));
        filtered = filtered.filter((c) => !isWorldCup2026League(c && c.league));
      }

      const nextCandidatesForDay = filtered.concat(worldCupCandidates);
      const activeCandidatesForDay = nextCandidatesForDay.filter((candidate) => fixtureStatus.countsAsAvailable(candidate));
      const nextRenderCount = activeCandidatesForDay.length;

      filtered.sort((a,b) => {
        if (sortMode === "time"){
          const d = parseUtcTime(a) - parseUtcTime(b);
          return d !== 0 ? d : (b.prob - a.prob);
        }
        if (sortMode === "confidence"){
          const d = sortablePickConfidenceForCandidate(b) - sortablePickConfidenceForCandidate(a);
          return d !== 0 ? d : ((b.prob - a.prob) || (parseUtcTime(a) - parseUtcTime(b)));
        }
        return (b.prob - a.prob)
          || (sortablePickConfidenceForCandidate(b) - sortablePickConfidenceForCandidate(a))
          || (parseUtcTime(a) - parseUtcTime(b));
      });

      markTopPerf("personalized_candidates_ready", { picks: nextRenderCount });
      detailsIdCounter = 0;
      const progressiveInitial = initialProgressiveRenderPending;
      const nextRoot = progressiveInitial ? elGrid : document.createDocumentFragment();
      if (progressiveInitial) elGrid.replaceChildren();
      const inlineAdMatchCount = new Set(
        filtered.map((candidate) => `${candidate.league}|${candidate.utc}|${candidate.home}|${candidate.away}`)
      ).size;
      const renderState = {
        renderedMatchCards: 0,
        injectInlineAds: shouldRenderInlineMatchAds(),
        inlineAdInterval: inlineAdMatchCount > 0 && inlineAdMatchCount < 10 ? 2 : 4,
        insertedInlineAd: false,
      };

      const onBatchRendered = () => {
        markTopPerf("first_batch_rendered", { cards: renderState.renderedMatchCards });
        startDeferredCardEnrichments();
      };

      const worldCupSection = await renderWorldCupDedicatedSection(worldCupCandidates);
      if (!isListingGenerationCurrent(generation)) return nextRenderCount;
      if (worldCupSection) nextRoot.appendChild(worldCupSection);

      if (!filtered.length){
        if (!worldCupSection) {
          const emptyCard = document.createElement("div");
          emptyCard.className = "bestbet-card";
          emptyCard.style.textAlign = "center";
          emptyCard.innerHTML = `${t.no_bet_title}<br/><small>${t.no_bet_hint}</small>`;
          nextRoot.appendChild(emptyCard);
        }
      } else if (groupMode === "none") {
        let list = filtered;
        if (chkHideFinishedDay && chkHideFinishedDay.checked) {
          list = list.filter((c) => !isSettledCandidate(c));
        }
        const entries = list.map((c) => [
          `${c.league}|${c.utc}|${c.home}|${c.away}`,
          [c]
        ]);
        const ok = await renderCardBatch(entries, nextRoot, renderState, generation, 6, { onBatchRendered });
        if (!ok) return nextRenderCount;
      } else if (groupMode === "prob") {
        const binSize = 5;
        const groups = new Map();

        for (const c of filtered){
          const p = Number(c.prob || 0);
          const lo = Math.floor(p / binSize) * binSize;
          const hi = lo + binSize;
          const k = `${lo}-${hi}`;
          if (!groups.has(k)) groups.set(k, []);
          groups.get(k).push(c);
        }

        const keys = Array.from(groups.keys()).sort((a,b) => {
          const alo = Number(a.split("-")[0]);
          const blo = Number(b.split("-")[0]);
          return blo - alo;
        });

        for (const k of keys){
          if (!isListingGenerationCurrent(generation)) return nextRenderCount;
          const arr = groups.get(k);
          const byMatch = new Map();

          for (const c of arr){
            const mk = `${c.league}|${c.utc}|${c.home}|${c.away}`;
            if (!byMatch.has(mk)) byMatch.set(mk, []);
            byMatch.get(mk).push(c);
          }

          let matchEntries = Array.from(byMatch.entries());

          if (chkHideFinishedDay && chkHideFinishedDay.checked) {
            matchEntries = matchEntries.filter(([, picks]) => !matchHasAnySettledPick(picks));
          }

          matchEntries.sort((A,B) => {
            const picksA = A[1], picksB = B[1];
            if (sortMode === "time"){
              const ta = parseUtcTime(picksA[0]);
              const tb = parseUtcTime(picksB[0]);
              const d = ta - tb;
              if (d !== 0) return d;
              const bestA = Math.max(...picksA.map(x => x.prob || 0));
              const bestB = Math.max(...picksB.map(x => x.prob || 0));
              return bestB - bestA;
            }
            const bestA = Math.max(...picksA.map(x => x.prob || 0));
            const bestB = Math.max(...picksB.map(x => x.prob || 0));
            return (bestB - bestA) || (parseUtcTime(picksA[0]) - parseUtcTime(picksB[0]));
          });

          matchEntries.forEach(([, picks]) => {
            picks.sort((a,b) =>
              (b.prob - a.prob)
              || (sortablePickConfidenceForCandidate(b) - sortablePickConfidenceForCandidate(a))
            );
          });

          const wrap = document.createElement("div");
          wrap.className = "tp-group";
          const title = document.createElement("div");
          title.className = "tp-group__title";
          title.innerHTML = `<span>${k}%</span><small>${arr.length} pick(s)</small>`;
          wrap.appendChild(title);

          if (progressiveInitial) nextRoot.appendChild(wrap);
          const ok = await renderCardBatch(matchEntries, wrap, renderState, generation, 6, { onBatchRendered });
          if (!ok) return nextRenderCount;
          if (!progressiveInitial) nextRoot.appendChild(wrap);
          await yieldToBrowser();
        }
      } else {
        const byMatch = new Map();
        for (const c of filtered){
          const mk = `${c.league}|${c.utc}|${c.home}|${c.away}`;
          if (!byMatch.has(mk)) byMatch.set(mk, []);
          byMatch.get(mk).push(c);
        }

        let matchEntries = Array.from(byMatch.entries());

        if (chkHideFinishedDay && chkHideFinishedDay.checked) {
          matchEntries = matchEntries.filter(([, picks]) => !matchHasAnySettledPick(picks));
        }

        matchEntries.sort((A,B) => {
          const picksA = A[1], picksB = B[1];
          if (sortMode === "time"){
            const ta = parseUtcTime(picksA[0]);
            const tb = parseUtcTime(picksB[0]);
            const d = ta - tb;
            if (d !== 0) return d;
            const bestA = Math.max(...picksA.map(x => x.prob || 0));
            const bestB = Math.max(...picksB.map(x => x.prob || 0));
            return bestB - bestA;
          }
          const bestA = Math.max(...picksA.map(x => x.prob || 0));
          const bestB = Math.max(...picksB.map(x => x.prob || 0));
          return (bestB - bestA)
            || (parseUtcTime(picksA[0]) - parseUtcTime(picksB[0]));
        });

        matchEntries.forEach(([, picks]) => {
          picks.sort((a,b) =>
            (b.prob - a.prob)
            || (sortablePickConfidenceForCandidate(b) - sortablePickConfidenceForCandidate(a))
          );
        });

        const ok = await renderCardBatch(matchEntries, nextRoot, renderState, generation, 6, { onBatchRendered });
        if (!ok) return nextRenderCount;
      }

      if (!isListingGenerationCurrent(generation)) return nextRenderCount;

      // Only the first boot is progressive. Every later profile/filter change
      // keeps the existing atomic swap semantics.
      if (!progressiveInitial) elGrid.replaceChildren(nextRoot);
      initialProgressiveRenderPending = false;
      markTopPerf("first_batch_rendered", { cards: renderState.renderedMatchCards });
      markTopPerf("full_grid_rendered", { cards: renderState.renderedMatchCards });
      startDeferredCardEnrichments();

      lastCandidatesForDay = activeCandidatesForDay;
      lastTopPronosticsRenderCount = nextRenderCount;
      hasDaySummarySnapshot = true;

      await renderTourDemoCardInto();
      if (!isListingGenerationCurrent(generation)) return nextRenderCount;

      applyExpertModeToCards(expertModeEnabled);
      applyCompactModeToCards(compactModeEnabled);
      schedulePostRenderTasks({ refreshInlineAds: renderState.insertedInlineAd });
      schedulePersistTopFiltersState();

      return nextRenderCount;
    } catch (error) {
      console.error("filterAndRender failed", error);
      if (isListingGenerationCurrent(generation) && elGrid) {
        const errorCard = document.createElement("div");
        errorCard.className = "bestbet-card";
        errorCard.textContent = t.error_loading;
        elGrid.replaceChildren(errorCard);
      }
      return 0;
    } finally {
      if (ownsGeneration) endListingUpdate(generation);
    }
  }

  async function restoreStoredTopFiltersState() {
    const stored = readStoredTopFiltersState();
    if (!stored || typeof stored !== "object") return false;

    optimizeWithTodayResults = !!stored.optimizeWithTodayResults;
    if (chkOptimizeTodayResults) chkOptimizeTodayResults.checked = optimizeWithTodayResults;
    syncOptimizeTodayUI();

    const selection = String(stored.selection || "builtin:performance");
    setActiveModeSelection(selection, { persist: false });

    if (isCustomProfileSelection(selection) && profilesApi) {
      const profile = profilesApi.getProfile(selection.slice(8));
      if (profile) {
        await applyProfileConfig(profile, { persist: false });
        return true;
      }
    }

    const mode = selection.replace(/^builtin:/, "") || "performance";
    await applyDisplayMode(mode);
    return true;
  }


  async function restoreActiveModeSelection(){
    const forcedProfileBuilderMode = String(document.documentElement?.dataset?.fsProfileBuilderDefault || "").trim();
    if (forcedProfileBuilderMode === "performance"){
      setActiveModeSelection("builtin:performance", { persist: false });
      if (elDisplayMode) elDisplayMode.value = "performance";
      selectAllLeagues();
      syncInlineModeButtons();
      await applyPerformanceModeState();
      return;
    }

    if (await restoreStoredTopFiltersState()) {
      return;
    }

    const storedSelection = profilesApi ? profilesApi.getActiveSelection() : `builtin:${activeDisplayMode}`;

    if (isCustomProfileSelection(storedSelection) && profilesApi){
      const profile = profilesApi.getProfile(storedSelection.slice(8));
      if (profile){
        await applyProfileConfig(profile, { persist: false });
        return;
      }
    }

    const mode = storedSelection.startsWith("builtin:")
      ? storedSelection.slice(8)
      : "performance";

    setActiveModeSelection(`builtin:${mode}`, { persist: false });
    if (mode === "performance"){
      if (elDisplayMode) elDisplayMode.value = "performance";
      syncInlineModeButtons();
      await applyPerformanceModeState();
      return;
    }

    await applyDisplayMode(mode);
  }
  if (chkOptimizeTodayResults){
    chkOptimizeTodayResults.addEventListener("change", async () => {
      markTopModeUserInteraction();
      optimizeWithTodayResults = !!chkOptimizeTodayResults.checked;
      persistOptimizeTodayResults(optimizeWithTodayResults);
      syncOptimizeTodayUI();

      // Profil perso : on ne réécrit pas ses réglages, on rerender juste
      if (isCustomProfileSelection()) {
        await filterAndRender();
        return;
      }

      // Mode "tous les matchs" : pas concerné par l'optimisation perf
      if (activeDisplayMode === "all") {
        setModeHint(t.mode_hint_all);
        await filterAndRender();
        return;
      }

      await applyDisplayMode(activeDisplayMode);
    });
  }

  // Events
  if (elSort) elSort.addEventListener("change", () => {
    markTopModeUserInteraction();
    if (elV2Sort && elV2Sort.value !== elSort.value) elV2Sort.value = elSort.value;
    filterAndRender();
  });
  if (elGroup) elGroup.addEventListener("change", () => {
    markTopModeUserInteraction();
    filterAndRender();
  });
  if (elRange) elRange.addEventListener("change", () => {
    markTopModeUserInteraction();
    filterAndRender();
  });
  if (chkHideFinishedDay){
    chkHideFinishedDay.addEventListener("change", () => {
      markTopModeUserInteraction();
      filterAndRender();
    });
  }

  [chkDC, chkDNB, chk1X2, chkUnder25, chkOver25, chkOver15, chkUnder35, chkBTTS].forEach((el) => {
    if (!el) return;
    el.addEventListener("change", () => {
      markTopModeUserInteraction();
      filterAndRender();
    });
  });

  attachTypeSlider(elMinDC, elMinDCVal, "DC");
  attachTypeSlider(elMinDNB, elMinDNBVal, "DNB");
  attachTypeSlider(elMin1X2, elMin1X2Val, "1X2");
  attachTypeSlider(elMinU25, elMinU25Val, "U25");
  attachTypeSlider(elMinO25, elMinO25Val, "O25");
  attachTypeSlider(elMinO15, elMinO15Val, "O15");
  attachTypeSlider(elMinU35, elMinU35Val, "U35");
  attachTypeSlider(elMinBTTS, elMinBTTSVal, "BTTS");

  bindMatchDetailsInteractions();

  btnRefresh.addEventListener("click", refreshSources);
  if (chkHidePast){
    chkHidePast.addEventListener("change", () => {
      markTopModeUserInteraction();
      if (elV2HidePast) elV2HidePast.checked = !!chkHidePast.checked;
      filterAndRender();
    });
  }
  if (elExpertMode){
    elExpertMode.addEventListener("change", () => {
      applyExpertModeToCards(!!elExpertMode.checked);
      schedulePersistTopFiltersState();
    });
  }
  if (elCompactMode){
    elCompactMode.addEventListener("change", () => {
      applyCompactModeToCards(!!elCompactMode.checked, {
        track: true,
        origin: "checkbox"
      });
      syncV2ViewSwitch();
      schedulePersistTopFiltersState();
    });
  }

  if (elV2Sort && elSort) {
    elV2Sort.addEventListener("change", () => {
      if (elSort.value === elV2Sort.value) return;
      elSort.value = elV2Sort.value;
      elSort.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  if (elV2HidePast && chkHidePast) {
    elV2HidePast.addEventListener("change", () => {
      if (chkHidePast.checked === elV2HidePast.checked) return;
      chkHidePast.checked = elV2HidePast.checked;
      chkHidePast.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  if (elV2ViewButtons.length) {
    elV2ViewButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const mode = String(button.getAttribute("data-tpv2-view") || "compact");
        const nextCompact = mode !== "detailed";
        if (compactModeEnabled !== nextCompact) {
          applyCompactModeToCards(nextCompact, { track: true, origin: "toolbar-switch" });
          schedulePersistTopFiltersState();
        }
        syncV2ViewSwitch();
      });
    });
  }
  if (elDisplayMode){
    elDisplayMode.addEventListener("change", () => {
      markTopModeUserInteraction();
      setActiveModeSelection(`builtin:${elDisplayMode.value || "performance"}`);
      applyDisplayMode(elDisplayMode.value).catch((e) => console.error(e));
    });
  }
  if (inlineModeButtons.length){
    inlineModeButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        markTopModeUserInteraction();
        const mode = String(btn.getAttribute("data-tp-selectivity-mode") || "performance");
        setActiveModeSelection(`builtin:${mode}`);
        applyDisplayMode(mode).catch((e) => console.error(e));
      });
    });
  }

  if (modeMenuButton && modeMenuPanel){
    modeMenuButton.addEventListener("click", () => {
      setModeMenuOpen(!modeMenuOpen);
    });

    modeMenuPanel.addEventListener("click", (event) => {
      const button = event.target.closest(".tp-mode-option");
      if (!button) return;
      const selection = String(button.dataset.selection || "");
      if (!selection) return;

      markTopModeUserInteraction();
      setModeMenuOpen(false);
      if (isCustomProfileSelection(selection) && profilesApi){
        const profile = profilesApi.getProfile(selection.slice(8));
        if (!profile) return;
        applyProfileConfig(profile).catch((e) => console.error(e));
        return;
      }

      const mode = selection.replace(/^builtin:/, "") || "performance";
      setActiveModeSelection(`builtin:${mode}`);
      applyDisplayMode(mode).catch((e) => console.error(e));
    });

    document.addEventListener("click", (event) => {
      if (!modeMenuOpen) return;
      if (modeMenu && modeMenu.contains(event.target)) return;
      setModeMenuOpen(false);
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && modeMenuOpen) {
        setModeMenuOpen(false);
      }
    });
  }

  if (btnAdvancedToggle && elAdvanced){
    syncAdvancedToggleUI();
    btnAdvancedToggle.addEventListener("click", () => {
      elAdvanced.classList.toggle("collapsed");
      syncAdvancedToggleUI();
      schedulePersistTopFiltersState();
    });
  }
  if (btnResetAdvanced){
    btnResetAdvanced.addEventListener("click", resetAdvancedToSuggestions);
  }

  if (profilesApi){
    window.addEventListener("storage", (event) => {
      if (event.key !== profilesApi.storageKey && event.key !== profilesApi.activeKey) return;
      document.dispatchEvent(new Event(profilesApi.changeEvent || "fs-prediction-profiles-change"));
    });

    document.addEventListener(profilesApi.changeEvent || "fs-prediction-profiles-change", async () => {
      const selection = profilesApi.getActiveSelection();
      if (selection === activeModeSelection) {
        if (isCustomProfileSelection(selection)) {
          const profile = profilesApi.getProfile(selection.slice(8));
          if (profile && JSON.stringify(profile) !== appliedProfileSignature) {
            await applyProfileConfig(profile, { persist: false });
            return;
          }
        }
        renderModeMenu();
        return;
      }

      setActiveModeSelection(selection, { persist: false });
      renderModeMenu();

      if (isCustomProfileSelection(selection)) {
        const profile = profilesApi.getProfile(selection.slice(8));
        if (!profile) return;
        try {
          await applyProfileConfig(profile, { persist: false });
        } catch (err) {
          console.error(err);
        }
        return;
      }

      const builtinMode = selection.replace(/^builtin:/, "");
      if (builtinMode && builtinMode !== activeDisplayMode) {
        try {
          await applyDisplayMode(builtinMode);
        } catch (err) {
          console.error(err);
        }
      }
    });
  }

  applyCompactModeToCards(compactModeEnabled);

  window.FSTopPronosticsControls = {
    captureProfileConfig: captureCurrentProfileConfig,
    applyProfileConfig: applyProfileConfig,
    applyBuiltInMode: applyBuiltInMode,
    setThresholdValue: setBuilderThreshold,
    setMarketEnabled: setBuilderMarketEnabled,
    whenReady: () => controlsReadyPromise,
    getActiveDisplayMode: () => activeDisplayMode,
    getActiveSelection: () => activeModeSelection,
    getProfilePageHref: () => profilePageHref
  };

  // Boot — rendu asynchrone :
  // 1) paint shell/high-priority visible ad,
  // 2) fetch performance index + match window concurrently,
  // 3) render once with the final active selection.
  (async function init(){
    renderLeagueButtons();
    const bootGeneration = beginListingUpdate("boot");

    try {
      await yieldInitialPaint();

      const perfPromise = preloadPicksPerf();
      const dataPromise = ensureWindowDataLoaded();

      await Promise.allSettled([perfPromise, dataPromise]);
      sourcesReady = true;
      markTopPerf("core_data_ready", {
        performance: !!topPronosticsPerformanceIndex,
        matches: windowMatchesFullRaw?.length || 0
      });

      if (!windowMatchesFullRaw?.length) {
        throw new Error("match_window_empty");
      }

      syncCurrentWindowMatchesFromSelection();
      renderDatePills(selectedDate);

      initialModeRelaxationPending = true;
      await restoreActiveModeSelection();
      await applyInitialModeRelaxationIfNeeded();

      if (window.FSNewLeaguesPrompt) {
        // This prompt is secondary and must not block the first usable list.
        Promise.resolve().then(() => window.FSNewLeaguesPrompt.init({
          page: "top_pronostics_ia",
          profileHref: profilePageHref,
          hasPreviousVisit: hadTopPronosticsVisitBeforeBoot,
          getSelectedLeagues: selectedLeagues,
          isProfileActive: () => isCustomProfileSelection(),
          applySelectedLeagues: applyNewLeaguesPromptSelection,
        })).catch((err) => console.warn("FSNewLeaguesPrompt init failed", err));
      }

      renderModeMenu();
    } catch (err) {
      console.error("top pronostics init failed", err);
      if (elGrid && isListingGenerationCurrent(bootGeneration)) {
        const errorCard = document.createElement("div");
        errorCard.className = "bestbet-card";
        errorCard.textContent = t.error_loading;
        elGrid.replaceChildren(errorCard);
      }
    } finally {
      endListingUpdate(bootGeneration);
      if (resolveControlsReady) resolveControlsReady();
    }
  })();
});

// The compact filters remain bridged to the canonical listing controls.

// The primary filter/stat strip is a presentation layer; business logic is unchanged.

// Keep the dynamically injected page-tour CTA immediately above the date selector.
(function positionTopPronosticsTourCta(){
  const move = () => {
    const anchor = document.getElementById('tp-tour-cta-anchor');
    const row = document.querySelector('.fs-tour-cta-row');
    if (!anchor || !row || row.parentElement === anchor) return false;
    anchor.appendChild(row);
    return true;
  };

  const boot = () => {
    move();
    const root = document.querySelector('#tp-results .tp-container') || document.body;
    if (!root) return;
    const observer = new MutationObserver(() => move());
    observer.observe(root, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 15000);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
